var Ko = Object.defineProperty;
var Xo = (e, t, o) => t in e ? Ko(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var Re = (e, t, o) => Xo(e, typeof t != "symbol" ? t + "" : t, o);
import { jsx as n, Fragment as Y, jsxs as $ } from "react/jsx-runtime";
import * as Zo from "react";
import Ze, { createContext as ct, useContext as dt, useState as O, useCallback as W, useMemo as Q, useEffect as J, useRef as ye, Fragment as jt, memo as nn, useLayoutEffect as Qo, forwardRef as Cn, useImperativeHandle as qn, Component as Jo, createElement as zn } from "react";
import { chunk as _n, some as eo, toNumber as Bt, sortBy as qo, first as yn, isEmpty as en, has as er, last as tr, toString as nr, find as to, isNaN as or, debounce as Wn, throttle as rr } from "lodash";
import { FreeBannerUnit as ir, BandBannerUnit as In, HorizontalBannerUnit as ar, SquareBannerUnit as Ln, VerticalBannerUnit as sr, TimeBannerUnit as no, LineBannerUnit as lr, HorizontalityProductUnit as cr, VerticalProductUnit as dr, VStack as xe, HStack as je, Box as V, Text as Ht, pickColor as Jt, BottomSheet as oo, NewContentButton as xn, TextButton as ur, LineIndicator as Vt, TitleUnit as pr, CapsuleQuickLinkUnit as hr, SquareQuickLinkUnit as gr, CirecleQuickLinkUnit as fr, useVH as yr, FilterChip as mr, ImgChip as wr, IconButton as br, ThumbnailContentUnit as vr, CircleHorizontalityContentUnit as Cr, SquareHorizontalityContentUnit as _r, SquareVerticalContentUnit as Ir, VerticalContentUnit as Lr, Grid as xr, NumberIndicator as Rt } from "@design-system/mobile";
import { GetScrapsExistenceGateway as Nr, DeleteScrapGateway as Sr, CreateScrapGateway as Tr, GetScrapCategoriesGateway as kr, GetScrapsGateway as Dr, GetRemodelingComponentData as $r, GetRemodelingComponentList as Mr, GetRemodelingTemplateInfo as Er, GetRemodelingGnbList as Or, GetRemodelingDisplayInfo as Rr, GetPopupLists as Br, GetTemplateComponentsPreview as Ar, GetTemplateComponents as ro, GetTemplateComponentsPreviewData as Ur, GetTemplateComponentsData as io, GetTemplateInfiniteComponentsData as ao, GetScraps as so, PostScraps as lo, DeleteScraps as co, getCdnImage as Te, makeAppLink as et, makeAppLinkCate as Nn, getResizeImage as Pr, VIEW_TYPE_MAIN as Gr, VIEW_TYPE_MALL as Hr, VIEW_TYPE_REMODELING as zr, VIEW_TYPE_HOMEIDEA as Wr } from "@display-component/shared";
import Sn from "swr";
import tn from "query-string";
import uo from "swr/infinite";
import { Box as oe, VStack as le, HStack as Ve, Text as Ce, pickColor as we, SystemIcongraphy as Ot, FlagSquare as gt, BaseButton as po, Icongraphy as ho, ContentButton as jr, RoundButton as Vr } from "remodeling-web-mobile-sdk-ui";
import ce, { css as Be } from "styled-components";
import { AutoSizer as Lt, CellMeasurerCache as go, CellMeasurer as fo, InfiniteLoader as yo, WindowScroller as mo, List as wo, Grid as bo } from "react-virtualized";
import { addDays as Fr } from "date-fns";
import { v4 as Tn } from "uuid";
import { Swiper as Ft, SwiperSlide as Yt } from "swiper/react";
import { Autoplay as kn, EffectCreative as Yr } from "swiper";
const mn = ct({
  hosts: null,
  httpClient: null,
  tagGTM: null
}), te = () => {
  const e = dt(mn);
  if (e === void 0)
    throw new Error(
      "useDisplayComponent must be used within a DisplayComponentContext"
    );
  return e;
}, Dl = ({
  hosts: e,
  httpClient: t,
  tagGTM: o,
  children: r
}) => /* @__PURE__ */ n(mn.Provider, { value: { hosts: e, httpClient: t, tagGTM: o }, children: /* @__PURE__ */ n(mn.Consumer, { children: (a) => /* @__PURE__ */ n(Y, { children: r }) }) }), vo = ct({ indicatorPercent: 0, setIndicatorPercent: () => {
}, index: 0 }), ft = () => {
  const e = dt(vo);
  if (e === void 0)
    throw new Error(
      "useHorizontalPercent must be used within a HorizontalPercentContext"
    );
  return e;
}, Kr = ({
  children: e,
  index: t
}) => {
  const [o, r] = O(0);
  return /* @__PURE__ */ n(
    vo.Provider,
    {
      value: { indicatorPercent: o, setIndicatorPercent: r, index: t },
      children: e
    }
  );
}, Co = ct({ handleClickUnit: () => {
}, onHandleAction: () => {
} }), ut = () => {
  const e = dt(Co);
  if (e === void 0)
    throw new Error(
      "useDisplayActionProvider must be used within a DisplayActionProvider"
    );
  return e;
}, Xr = ({
  children: e,
  onHandleClick: t,
  onHandleAction: o
}) => {
  const r = W(
    (a, i, l) => {
      if (l) {
        t({
          goodsInfo: l,
          isNewWindow: !!a
        });
        return;
      }
      i && t({ applink: i, isNewWindow: !!a });
    },
    [t]
  );
  return /* @__PURE__ */ n(
    Co.Provider,
    {
      value: { handleClickUnit: r, onHandleAction: o },
      children: e
    }
  );
}, Zr = (e) => typeof e == "number" ? `${e}px` : e, Dn = (e) => String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ","), Qr = (e) => new Proxy(e, {
  set(t, o, r) {
    return r === void 0 ? delete t[o] : t[o] = r, !0;
  },
  get(t, o) {
    const r = t[o];
    return typeof r == "object" && r !== null ? Qr(r) : r;
  }
}), rt = (e) => {
  for (const t in e)
    e[t] === void 0 ? delete e[t] : typeof e[t] == "object" && e[t] !== null && rt(e[t]);
  return e;
}, Jr = (e, t) => {
  console.error(`${e.message} - ${t} - display`);
}, $l = (e) => {
  const t = {};
  return e && Object.keys(e).forEach((o) => {
    o in {} && (t[o] = e[o]);
  }), t;
}, zt = (e, t, o, r) => {
  const a = r.map((s, c) => ({
    ...s,
    gtmIndex: c + 1
  })), i = () => {
    const s = Array.from(
      { length: e },
      () => []
    );
    return a.forEach(
      (c, d) => s[d % e].push(c)
    ), s;
  }, l = () => _n(a, Math.ceil(t));
  return o === "vertical" ? l().slice(0, e) : i().slice(0, e);
}, _o = ct(null), on = () => {
  const e = dt(_o);
  if (!e)
    throw new Error(
      "useQuickLinkData must be used within a QuickLinkDataProvider"
    );
  return e;
}, qr = ({
  children: e,
  quickLinkItem: t
}) => {
  var p;
  const o = t.componentId, {
    horizontalType: r,
    verticalType: a,
    scroll: i,
    unit: l,
    paging: s,
    gtm: c
  } = t.attribute.body, d = s === "infinity", u = zt(
    a,
    r,
    i,
    (p = t.data) == null ? void 0 : p.content
  );
  return /* @__PURE__ */ n(
    _o.Provider,
    {
      value: {
        quickLinkItem: t,
        componentId: o,
        horizontalType: r,
        verticalType: a,
        scrollType: i,
        unitType: l,
        isInfinity: d,
        gtm: c,
        quickLinkData: u
      },
      children: e
    }
  );
}, Io = ct(null), rn = () => {
  const e = dt(Io);
  if (!e)
    throw new Error("useBannerData must be used within a BannerDataProvider");
  return e;
}, ei = ({
  children: e,
  bannerItem: t,
  index: o
}) => {
  const { tagGTM: r } = te(), { handleClickUnit: a } = ut(), { dataType: i, componentId: l } = t, {
    horizontalType: s,
    verticalType: c,
    scroll: d,
    display: u,
    unit: p,
    paging: h,
    gtm: g,
    unitElement: { isMainTitle: w, isSubTitle: f },
    titleType: C,
    titleOutBgColor: N,
    leftRightSpace: k,
    bannerLink: I,
    chipUnit: { chipUnitType: A, isChipLink: M }
  } = t.attribute.body, R = u === "chip" && i === "group", X = h === "infinity", U = I.isUse, S = t.data.content, [E, Z] = O(0), B = Q(() => o === 0 || o === 1, [o]), T = Q(() => {
    if (i === "default")
      return zt(
        c,
        s,
        d,
        t.data.content
      );
    if (i === "group") {
      const x = t.data.content.map((m) => m.data.content);
      return zt(
        c,
        s,
        d,
        x[E]
      );
    }
    return [[]];
  }, [
    t.data.content,
    i,
    s,
    d,
    E,
    c
  ]), ee = ({ item: x }) => {
    const m = Q(() => {
      var G, z, _;
      return r(g.taggtm, {
        ...g,
        index: x == null ? void 0 : x.gtmIndex,
        "plan-id": ((G = x == null ? void 0 : x.appLinkInfoDto) == null ? void 0 : G.appLinkTarget) === "PLAN" ? (z = x == null ? void 0 : x.appLinkInfoDto) == null ? void 0 : z.appLinkVal : void 0,
        "landing-url": (_ = x == null ? void 0 : x.appLinkInfoDto) == null ? void 0 : _.linkUrl
      });
    }, [x]), v = Q(() => {
      switch (p) {
        case "vertical":
          return sr;
        case "square":
          return Ln;
        case "horizontal":
          return ar;
        case "band":
          return In;
        default:
          return ir;
      }
    }, []);
    return /* @__PURE__ */ n(Y, { children: (() => {
      switch (p) {
        case "thin":
          return /* @__PURE__ */ n(
            lr,
            {
              img: x == null ? void 0 : x.imageUrl,
              title: x == null ? void 0 : x.bannerTitle1,
              subTitle: x == null ? void 0 : x.bannerSubTitle1,
              handleClick: () => U && a(x.isNewWindow, x.appLinkInfoDto),
              noLazyLoading: B,
              ...m
            }
          );
        case "timer":
          return /* @__PURE__ */ n(
            no,
            {
              date: new Date(x.timerEndDatetime),
              title: x.bannerTitle1,
              ...m
            }
          );
        default:
          return /* @__PURE__ */ n(
            v,
            {
              img: x == null ? void 0 : x.imageUrl,
              title1: w ? x == null ? void 0 : x.bannerTitle1 : "",
              title2: w ? x == null ? void 0 : x.bannerTitle2 : "",
              subTitle1: f ? x == null ? void 0 : x.bannerSubTitle1 : "",
              subTitle2: f ? x == null ? void 0 : x.bannerSubTitle2 : "",
              titleType: C,
              bgColor: `#${N}`,
              variant: s < 2 ? "case1" : "case2",
              zIndex: 1,
              opacity: x ? 1 : 0,
              handleClick: () => U && a(x.isNewWindow, x.appLinkInfoDto),
              noLazyLoading: B,
              isMainTitle: w,
              ...m
            }
          );
      }
    })() });
  };
  return /* @__PURE__ */ n(
    Io.Provider,
    {
      value: {
        horizontalType: s,
        verticalType: c,
        scrollType: d,
        displayType: u,
        dataType: i,
        unitType: p,
        item: t,
        bannerItem: t,
        bannerData: T,
        groupData: S,
        BannerUnit: ee,
        componentId: l,
        gtm: g,
        titleType: C,
        titleOutBgColor: N,
        isMainTitle: w,
        isSubTitle: f,
        isLeftRightSpace: k,
        isInfinity: X,
        chipUnitType: A,
        isChipLink: M,
        isChip: R,
        isLink: U,
        selectedChip: E,
        setSelectedChip: Z
      },
      children: e
    }
  );
}, ti = (e, t) => {
  if (e)
    return t || void 0;
}, ni = (e, t) => {
  if (e)
    return t || void 0;
}, Lo = (e) => e === "Z", oi = (e, t) => Lo(e) ? "견적 상담" : t ? Dn(t) : t === 0 ? "0" : "", ri = (e, t) => {
  if (!(!e || !t))
    return t;
}, ii = (e, t, o, r) => {
  if (!(!e || !o))
    return o !== r ? `${Dn(o)}${t}` : void 0;
}, xo = ct({ isLogin: !1 }), ai = () => {
  const e = dt(xo);
  if (e === void 0)
    throw new Error("useAuthProvider must be used within a AuthProvider");
  return e;
}, si = ({ children: e, isLogin: t }) => /* @__PURE__ */ n(xo.Provider, { value: { isLogin: t }, children: e }), No = ct({
  scrapItemList: [],
  setScrapItemList: () => {
  },
  toggleScrap: () => Promise.resolve(0),
  isScrapProduct: () => !1,
  handleClickBookMark: () => {
  }
}), li = () => {
  const e = dt(No);
  if (e === void 0)
    throw new Error("useScrapProvider must be used within a ScrapProvider");
  return e;
}, ci = ({
  children: e,
  scrapItemList: t,
  setScrapItemList: o,
  toggleScrap: r
}) => {
  const { onHandleAction: a } = ut(), { isLogin: i } = ai(), l = W(
    (c, d) => (t == null ? void 0 : t.find(
      (p) => p.targetNo === c && p.scrapGbnCd === d
    )) !== void 0,
    [t]
  ), s = W(
    async (c, d) => {
      if (!i) {
        a({
          type: "confirm",
          action: "login",
          message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
        });
        return;
      }
      const u = l(c, d);
      if (await r({
        scrapGbnCd: d,
        targetNo: c,
        targetSubNo: 0,
        isUse: !u
      }) === 200)
        if (u) {
          const h = t.filter(
            (g) => g.targetNo !== c || g.scrapGbnCd !== d
          );
          o(h);
        } else
          a({
            type: "toast",
            action: "scrap",
            message: "스크랩이 완료되었습니다."
          }), o([
            ...t,
            { targetNo: c, targetSubNo: 0, scrapGbnCd: d }
          ]);
    },
    [
      i,
      l,
      a,
      t,
      o,
      r
    ]
  );
  return /* @__PURE__ */ n(
    No.Provider,
    {
      value: {
        scrapItemList: t,
        setScrapItemList: o,
        toggleScrap: r,
        isScrapProduct: l,
        handleClickBookMark: s
      },
      children: e
    }
  );
}, So = ct(null), an = () => {
  const e = dt(So);
  if (!e)
    throw new Error("useProductData must be used within a ProductDataProvider");
  return e;
}, di = ({
  children: e,
  productItem: t,
  index: o
}) => {
  const { tagGTM: r } = te(), { handleClickUnit: a } = ut(), { isScrapProduct: i, handleClickBookMark: l } = li(), { dataType: s, componentId: c } = t, d = t.data.content, {
    horizontalType: u,
    verticalType: p,
    scroll: h,
    groupScroll: g,
    groupUnit: { groupUnitType: w },
    display: f,
    unit: C,
    paging: N,
    gtm: k,
    unitElement: {
      isReviewRating: I,
      isNormalPrice: A,
      isDiscountRate: M,
      isBrand: R,
      isAdvertiseFlag: X,
      isRankingNumber: U,
      isScrap: S,
      isFlag: E,
      isPrice: Z
    },
    chipUnit: { chipUnitType: B, isChipLink: T }
  } = t.attribute.body, ee = f === "chip" && s === "group", x = N === "infinity", [m, v] = O(0), G = Q(() => o === 0 || o === 1, [o]), z = Q(() => {
    if (f === "gallery")
      return zt(
        p,
        u,
        h,
        t.data.content
      );
    if (f === "group" || f === "chip") {
      const y = t.data.content.map((b) => b.data.content);
      return zt(
        p,
        u,
        h,
        y[m]
      );
    }
    return [[]];
  }, [
    f,
    u,
    t.data.content,
    h,
    m,
    p
  ]), _ = ({
    item: y,
    index: b
  }) => {
    var se, ie, ke, tt;
    const j = r(k.taggtm, {
      ...k,
      index: (y == null ? void 0 : y.gtmIndex) ?? (b ?? 0) + 1,
      "good-id": (y == null ? void 0 : y.goodsMallType) !== "PLAN" ? y == null ? void 0 : y.gdsNo : void 0,
      "landing-url": (se = y == null ? void 0 : y.appLinkInfoDto) == null ? void 0 : se.linkUrl,
      "plan-id": (y == null ? void 0 : y.goodsMallType) === "PLAN" ? y == null ? void 0 : y.gdsNo : void 0
    }), de = Q(() => {
      switch (C) {
        case "normal":
          return dr;
        default:
          return cr;
      }
    }, []);
    return /* @__PURE__ */ n(
      de,
      {
        img: y == null ? void 0 : y.imageUrl,
        brandName: R ? (ie = y == null ? void 0 : y.goodsBrandInfoDto) == null ? void 0 : ie.brandNm : void 0,
        isShowADFlag: X,
        productTitle: y == null ? void 0 : y.gdsNm,
        originalPrice: ii(
          A,
          y == null ? void 0 : y.prcViewTypNm,
          y == null ? void 0 : y.normalSalePrc,
          y == null ? void 0 : y.dcPrc
        ),
        discountRate: ri(M, y == null ? void 0 : y.dcRate),
        finalPrice: oi(y == null ? void 0 : y.prcViewTypCd, y == null ? void 0 : y.dcPrc),
        finalPricePerUnit: Lo(y == null ? void 0 : y.prcViewTypCd) ? "" : y == null ? void 0 : y.prcViewTypNm,
        reviewScore: ti(
          I,
          (ke = y == null ? void 0 : y.goodsEvaluationStatInfoDto) == null ? void 0 : ke.totAvgScore
        ),
        reviewCount: ni(
          I,
          (tt = y == null ? void 0 : y.goodsEvaluationStatInfoDto) == null ? void 0 : tt.totCnt
        ),
        ranking: U ? (y == null ? void 0 : y.gtmIndex) || (b ?? 0) + 1 : void 0,
        superFlag: y == null ? void 0 : y.badgeImageUrl,
        isShowBookmark: y != null && y.scrapGbnCode ? S : !1,
        isCheckedBookmark: i(y == null ? void 0 : y.gdsNo, y == null ? void 0 : y.scrapGbnCode),
        flag: E ? y == null ? void 0 : y.goodsTagInfoDtoList : void 0,
        handleClickBookmark: () => l(y == null ? void 0 : y.gdsNo, y == null ? void 0 : y.scrapGbnCode),
        isShowRestockAlert: (y == null ? void 0 : y.gdsStatCd) === "SD" && (y == null ? void 0 : y.isNotiOfStock),
        isShowSoldOut: (y == null ? void 0 : y.gdsStatCd) === "SD",
        handleClick: () => a(
          y == null ? void 0 : y.isNewWindow,
          y == null ? void 0 : y.appLinkInfoDto,
          (y == null ? void 0 : y.goodsMallType) !== "PLAN" ? {
            isRestock: (y == null ? void 0 : y.gdsStatCd) === "SD" && y.isNotiOfStock,
            gdsNo: y.gdsNo
          } : void 0
        ),
        noLazyLoading: G,
        isShowPriceInfo: Z,
        ...j
      }
    );
  }, q = ({
    item: y,
    index: b
  }) => {
    var se;
    const j = Q(() => {
      var ie;
      return r(k.taggtm, {
        ...k,
        index: b + 1,
        "landing-url": (ie = y.appLinkInfoDto) == null ? void 0 : ie.linkUrl,
        "plan-id": y.componentGroupDataType === "PLAN" ? y.sourceId : void 0,
        "content-id": y.componentGroupDataType === "HOMEIDEA" ? y.sourceId : void 0
      });
    }, [
      b,
      (se = y.appLinkInfoDto) == null ? void 0 : se.linkUrl,
      y.componentGroupDataType,
      y.sourceId
    ]), de = Q(() => {
      switch (w) {
        case "BAND_BANNER":
          return In;
        case "BANNER":
          return Ln;
        default:
          return no;
      }
    }, []);
    return /* @__PURE__ */ n(
      de,
      {
        variant: "case1",
        img: y.imageUrl,
        title1: y.groupTitle1,
        title2: y.groupTitle2,
        subTitle1: y.groupSubTitle1,
        subTitle2: y.groupSubTitle2,
        date: new Date(y.timerEndDatetime),
        title: y.groupTitle1,
        zIndex: 1,
        handleClick: () => a(y == null ? void 0 : y.isNewWindow, y.appLinkInfoDto),
        noLazyLoading: G,
        ...j
      }
    );
  };
  return /* @__PURE__ */ n(
    So.Provider,
    {
      value: {
        horizontalType: u,
        verticalType: p,
        scrollType: h,
        displayType: f,
        dataType: s,
        unitType: C,
        bannerType: w,
        groupScroll: g,
        productItem: t,
        goodsData: z,
        bannerData: d,
        ProductUnit: _,
        GroupBannerUnit: q,
        componentId: c,
        gtm: k,
        isInfinity: x,
        chipUnitType: B,
        isChipLink: T,
        isChip: ee,
        selectedChip: m,
        setSelectedChip: v
      },
      children: e
    }
  );
}, Ml = (e, t) => ({
  getScraps: new Dr(e, t),
  getScrapCategories: new kr(e, t),
  createScraps: new Tr(e, t),
  deleteScraps: new Sr(e, t),
  isScraps: new Nr(e, t)
}), To = (e, t) => ({
  getRemodelingComponentList: new Mr(
    e,
    t
  ),
  getRemodelingComponentData: new $r(
    e,
    t
  )
}), $n = (e, t) => ({
  getRemodelingDisplayInfo: new Rr(e, t),
  getRemodelingGnbList: new Or(e, t),
  getRemodelingTemplateInfo: new Er(e, t),
  getTemplateComponents: new ui(
    e,
    t
  )
});
class ui {
  constructor(t, o) {
  }
  async exec(t) {
  }
}
const It = (e, t) => ({
  getTemplateComponents: new pi(
    e,
    t
  ),
  getTemplateInfiniteComponentsData: new hi(e, t),
  getScraps: new gi(e, t),
  requestScraps: new fi(e, t),
  getPopupList: new Br(e, t)
}), Pe = (e) => e.map((o) => ({
  content: o.name,
  variant: o.style.toLocaleLowerCase(),
  color: o.styleColor.toLocaleLowerCase(),
  textColor: o.textColor
}));
class pi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    const o = document.cookie;
    let r = t;
    if (t.isPreview) {
      if (r = t, !r.templateId || !r.componentIdList)
        return { code: 10500, message: "error" };
    } else if (r = t, r != null && r.rdId && (r.pageIdentificationValue = "RD_M", r.detailCode = r.rdId, r.rdId = void 0), !r.pageIdentificationValue)
      return { code: 10500, message: "error" };
    return await Promise.all([
      t.isPreview ? new Ar(this.host, this.httpClient).exec(
        r
      ) : new ro(this.host, this.httpClient).exec(
        r,
        o
      ),
      t.isPreview ? new Ur(this.host, this.httpClient).exec(
        r
      ) : new io(this.host, this.httpClient).exec(
        r,
        o
      )
    ]).then((i) => {
      var h, g, w, f, C, N, k, I, A, M, R, X, U;
      const [l, s] = i, c = s != null && s.data ? [...s == null ? void 0 : s.data] : [], d = ((h = l == null ? void 0 : l.data) == null ? void 0 : h.displayComponentList) || [], u = [];
      e: for (let S = 0; S < d.length; S++) {
        const E = d[S].componentId;
        if (!eo(c, { componentId: E }))
          continue;
        const B = d[S].componentType, T = {
          ...d[S]
        };
        let ee = "quicklinkResponse", x = "퀵링크 속성";
        switch (B) {
          case "BANNER":
            ee = "bannerResponse", x = "배너 속성";
            break;
          case "CONTENTS":
            ee = "contentsResponse", x = "콘텐츠 속성";
            break;
          case "GOODS":
            ee = "goodsResponse", x = "굿즈 속성";
            break;
        }
        const m = d[S].componentAttributeInfo, v = m[ee];
        if (v.header.title && (v.header.title.data1 = v.header.title.data1 ?? "", v.header.title.data2 = v.header.title.data2 ?? ""), v.header.subTitle && (v.header.subTitle.data1 = v.header.subTitle.data1 ?? "", v.header.subTitle.data2 = v.header.subTitle.data2 ?? ""), v.header.tooltip) {
          v.header.tooltip.title = v.header.tooltip.title ?? "", v.header.tooltip.desc = v.header.tooltip.desc ?? "";
          let _ = v.header.tooltip.iconType || "";
          switch (_) {
            case "INFORMATION":
            case "NOTICE":
              _ = "ic_information";
              break;
            case "QUESTION":
              _ = "ic_question";
              break;
          }
          v.header.tooltip.iconType = _;
        }
        if (v.header.moreView && v.header.moreView.isUse && (v.header.moreView.buttonName = v.header.moreView.buttonName || "더보기"), t.isPreview)
          Object.assign(v.header, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_header`,
              "template-id": (w = l.data) == null ? void 0 : w.templateId,
              "component-id": E
            })
          });
        else {
          const _ = t;
          Object.assign(v.header, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_header`,
              "template-id": (g = l.data) == null ? void 0 : g.templateId,
              "component-id": E,
              "page-id-value": _.pageIdentificationValue,
              "category-id": (_ == null ? void 0 : _.categoryNo) || void 0
            })
          });
        }
        const G = (v.body.display.displayType || "").toLowerCase();
        if (v.body.display) {
          const _ = (v.body.display.displayType || "GALLERY").toLowerCase();
          Object.assign(v.body, { display: _ });
        }
        if (v.body.paging) {
          const _ = v.body.paging.pagingType === "INFINITY" ? "infinity" : "default";
          Object.assign(v.body, {
            paging: _,
            isInfinity: _ === "infinity"
          });
        }
        if (v.body.viewForm) {
          if (v.body.viewForm.horizontalType) {
            const _ = Bt(
              v.body.viewForm.horizontalType.replace("HORIZONTAL_", "").replace("_", ".")
            );
            Object.assign(v.body, { horizontalType: _ });
          }
          if (v.body.viewForm.verticalType) {
            const _ = Bt(
              v.body.viewForm.verticalType.split("VERTICAL_")[1]
            );
            Object.assign(v.body, { verticalType: _ });
          }
        }
        if (v.body.scroll) {
          const _ = v.body.scroll.scrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(v.body, { scroll: _ });
        }
        if (v.body.unit) {
          let _ = v.body.unit.unitType;
          switch (B) {
            case "QUICKLINK":
              switch (v.body.unit.unitType) {
                case "ICON_CIRCLE":
                  _ = "circle";
                  break;
                case "ICON_SQUARE":
                  _ = "square";
                  break;
                case "CAPSULE":
                  _ = "capsule";
                  break;
              }
              break;
            case "BANNER":
              _ = (v.body.unit.unitType || "vertical").replace("_BANNER", "").toLocaleLowerCase();
              break;
            case "CONTENTS":
              _ = (v.body.unit.unitType || "normal").toLocaleLowerCase();
              break;
            case "GOODS":
              _ = (v.body.unit.unitType || "").toLocaleLowerCase();
              break;
          }
          Object.assign(v.body, { unit: _ });
        }
        if (v.body.chipUnit && Object.assign(v.body, {
          chipUnit: {
            ...v.body.chipUnit,
            chipUnitType: v.body.chipUnit.chipUnitType === "TEXT" ? "filter" : "image"
          }
        }), (f = v.body) != null && f.thumbnail) {
          const _ = v.body.thumbnail.ratio.split("_");
          Object.assign(v.body, {
            thumbnail: _[0].toLowerCase()
          });
        }
        if (v.body.leftRightSpace && Object.assign(v.body, {
          leftRightSpace: v.body.leftRightSpace.isLeftRightSpace
        }), v.body.groupScroll) {
          const _ = v.body.groupScroll.groupScrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(v.body, { groupScroll: _ });
        }
        if ((C = v.body) != null && C.textLocation) {
          const _ = ((N = v.body) == null ? void 0 : N.textLocation.textLocationType) === "BANNER_INNER" ? "in" : "out";
          Object.assign(v.body, {
            titleType: _,
            titleOutBgColor: (k = v.body) == null ? void 0 : k.textLocation.textBackGroundColor
          });
        }
        if (t.isPreview)
          Object.assign(v.body, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_body`,
              "template-id": (A = l.data) == null ? void 0 : A.templateId,
              "component-id": E
            })
          });
        else {
          const _ = t;
          Object.assign(v.body, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_body`,
              "template-id": (I = l.data) == null ? void 0 : I.templateId,
              "component-id": E,
              "page-id-value": _.pageIdentificationValue,
              "category-id": (_ == null ? void 0 : _.categoryNo) || void 0
            })
          });
        }
        if (!t.isPreview && (r != null && r.detailCode)) {
          let _ = "R";
          if (v.body.dataRegistration.homeIdeaSortType)
            switch (v.body.dataRegistration.homeIdeaSortType) {
              case "LATEST":
                _ = "R";
                break;
              case "ALLTIME":
                _ = "F";
                break;
              case "RECENT":
                _ = "N";
                break;
            }
          v.header.moreView.appLinkInfoDto.linkUrl = `${(M = v.header.moreView.appLinkInfoDto.linkUrl) == null ? void 0 : M.replace(
            "{id}",
            r == null ? void 0 : r.detailCode
          )}?sort=${_}`;
        }
        let z = "groupDataList";
        if (G === "gallery")
          switch (B) {
            case "QUICKLINK":
              z = "quicklinkDataList";
              break;
            case "BANNER":
              z = "bannerDataList";
              break;
            case "CONTENTS":
              z = "contentsDataList";
              break;
            case "GOODS":
              z = "goodsDataList";
              break;
          }
        if (v.footer.landing && v.footer.landing.isUse && (v.footer.landing.buttonName = v.footer.landing.buttonName || "더보기"), t.isPreview)
          Object.assign(v.footer, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_footer`,
              "template-id": (X = l.data) == null ? void 0 : X.templateId,
              "component-id": E
            })
          });
        else {
          const _ = t;
          Object.assign(v.footer, {
            gtm: rt({
              taggtm: `display_${B.toLocaleLowerCase()}_footer`,
              "template-id": (R = l.data) == null ? void 0 : R.templateId,
              "component-id": E,
              "page-id-value": _.pageIdentificationValue,
              "category-id": (_ == null ? void 0 : _.categoryNo) || void 0
            })
          });
        }
        Object.assign(T, {
          dataType: z === "groupDataList" ? "group" : "default"
        }), Object.assign(v, { attributeResponse: x }), Object.assign(T, { attribute: v }), delete m.quicklinkResponse, delete m.bannerResponse, delete m.contentsResponse, delete m.goodsResponse;
        for (let _ = 0; _ < c.length; _++)
          if (c[_].componentId === E) {
            if (z === "goodsDataList") {
              if (c[_].goodsDataList.content)
                for (let q = 0; q < c[_].goodsDataList.content.length; q++) {
                  const y = c[_].goodsDataList.content[q];
                  if (y.goodsTagInfoDtoList && y.goodsTagInfoDtoList.length > 0) {
                    const b = Pe(
                      y.goodsTagInfoDtoList
                    );
                    Object.assign(y, { goodsTagInfoDtoList: b });
                  }
                }
            } else if (z === "contentsDataList" && c[_].contentsDataList.content)
              for (let q = 0; q < c[_].contentsDataList.content.length; q++) {
                const y = c[_].contentsDataList.content[q];
                if (y.tagInfoDto && y.tagInfoDto.length > 0) {
                  const b = Pe(
                    y.tagInfoDto
                  );
                  Object.assign(y, { goodsTagInfoDtoList: b });
                }
                if (y.imageInfo.tagInfo && y.imageInfo.tagInfo.length > 0) {
                  const b = Pe(y.imageInfo.tagInfo);
                  Object.assign(y.imageInfo, {
                    tagInfo: b
                  });
                }
              }
            if (G === "gallery") {
              if (!(((U = c[_][z]) == null ? void 0 : U.content) || []).length)
                continue e;
              Object.assign(T, {
                data: c[_][z] ?? {
                  content: []
                }
              });
            } else {
              if (!(c[_][z] || []).length)
                continue e;
              Object.assign(T, {
                data: {
                  content: c[_][z] ?? []
                }
              });
            }
            if (z === "groupDataList" && c[_][z])
              for (let q = 0; q < c[_][z].length; q++) {
                const y = c[_].groupUnitType || "", b = c[_][z][q];
                let j, de, se = "";
                if (B === "BANNER" && G === "group" && y === "COORDINATE" ? (j = b.goodsListResponse, se = "goods", de = "나는 배너 리스펀스에서 나왔지롱") : B === "BANNER" ? (j = b.bannerListResponse, se = "banner", de = "나는 배너 리스펀스에서 나왔지롱") : B === "CONTENTS" ? (j = b.contentsListResponse, se = "contents", de = "나는 콘텐츠 리스펀스에서 나왔지롱") : B === "GOODS" && (se = "goods", j = b.goodsListResponse, de = "나는 굿즈 리스펀스에서 나왔지롱"), j && (j != null && j.content) && (j == null ? void 0 : j.content.length) > 0 && (se === "goods" || se === "contents"))
                  for (let ie = 0; ie < j.content.length; ie++) {
                    const ke = j.content[ie];
                    if (se === "goods") {
                      if (ke.goodsTagInfoDtoList && ke.goodsTagInfoDtoList.length > 0) {
                        const tt = Pe(
                          ke.goodsTagInfoDtoList
                        );
                        Object.assign(ke, { goodsTagInfoDtoList: tt });
                      }
                    } else if (se === "contents") {
                      if (ke.tagInfoDto && ke.tagInfoDto.length > 0) {
                        const tt = Pe(
                          ke.tagInfoDto
                        );
                        Object.assign(ke, { goodsTagInfoDtoList: tt });
                      }
                      if (ke.imageInfo.tagInfo && ke.imageInfo.tagInfo.length > 0) {
                        const tt = Pe(
                          ke.imageInfo.tagInfo
                        );
                        Object.assign(ke.imageInfo, {
                          tagInfo: tt
                        });
                      }
                    }
                  }
                delete b.bannerListResponse, delete b.contentsListResponse, delete b.goodsListResponse, j && (j != null && j.content) && (j.content = j.content.map((ie) => (!(ie != null && ie.appLinkTarget) && (ie != null && ie.linkUrl) && Object.assign(ie, {
                  appLinkTarget: "URL",
                  linkUrl: ie.linkUrl
                }), ie))), Object.assign(b, {
                  data: j && (j != null && j.content) ? j : { ...j, content: [] },
                  TEST_RESPONSE: de
                });
              }
            c.splice(_, 1);
          }
        u.push(T);
      }
      return i.filter((S) => S.code === 200).length < 2 ? { code: 10500, message: "error" } : { ...i[0], data: u };
    });
  }
}
class hi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    const o = document.cookie, r = await new ao(
      this.host,
      this.httpClient
    ).exec(t, o);
    if (r.code === 200) {
      let a;
      r.data && (a = r.data.map(
        (i) => {
          let l = "";
          switch (i.componentType) {
            case "QUICKLINK":
              l = "quicklinkDataList";
              break;
            case "BANNER":
              l = "bannerDataList";
              break;
            case "CONTENTS":
              l = "contentsDataList";
              break;
            case "GOODS":
              l = "goodsDataList";
              break;
          }
          const s = (i.displayType || "").toLowerCase(), c = i[l];
          Object.assign(i, {
            display: s
          });
          for (let d = 0; d < c.content.length; d++) {
            const u = c.content[d];
            if (l === "goodsDataList") {
              if (u.goodsTagInfoDtoList && u.goodsTagInfoDtoList.length > 0) {
                const p = Pe(
                  u.goodsTagInfoDtoList
                );
                Object.assign(u, { goodsTagInfoDtoList: p });
              }
            } else if (l === "contentsDataList") {
              if (u.tagInfoDto && u.tagInfoDto.length > 0) {
                const p = Pe(
                  c.tagInfoDto
                );
                Object.assign(u, { goodsTagInfoDtoList: p });
              }
              if (u.imageInfo.tagInfo && u.imageInfo.tagInfo.length > 0) {
                const p = Pe(u.imageInfo.tagInfo);
                Object.assign(u.imageInfo, {
                  tagInfo: p
                });
              }
            }
          }
          return delete i.displayType, delete i.quicklinkDataList, delete i.bannerDataList, delete i.contentsDataList, delete i.goodsDataList, Object.assign(i, { ...c });
        }
      )), Object.assign(r, {
        data: a
      });
    }
    return r;
  }
}
class gi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    const o = await new so(this.host, this.httpClient).exec();
    if (t && o.code === 200 && o.data) {
      const r = o.data.reduce((a, i) => {
        const l = `${i.scrapGbnCd}_${i.targetNo}${i.targetSubNo ? `_${i.targetSubNo}` : ""}`;
        return a[l] = !0, a;
      }, {});
      return { response: o, data: r };
    }
    return o;
  }
}
class fi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    return t.isUse ? await new lo(this.host, this.httpClient).exec({
      scrapGbnCd: t.scrapGbnCd,
      targetNo: t.targetNo,
      targetSubNo: t.targetSubNo
    }) : await new co(this.host, this.httpClient).exec({
      scrapGbnCd: t.scrapGbnCd,
      targetNo: t.targetNo,
      targetSubNo: t.targetSubNo
    });
  }
}
const El = (e, t) => ({
  getTemplateComponents: new yi(
    e,
    t
  ),
  getTemplateInfiniteComponentsData: new mi(e, t),
  getScraps: new wi(e, t),
  requestScraps: new bi(e, t)
});
class yi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t, o) {
    return t != null && t.rdId && (t.pageIdentificationValue = "RD_M", t.detailCode = t.rdId, t.rdId = void 0), await Promise.all([
      new ro(this.host, this.httpClient).exec(t, o),
      new io(this.host, this.httpClient).exec(
        t,
        o
      )
    ]).then((a) => {
      var p, h, g, w, f, C, N, k, I, A;
      const [i, l] = a, s = l != null && l.data ? [...l == null ? void 0 : l.data] : [], c = ((p = i == null ? void 0 : i.data) == null ? void 0 : p.displayComponentList) || [], d = [];
      e: for (let M = 0; M < c.length; M++) {
        const R = c[M].componentId;
        if (!eo(s, { componentId: R }))
          continue;
        const U = c[M].componentType, S = { ...c[M] };
        let E = "quicklinkResponse", Z = "퀵링크 속성";
        switch (U) {
          case "BANNER":
            E = "bannerResponse", Z = "배너 속성";
            break;
          case "CONTENTS":
            E = "contentsResponse", Z = "콘텐츠 속성";
            break;
          case "GOODS":
            E = "goodsResponse", Z = "굿즈 속성";
            break;
        }
        const B = c[M].componentAttributeInfo, T = B[E];
        if (T.header.title && (T.header.title.data1 = T.header.title.data1 ?? "", T.header.title.data2 = T.header.title.data2 ?? ""), T.header.subTitle && (T.header.subTitle.data1 = T.header.subTitle.data1 ?? "", T.header.subTitle.data2 = T.header.subTitle.data2 ?? ""), T.header.tooltip) {
          T.header.tooltip.title = T.header.tooltip.title ?? "", T.header.tooltip.desc = T.header.tooltip.desc ?? "";
          let m = T.header.tooltip.iconType || "";
          switch (m) {
            case "INFORMATION":
            case "NOTICE":
              m = "ic_information";
              break;
            case "QUESTION":
              m = "ic_question";
              break;
          }
          T.header.tooltip.iconType = m;
        }
        T.header.moreView && T.header.moreView.isUse && (T.header.moreView.buttonName = T.header.moreView.buttonName || "더보기"), Object.assign(T.header, {
          gtm: rt({
            tagGTM: `display_${U.toLocaleLowerCase()}_header`,
            taggtm: `display_${U.toLocaleLowerCase()}_header`,
            "template-id": (h = i.data) == null ? void 0 : h.templateId,
            "component-id": R,
            "page-id-value": t.pageIdentificationValue,
            "category-id": (t == null ? void 0 : t.categoryNo) || void 0
          })
        });
        const ee = (T.body.display.displayType || "").toLowerCase();
        if (T.body.display) {
          const m = (T.body.display.displayType || "GALLERY").toLowerCase();
          Object.assign(T.body, { display: m });
        }
        if (T.body.paging) {
          const m = T.body.paging.pagingType === "INFINITY" ? "infinity" : "default";
          Object.assign(T.body, {
            paging: m,
            isInfinity: m === "infinity"
          });
        }
        if (T.body.viewForm) {
          if (T.body.viewForm.horizontalType) {
            const m = Bt(
              T.body.viewForm.horizontalType.replace("HORIZONTAL_", "").replace("_", ".")
            );
            Object.assign(T.body, { horizontalType: m });
          }
          if (T.body.viewForm.verticalType) {
            const m = Bt(
              T.body.viewForm.verticalType.split("VERTICAL_")[1]
            );
            Object.assign(T.body, { verticalType: m });
          }
        }
        if (T.body.scroll) {
          const m = T.body.scroll.scrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(T.body, { scroll: m });
        }
        if (T.body.unit) {
          let m = T.body.unit.unitType;
          switch (U) {
            case "QUICKLINK":
              switch (T.body.unit.unitType) {
                case "ICON_CIRCLE":
                  m = "circle";
                  break;
                case "ICON_SQUARE":
                  m = "square";
                  break;
                case "CAPSULE":
                  m = "capsule";
                  break;
              }
              break;
            case "BANNER":
              m = (T.body.unit.unitType || "vertical").replace("_BANNER", "").toLocaleLowerCase();
              break;
            case "CONTENTS":
              m = (T.body.unit.unitType || "normal").toLocaleLowerCase();
              break;
            case "GOODS":
              m = (T.body.unit.unitType || "").toLocaleLowerCase();
              break;
          }
          Object.assign(T.body, { unit: m });
        }
        if (T.body.chipUnit && Object.assign(T.body, {
          chipUnit: {
            ...T.body.chipUnit,
            chipUnitType: T.body.chipUnit.chipUnitType === "TEXT" ? "filter" : "image"
          }
        }), T.body.leftRightSpace && Object.assign(T.body, {
          leftRightSpace: T.body.leftRightSpace.isLeftRightSpace
        }), T.body.groupScroll) {
          const m = T.body.groupScroll.groupScrollType === "UP_DOWN" ? "vertical" : "horizontal";
          Object.assign(T.body, { groupScroll: m });
        }
        if ((g = T.body) != null && g.textLocation) {
          const m = ((w = T.body) == null ? void 0 : w.textLocation.textLocationType) === "BANNER_INNER" ? "in" : "out";
          Object.assign(T.body, {
            titleType: m,
            titleOutBgColor: (f = T.body) == null ? void 0 : f.textLocation.textBackGroundColor
          });
        }
        if (t != null && t.detailCode) {
          let m = "R";
          if (T.body.dataRegistration.homeIdeaSortType)
            switch (T.body.dataRegistration.homeIdeaSortType) {
              case "LATEST":
                m = "R";
                break;
              case "ALLTIME":
                m = "F";
                break;
              case "RECENT":
                m = "N";
                break;
            }
          T.header.moreView.appLinkInfoDto.linkUrl = `${(C = T.header.moreView.appLinkInfoDto.linkUrl) == null ? void 0 : C.replace(
            "{id}",
            t == null ? void 0 : t.detailCode
          )}?sort=${m}`;
        }
        Object.assign(T.body, {
          gtm: rt({
            tagGTM: `display_${U.toLocaleLowerCase()}_body`,
            taggtm: `display_${U.toLocaleLowerCase()}_body`,
            "template-id": (N = i.data) == null ? void 0 : N.templateId,
            "component-id": R,
            "page-id-value": t.pageIdentificationValue,
            "category-id": (t == null ? void 0 : t.categoryNo) || void 0
          })
        });
        let x = "groupDataList";
        if (ee === "gallery")
          switch (U) {
            case "QUICKLINK":
              x = "quicklinkDataList";
              break;
            case "BANNER":
              x = "bannerDataList";
              break;
            case "CONTENTS":
              x = "contentsDataList";
              break;
            case "GOODS":
              x = "goodsDataList";
              break;
          }
        T.footer.landing && T.footer.landing.isUse && (T.footer.landing.buttonName = T.footer.landing.buttonName || "더보기"), Object.assign(T.footer, {
          gtm: rt({
            tagGTM: `display_${U.toLocaleLowerCase()}_footer`,
            taggtm: `display_${U.toLocaleLowerCase()}_footer`,
            "template-id": (k = i.data) == null ? void 0 : k.templateId,
            "component-id": R,
            "page-id-value": t.pageIdentificationValue,
            "category-id": (t == null ? void 0 : t.categoryNo) || void 0
          })
        }), Object.assign(S, {
          dataType: x === "groupDataList" ? "group" : "default"
        }), Object.assign(T, { attributeResponse: Z }), Object.assign(S, { attribute: T }), delete B.quicklinkResponse, delete B.bannerResponse, delete B.contentsResponse, delete B.goodsResponse;
        for (let m = 0; m < s.length; m++)
          if (s[m].componentId === R) {
            if (x === "contentsDataList" && s[m].contentsDataList.content)
              for (let v = 0; v < s[m].contentsDataList.content.length; v++) {
                const G = s[m].contentsDataList.content[v];
                if (G.tagInfoDto && G.tagInfoDto.length > 0) {
                  const z = Pe(
                    G.tagInfoDto
                  );
                  Object.assign(G, { goodsTagInfoDtoList: z });
                }
                if (G.imageInfo.tagInfo && G.imageInfo.tagInfo.length > 0) {
                  const z = Pe(G.imageInfo.tagInfo);
                  Object.assign(G.imageInfo, {
                    tagInfo: z
                  });
                }
              }
            if (x === "goodsDataList" && s[m].goodsDataList.content)
              for (let v = 0; v < s[m].goodsDataList.content.length; v++) {
                const G = s[m].goodsDataList.content[v];
                if (G.goodsTagInfoDtoList && G.goodsTagInfoDtoList.length > 0) {
                  const z = G.goodsTagInfoDtoList.map(
                    (_) => ({
                      content: _.name,
                      variant: _.style.toLowerCase(),
                      color: _.styleColor,
                      textColor: _.textColor
                    })
                  );
                  Object.assign(G, { goodsTagInfoDtoList: z });
                }
              }
            if (ee === "gallery") {
              if (!(((I = s[m][x]) == null ? void 0 : I.content) || []).length)
                continue e;
              Object.assign(S, {
                data: s[m][x] ?? {
                  content: []
                }
              });
            } else {
              if (!(s[m][x] || []).length)
                continue e;
              Object.assign(S, {
                data: {
                  content: s[m][x] ?? []
                }
              });
            }
            if (x === "groupDataList" && s[m][x])
              for (let v = 0; v < s[m][x].length; v++) {
                const G = s[m].groupUnitType || "", z = s[m][x][v];
                let _, q, y = !1;
                if (U === "BANNER" && ee === "group" && G === "COORDINATE" ? (_ = z.goodsListResponse, y = !0, q = "나는 배너 리스펀스에서 나왔지롱") : U === "BANNER" ? (_ = z.bannerListResponse, q = "나는 배너 리스펀스에서 나왔지롱") : U === "CONTENTS" ? (_ = z.contentsListResponse, q = "나는 콘텐츠 리스펀스에서 나왔지롱") : U === "GOODS" && (y = !0, _ = z.goodsListResponse, q = "나는 굿즈 리스펀스에서 나왔지롱"), _ && (_ != null && _.content) && y)
                  for (let b = 0; b < _.content.length; b++) {
                    const j = _.content[b];
                    if (j.goodsTagInfoDtoList && j.goodsTagInfoDtoList.length > 0) {
                      const de = j.goodsTagInfoDtoList.map(
                        (se) => ({
                          content: se.name,
                          variant: se.style.toLowerCase(),
                          color: se.styleColor,
                          textColor: se.textColor
                        })
                      );
                      Object.assign(j, { goodsTagInfoDtoList: de });
                    }
                  }
                delete z.bannerListResponse, delete z.contentsListResponse, delete z.goodsListResponse, Object.assign(z, {
                  data: _ && (_ != null && _.content) ? _ : { ..._, content: [] },
                  TEST_RESPONSE: q
                });
              }
            s.splice(m, 1);
          }
        d.push(S);
      }
      return a.filter((M) => M.code === 200).length < 2 ? { code: 10500, message: "error" } : t.hasTemplateInfo ? {
        ...a[0],
        data: {
          templateData: { templateName: (A = i.data) == null ? void 0 : A.templateName },
          componentData: d
        }
      } : { ...a[0], data: d };
    });
  }
}
class mi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t, o) {
    const r = await new ao(
      this.host,
      this.httpClient
    ).exec(t, o);
    if (r.code === 200) {
      let a;
      r.data && (a = r.data.map(
        (i) => {
          let l = "";
          switch (i.componentType) {
            case "QUICKLINK":
              l = "quicklinkDataList";
              break;
            case "BANNER":
              l = "bannerDataList";
              break;
            case "CONTENTS":
              l = "contentsDataList";
              break;
            case "GOODS":
              l = "goodsDataList";
              break;
          }
          const s = (i.displayType || "").toLowerCase(), c = i[l];
          Object.assign(i, {
            display: s
          });
          for (let d = 0; d < c.content.length; d++) {
            const u = c.content[d];
            if (l === "goodsDataList") {
              if (u.goodsTagInfoDtoList && u.goodsTagInfoDtoList.length > 0) {
                const p = Pe(
                  u.goodsTagInfoDtoList
                );
                Object.assign(u, { goodsTagInfoDtoList: p });
              }
            } else if (l === "contentsDataList") {
              if (u.tagInfoDto && u.tagInfoDto.length > 0) {
                const p = Pe(
                  c.tagInfoDto
                );
                Object.assign(u, { goodsTagInfoDtoList: p });
              }
              if (u.imageInfo.tagInfo && u.imageInfo.tagInfo.length > 0) {
                const p = Pe(u.imageInfo.tagInfo);
                Object.assign(u.imageInfo, {
                  tagInfo: p
                });
              }
            }
          }
          return delete i.displayType, delete i.quicklinkDataList, delete i.bannerDataList, delete i.contentsDataList, delete i.goodsDataList, {
            ...i,
            data: c
          };
        }
      )), Object.assign(r, {
        data: a
      });
    }
    return r;
  }
}
class wi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    const o = t || {
      scrapGbnCd: "GA"
    };
    return t != null && t.scrapGbnCd || (o.scrapGbnCd = "GA"), await new so(this.host, this.httpClient).exec();
  }
}
class bi {
  constructor(t, o) {
    Re(this, "host");
    Re(this, "httpClient");
    this.host = t, this.httpClient = o;
  }
  async exec(t) {
    return t.isUse ? await new lo(this.host, this.httpClient).exec(
      t
    ) : await new co(this.host, this.httpClient).exec(
      t
    );
  }
}
const Ee = ({ component: e }) => {
  const [t, o] = O(), [r, a] = O(!1);
  J(() => {
    e.componentData ? o(e.componentData) : a(!0);
  }, [e.componentData]);
  const { hosts: i, httpClient: l } = te();
  J(() => {
    r && To(i.hanssemApiGateway, l).getRemodelingComponentData.exec({
      dispComponentType: e.dispComponentType,
      dispComponentNo: e.dispComponentNo,
      ctgNo: e.ctgNo,
      componentLayoutCd: e.componentLayoutCd
    }).then((d) => {
      d && (d == null ? void 0 : d.code) === 200 && o(d == null ? void 0 : d.data), a(!1);
    });
  }, [
    e.componentLayoutCd,
    e.ctgNo,
    e.dispComponentNo,
    e.dispComponentType,
    i.hanssemApiGateway,
    l,
    r
  ]);
  const s = W(
    () => qo(t == null ? void 0 : t.componentDataList, "rNum"),
    [t == null ? void 0 : t.componentDataList]
  ), c = Q(
    () => t == null ? void 0 : t.componentInfo.wiseLogParam,
    [t == null ? void 0 : t.componentInfo.wiseLogParam]
  );
  return {
    component: e,
    componentData: t,
    getComponentDataList: s,
    wiseLogParam: c
  };
}, vi = ({ viewType: e, typeValue: t, dedupingInterval: o = 3e3 }) => {
  const { hosts: r, httpClient: a } = te(), i = Q(() => {
    if (!(e && t && r.hanssemApiGateway)) return null;
    const c = tn.stringify({ viewType: e, typeValue: t });
    return `${r.hanssemApiGateway}/hanssem/content-service/api/v1/display/gnb-list?${c}`;
  }, [r.hanssemApiGateway, t, e]), { data: l } = Sn(
    i,
    () => $n(
      r.hanssemApiGateway,
      a
    ).getRemodelingGnbList.exec({ viewType: e, typeValue: t }),
    {
      dedupingInterval: o
    }
  );
  return {
    gnbList: Q(() => (l == null ? void 0 : l.code) !== 200 ? null : l == null ? void 0 : l.data, [l == null ? void 0 : l.code, l == null ? void 0 : l.data])
  };
}, Ci = ({
  apiType: e,
  dispTemplateNo: t,
  templateApiCd: o,
  ctgNo: r,
  custNo: a,
  pcId: i,
  snbCd: l,
  sort: s,
  channelCd: c,
  abTestGroup: d
}) => {
  const { hosts: u, httpClient: p } = te(), [h, g] = O();
  return J(() => {
    e === "component-list" ? To(u.hanssemApiGateway, p).getRemodelingComponentList.exec({
      dispTemplateNo: t,
      templateApiCd: o,
      ctgNo: r,
      abTestGroup: d
    }).then((w) => {
      (w == null ? void 0 : w.code) === 200 && g(w == null ? void 0 : w.data);
    }) : $n(u.hanssemApiGateway, p).getRemodelingDisplayInfo.exec({
      dispTemplateNo: t,
      templateApiCd: o,
      ctgNo: r,
      custNo: a,
      pcId: i,
      snbCd: l,
      sort: s,
      channelCd: c,
      abTestGroup: d
    }).then((w) => {
      (w == null ? void 0 : w.code) === 200 && g(w == null ? void 0 : w.data);
    });
  }, [
    d,
    e,
    c,
    r,
    a,
    t,
    u.hanssemApiGateway,
    p,
    i,
    g,
    l,
    s,
    o
  ]), {
    template: h
  };
}, _i = ({ typeValue: e }) => {
  const { hosts: t, httpClient: o } = te(), [r, a] = O();
  return J(() => {
    $n(t.hanssemApiGateway, o).getRemodelingTemplateInfo.exec({ typeValue: e }).then((i) => {
      (i == null ? void 0 : i.code) === 200 ? a(i == null ? void 0 : i.data) : a(null);
    });
  }, [t.hanssemApiGateway, o, e]), {
    templateInfo: r
  };
}, At = ({
  autoConfigData: e,
  fetchSize: t = 50
}) => {
  const { httpClient: o } = te(), r = (h) => {
    const g = tn.stringify({
      page: h + 1,
      size: t
    });
    return `${e == null ? void 0 : e.url}&${g}`;
  }, { data: a, size: i, setSize: l, isValidating: s } = uo(r, (h) => o.request({ url: h, method: "GET" })), c = Q(() => {
    const h = a != null && a.map ? a == null ? void 0 : a.map((g) => {
      var w;
      return (w = g.data) == null ? void 0 : w.content;
    }) : void 0;
    return (h == null ? void 0 : h.reduce(
      (g = [], w = []) => g == null ? void 0 : g.concat(w)
    )) || [];
  }, [a]), d = Q(
    () => {
      var h, g;
      return ((g = (h = yn(a)) == null ? void 0 : h.data) == null ? void 0 : g.totalElements) || 0;
    },
    [a]
  ), u = W(async () => {
    !s && c.length < d && i === (a == null ? void 0 : a.length) && await l(i + 1);
  }, [a == null ? void 0 : a.length, s, c.length, l, i, d]), p = W(async () => {
    await l(1);
  }, [l]);
  return {
    items: c,
    totalItems: d,
    handleMore: u,
    handleInit: p
  };
}, Mn = (e) => {
  const t = ye(), o = ye(!1), r = ye(!1), [a, i] = O(0);
  o.current && (r.current = !0), J(() => (o.current || (t.current = e(), o.current = !0), i((l) => l + 1), () => {
    r.current && t.current && t.current();
  }), []);
};
function Ii() {
  var e = ye(!1), t = W(function() {
    return e.current;
  }, []);
  return J(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), t;
}
var Li = function(e) {
  e === void 0 && (e = {});
  var t = O(e), o = t[0], r = t[1], a = W(function(i) {
    r(function(l) {
      return Object.assign({}, l, i instanceof Function ? i(l) : i);
    });
  }, []);
  return [o, a];
}, xi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ko(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ni = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, o = [], r = 0; r < e.rangeCount; r++)
    o.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || o.forEach(function(a) {
      e.addRange(a);
    }), t && t.focus();
  };
}, Si = Ni, jn = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Ti = "Copy to clipboard: #{key}, Enter";
function ki(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function Di(e, t) {
  var o, r, a, i, l, s, c = !1;
  t || (t = {}), o = t.debug || !1;
  try {
    a = Si(), i = document.createRange(), l = document.getSelection(), s = document.createElement("span"), s.textContent = e, s.ariaHidden = "true", s.style.all = "unset", s.style.position = "fixed", s.style.top = 0, s.style.clip = "rect(0, 0, 0, 0)", s.style.whiteSpace = "pre", s.style.webkitUserSelect = "text", s.style.MozUserSelect = "text", s.style.msUserSelect = "text", s.style.userSelect = "text", s.addEventListener("copy", function(u) {
      if (u.stopPropagation(), t.format)
        if (u.preventDefault(), typeof u.clipboardData > "u") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var p = jn[t.format] || jn.default;
          window.clipboardData.setData(p, e);
        } else
          u.clipboardData.clearData(), u.clipboardData.setData(t.format, e);
      t.onCopy && (u.preventDefault(), t.onCopy(u.clipboardData));
    }), document.body.appendChild(s), i.selectNodeContents(s), l.addRange(i);
    var d = document.execCommand("copy");
    if (!d)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (u) {
    o && console.error("unable to copy using execCommand: ", u), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (p) {
      o && console.error("unable to copy using clipboardData: ", p), o && console.error("falling back to prompt"), r = ki("message" in t ? t.message : Ti), window.prompt(r, e);
    }
  } finally {
    l && (typeof l.removeRange == "function" ? l.removeRange(i) : l.removeAllRanges()), s && document.body.removeChild(s), a();
  }
  return c;
}
var $i = Di;
const Mi = /* @__PURE__ */ ko($i);
var Ei = function() {
  var e = Ii(), t = Li({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), o = t[0], r = t[1], a = W(function(i) {
    if (e()) {
      var l, s;
      try {
        if (typeof i != "string" && typeof i != "number") {
          var c = new Error("Cannot copy typeof " + typeof i + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(c), r({
            value: i,
            error: c,
            noUserInteraction: !0
          });
          return;
        } else if (i === "") {
          var c = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(c), r({
            value: i,
            error: c,
            noUserInteraction: !0
          });
          return;
        }
        s = i.toString(), l = Mi(s), r({
          value: s,
          error: void 0,
          noUserInteraction: l
        });
      } catch (d) {
        r({
          value: s,
          error: d,
          noUserInteraction: l
        });
      }
    }
  }, []);
  return [o, a];
};
const Ol = () => {
  const [{ error: e }, t] = Ei();
  return { handleCopy: W(
    (r) => (t(r), e),
    [t, e]
  ) };
}, Oi = () => {
  const e = ye(), [t, o] = O(null), [r, a] = O(null), i = W(() => {
    e.current != null && (e.current > scrollY ? o("UP") : e.current < scrollY ? o("DOWN") : o(null)), e.current = scrollY, a(scrollY);
  }, [o]);
  return J(() => (window.addEventListener("scroll", i), () => window.removeEventListener("scroll", i)), [i]), { direction: t, y: r };
}, Rl = (e) => {
  const t = ye(!0), o = W(({ key: s, value: c }) => {
    var d, u;
    return en(c) ? (d = window == null ? void 0 : window.dataLayer) == null ? void 0 : d.some((p) => er(p, s)) : (u = window == null ? void 0 : window.dataLayer) == null ? void 0 : u.some((p) => (p == null ? void 0 : p[s]) === c);
  }, []), r = W(
    ({ data: s, key: c }) => {
      var d;
      en(s[c]) || o({ key: c, value: s[c] }) || (d = window == null ? void 0 : window.dataLayer) == null || d.push({
        ...s
      });
    },
    [o]
  ), a = W(
    ({ key: s, value: c }) => {
      var u;
      if (!o({ key: s, value: c })) return;
      const d = (u = window == null ? void 0 : window.dataLayer) == null ? void 0 : u.findIndex(
        (p) => (p == null ? void 0 : p[s]) === c
      );
      window.dataLayer.splice(d, 1);
    },
    [o]
  ), i = W(
    ({ data: s, key: c }) => {
      r({ data: s, key: c }), a({ key: c, value: s[c] });
    },
    [r, a]
  ), l = W(() => {
    var s, c;
    return (c = (s = window == null ? void 0 : window.google_tag_manager) == null ? void 0 : s.dataLayer) == null ? void 0 : c.gtmLoad;
  }, []);
  return Mn(() => {
    const s = () => {
      if (t.current)
        return t.current = !1, e == null ? void 0 : e({
          handlePush: r,
          handleRemove: a,
          has: o,
          handlePushAndRemove: i
        });
    };
    window.addEventListener("load", s);
    let c;
    return l() && (c = s()), () => {
      c == null || c(), window.removeEventListener("load", s);
    };
  }), {
    handlePush: r,
    handleRemove: a,
    has: o,
    handlePushAndRemove: i
  };
}, Bl = ({
  pageIdentificationValue: e,
  categoryNo: t
}) => {
  const { hosts: o, httpClient: r } = te(), [a, i] = O([]);
  return J(() => {
    It(o.hanssemApiGateway, r).getTemplateComponents.exec({
      pageIdentificationValue: e,
      categoryNo: t,
      isPreview: !1
    }).then((l) => {
      i((l == null ? void 0 : l.data) || []);
    });
  }, [
    t,
    o.hanssemApiGateway,
    r,
    e
  ]), { data: a };
}, Al = ({
  componentId: e,
  componentGroupDataId: t,
  page: o,
  size: r
}) => {
  const { hosts: a, httpClient: i } = te(), [l, s] = O([]);
  return J(() => {
    It(a.hanssemApiGateway, i).getTemplateInfiniteComponentsData.exec({
      componentId: e,
      componentGroupDataId: t,
      page: o,
      size: r
    }).then((c) => {
      s(
        c.data || []
      );
    });
  }, [
    t,
    e,
    a.hanssemApiGateway,
    i,
    o,
    r
  ]), { data: l };
}, be = ({ children: e, ...t }) => /* @__PURE__ */ n(Ri, { ...t, children: e }), Ri = ce.button`
  margin: 0;
  outline-width: 0;
  border-width: 0;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
`, ge = ({
  space: e = "default",
  children: t,
  ...o
}) => {
  const r = Q(() => {
    switch (e) {
      case "top_10_bottom_30":
        return [10, 0, 30, 0];
      case "bottom_20":
        return [0, 0, 20, 0];
      case "none":
        return [0, 0, 0, 0];
      default:
        return [30, 0, 40, 0];
    }
  }, [e]);
  return /* @__PURE__ */ n(
    oe,
    {
      width: "100%",
      height: "auto",
      pt: r[0],
      pr: r[1],
      pb: r[2],
      pl: r[3],
      ...o,
      children: t
    }
  );
}, Bi = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: o, wiseLogParam: r } = Ee({
    component: e
  }), a = o(), { hosts: i, tagGTM: l } = te();
  return a && a.length > 0 ? /* @__PURE__ */ n(
    ge,
    {
      space: "top_10_bottom_30",
      ...l(e.componentLayoutCd),
      children: /* @__PURE__ */ n(xe, { alignment: "start", space: 8, width: "100%", pl: 16, pr: 16, children: _n(a, 2).map((s, c) => /* @__PURE__ */ n(
        je,
        {
          alignment: "start",
          space: 8,
          width: "100%",
          children: s.map((d, u) => /* @__PURE__ */ n(
            be,
            {
              style: { width: "100%", fontSize: 0 },
              onClick: () => t({
                ...d,
                wiseLogParam: r
              }),
              ...l(`${e.componentLayoutCd}_item_button`, {
                wlp: r
              }),
              children: /* @__PURE__ */ n(
                Wt,
                {
                  src: Te(i.hanssemMallCDN, d.bannerImgUrl)
                }
              )
            },
            `${e.dispComponentNo}-item-${u + 1}`
          ))
        },
        `${e.dispComponentNo}-group-${c + 1}`
      )) })
    }
  ) : /* @__PURE__ */ n(Y, {});
}, Ai = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: o, wiseLogParam: r } = Ee({
    component: e
  }), a = o(), { hosts: i, tagGTM: l } = te();
  return a && a.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...l(e.componentLayoutCd), children: /* @__PURE__ */ n(xe, { alignment: "start", width: "100%", children: a.map((s, c) => /* @__PURE__ */ n(
    be,
    {
      style: { width: "100%" },
      onClick: () => t({
        ...s,
        wiseLogParam: r
      }),
      ...l(`${e.componentLayoutCd}_item_button`, {
        wlp: r
      }),
      children: /* @__PURE__ */ $(
        je,
        {
          alignment: "center",
          space: 4,
          width: "100%",
          pt: 10,
          pb: 10,
          pl: 16,
          pr: 16,
          children: [
            /* @__PURE__ */ n(V, { width: 24, height: 24, children: /* @__PURE__ */ n(
              Wt,
              {
                src: Te(i.hanssemMallCDN, s.bannerImgUrl)
              }
            ) }),
            /* @__PURE__ */ n(Ht, { variant: "subTitle1", color: Jt("color_chip.primary"), children: s.bannerNm })
          ]
        }
      )
    },
    `${e.dispComponentNo}-item-${c + 1}`
  )) }) }) : /* @__PURE__ */ n(Y, {});
}, Ui = Lt, Pi = ({
  component: e,
  handleLink: t
}) => {
  const { getComponentDataList: o, componentData: r, wiseLogParam: a } = Ee({
    component: e
  }), i = o(), { hosts: l, tagGTM: s } = te(), [c, d] = O(0), u = W(
    (h, g) => Math.round(g * c / h),
    [c]
  ), p = Q(() => tr(i), [i]);
  return i && i.length >= 4 ? /* @__PURE__ */ n(
    ge,
    {
      space: "bottom_20",
      ...s(e.componentLayoutCd),
      children: /* @__PURE__ */ n(
        Ui,
        {
          disableHeight: !0,
          onResize: ({ width: h }) => {
            d(h);
          },
          children: ({ width: h }) => {
            var g, w;
            return /* @__PURE__ */ n(V, { width: h, children: /* @__PURE__ */ $(
              V,
              {
                width: "100%",
                pl: 16,
                pr: 16,
                backgroundImage: `url("${l.remodelingAsset}/web/bg_interior_banner_unlimited_responsibility.png")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top",
                backgroundSize: `100% ${u(375, 186)}px`,
                children: [
                  /* @__PURE__ */ n(
                    Ht,
                    {
                      variant: "headline4",
                      color: Jt("color_chip.white"),
                      textAlign: "center",
                      pt: u(375, 40),
                      pb: u(375, 20),
                      children: (w = (g = r == null ? void 0 : r.componentInfo) == null ? void 0 : g.title) == null ? void 0 : w.split(`
`).map((f, C) => /* @__PURE__ */ $(
                        jt,
                        {
                          children: [
                            C > 0 && /* @__PURE__ */ n("br", {}),
                            f
                          ]
                        },
                        `${e.dispComponentNo}-text-${C + 1}`
                      ))
                    }
                  ),
                  /* @__PURE__ */ n(
                    Gi,
                    {
                      width: "100%",
                      p: 20,
                      backgroundColor: Jt("color_chip.white"),
                      children: /* @__PURE__ */ $(xe, { width: "100%", alignment: "center", space: 16, children: [
                        /* @__PURE__ */ n(
                          je,
                          {
                            width: "100%",
                            alignment: "center",
                            space: "space-between",
                            pl: 20,
                            pr: 20,
                            children: i.slice(0, i.length - 1).map((f, C) => /* @__PURE__ */ n(
                              be,
                              {
                                style: {
                                  width: "100%"
                                },
                                onClick: () => t({
                                  ...f,
                                  wiseLogParam: a
                                }),
                                ...s(
                                  `${e.componentLayoutCd}_item_button`,
                                  {
                                    wlp: a
                                  }
                                ),
                                children: /* @__PURE__ */ $(
                                  xe,
                                  {
                                    alignment: "center",
                                    space: 4,
                                    width: u(375, 80),
                                    margin: "0 auto",
                                    children: [
                                      /* @__PURE__ */ n(
                                        V,
                                        {
                                          width: u(375, 44),
                                          height: u(375, 44),
                                          children: /* @__PURE__ */ n(
                                            Wt,
                                            {
                                              src: Te(
                                                l.hanssemMallCDN,
                                                f.bannerImgUrl
                                              )
                                            }
                                          )
                                        }
                                      ),
                                      /* @__PURE__ */ n(
                                        Ht,
                                        {
                                          variant: "label_md_m",
                                          color: Jt("color_chip.primary"),
                                          height: 16,
                                          children: f.bannerNm
                                        }
                                      )
                                    ]
                                  }
                                )
                              },
                              `${e.dispComponentNo}-item-${C + 1}`
                            ))
                          }
                        ),
                        p && /* @__PURE__ */ n(
                          be,
                          {
                            style: { width: "100%", fontSize: 0 },
                            onClick: () => t({
                              ...p,
                              wiseLogParam: a
                            }),
                            ...s(`${e.componentLayoutCd}_item_button`, {
                              wlp: a
                            }),
                            children: /* @__PURE__ */ n(
                              Wt,
                              {
                                src: Te(
                                  l.hanssemMallCDN,
                                  p.bannerImgUrl
                                )
                              }
                            )
                          }
                        )
                      ] })
                    }
                  )
                ]
              }
            ) });
          }
        }
      )
    }
  ) : /* @__PURE__ */ n(Y, {});
}, Gi = ce(V)`
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
`, Hi = ({
  src: e,
  alt: t,
  w: o,
  h: r,
  imgFit: a = "fill",
  borderRadius: i,
  onLoad: l = () => {
  }
}) => /* @__PURE__ */ n(
  zi,
  {
    src: e,
    alt: t || "",
    w: o ? `${o}px` : "100%",
    h: r ? `${r}px` : "100%",
    imgFit: a,
    borderRadius: i,
    onLoad: l
  }
), _e = nn(Hi), zi = ce.img`
  ${({ w: e, h: t, imgFit: o, borderRadius: r }) => Be`
    width: ${e};
    height: ${t};
    object-fit: ${o};
    border-radius: ${r};
  `}
`, Wi = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: r, wiseLogParam: a } = Ee({
    component: e
  }), i = r(), { hosts: l, tagGTM: s } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...s(e.componentLayoutCd), children: /* @__PURE__ */ n(le, { width: "100%", pl: 20, pr: 20, children: /* @__PURE__ */ n(Ve, { alignment: "start", space: "space-between", width: "100%", children: i.map((c, d) => /* @__PURE__ */ n(
    be,
    {
      onClick: () => t({
        ...c,
        wiseLogParam: a
      }),
      ...s(`${e.componentLayoutCd}_item_button`, {
        wlp: a
      }),
      children: /* @__PURE__ */ $(le, { space: 12, width: 72, children: [
        /* @__PURE__ */ n(
          oe,
          {
            width: 72,
            height: 72,
            borderRadius: 20,
            overflow: "hidden",
            children: /* @__PURE__ */ n(
              _e,
              {
                src: Te(l.hanssemMallCDN, c.bannerImgUrl),
                w: 72,
                h: 72,
                imgFit: "fill"
              }
            )
          }
        ),
        /* @__PURE__ */ n(
          Ce,
          {
            variant: "caption1",
            color: we("accent_color.primary.default"),
            lineHeight: "14px",
            textAlign: "left",
            children: c.bannerNm
          }
        )
      ] })
    },
    `${e.dispComponentNo}-item-${d + 1}`
  )) }) }) }) : /* @__PURE__ */ n(Y, {});
};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
var Do = Vi, Vn = Fi, ji = Object.prototype.toString, Kt = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function Vi(e, t) {
  if (typeof e != "string")
    throw new TypeError("argument str must be a string");
  for (var o = {}, r = t || {}, a = r.decode || Yi, i = 0; i < e.length; ) {
    var l = e.indexOf("=", i);
    if (l === -1)
      break;
    var s = e.indexOf(";", i);
    if (s === -1)
      s = e.length;
    else if (s < l) {
      i = e.lastIndexOf(";", l - 1) + 1;
      continue;
    }
    var c = e.slice(i, l).trim();
    if (o[c] === void 0) {
      var d = e.slice(l + 1, s).trim();
      d.charCodeAt(0) === 34 && (d = d.slice(1, -1)), o[c] = Zi(d, a);
    }
    i = s + 1;
  }
  return o;
}
function Fi(e, t, o) {
  var r = o || {}, a = r.encode || Ki;
  if (typeof a != "function")
    throw new TypeError("option encode is invalid");
  if (!Kt.test(e))
    throw new TypeError("argument name is invalid");
  var i = a(t);
  if (i && !Kt.test(i))
    throw new TypeError("argument val is invalid");
  var l = e + "=" + i;
  if (r.maxAge != null) {
    var s = r.maxAge - 0;
    if (isNaN(s) || !isFinite(s))
      throw new TypeError("option maxAge is invalid");
    l += "; Max-Age=" + Math.floor(s);
  }
  if (r.domain) {
    if (!Kt.test(r.domain))
      throw new TypeError("option domain is invalid");
    l += "; Domain=" + r.domain;
  }
  if (r.path) {
    if (!Kt.test(r.path))
      throw new TypeError("option path is invalid");
    l += "; Path=" + r.path;
  }
  if (r.expires) {
    var c = r.expires;
    if (!Xi(c) || isNaN(c.valueOf()))
      throw new TypeError("option expires is invalid");
    l += "; Expires=" + c.toUTCString();
  }
  if (r.httpOnly && (l += "; HttpOnly"), r.secure && (l += "; Secure"), r.partitioned && (l += "; Partitioned"), r.priority) {
    var d = typeof r.priority == "string" ? r.priority.toLowerCase() : r.priority;
    switch (d) {
      case "low":
        l += "; Priority=Low";
        break;
      case "medium":
        l += "; Priority=Medium";
        break;
      case "high":
        l += "; Priority=High";
        break;
      default:
        throw new TypeError("option priority is invalid");
    }
  }
  if (r.sameSite) {
    var u = typeof r.sameSite == "string" ? r.sameSite.toLowerCase() : r.sameSite;
    switch (u) {
      case !0:
        l += "; SameSite=Strict";
        break;
      case "lax":
        l += "; SameSite=Lax";
        break;
      case "strict":
        l += "; SameSite=Strict";
        break;
      case "none":
        l += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  }
  return l;
}
function Yi(e) {
  return e.indexOf("%") !== -1 ? decodeURIComponent(e) : e;
}
function Ki(e) {
  return encodeURIComponent(e);
}
function Xi(e) {
  return ji.call(e) === "[object Date]" || e instanceof Date;
}
function Zi(e, t) {
  try {
    return t(e);
  } catch {
    return e;
  }
}
function Qi() {
  const e = typeof global > "u" ? void 0 : global.TEST_HAS_DOCUMENT_COOKIE;
  return typeof e == "boolean" ? e : typeof document == "object" && typeof document.cookie == "string";
}
function Ji(e) {
  return typeof e == "string" ? Do(e) : typeof e == "object" && e !== null ? e : {};
}
function hn(e, t = {}) {
  const o = qi(e);
  if (!t.doNotParse)
    try {
      return JSON.parse(o);
    } catch {
    }
  return e;
}
function qi(e) {
  return e && e[0] === "j" && e[1] === ":" ? e.substr(2) : e;
}
class ea {
  constructor(t, o = {}) {
    this.changeListeners = [], this.HAS_DOCUMENT_COOKIE = !1, this.update = () => {
      if (!this.HAS_DOCUMENT_COOKIE)
        return;
      const a = this.cookies;
      this.cookies = Do(document.cookie), this._checkChanges(a);
    };
    const r = typeof document > "u" ? "" : document.cookie;
    this.cookies = Ji(t || r), this.defaultSetOptions = o, this.HAS_DOCUMENT_COOKIE = Qi();
  }
  _emitChange(t) {
    for (let o = 0; o < this.changeListeners.length; ++o)
      this.changeListeners[o](t);
  }
  _checkChanges(t) {
    new Set(Object.keys(t).concat(Object.keys(this.cookies))).forEach((r) => {
      t[r] !== this.cookies[r] && this._emitChange({
        name: r,
        value: hn(this.cookies[r])
      });
    });
  }
  _startPolling() {
    this.pollingInterval = setInterval(this.update, 300);
  }
  _stopPolling() {
    this.pollingInterval && clearInterval(this.pollingInterval);
  }
  get(t, o = {}) {
    return o.doNotUpdate || this.update(), hn(this.cookies[t], o);
  }
  getAll(t = {}) {
    t.doNotUpdate || this.update();
    const o = {};
    for (let r in this.cookies)
      o[r] = hn(this.cookies[r], t);
    return o;
  }
  set(t, o, r) {
    r ? r = Object.assign(Object.assign({}, this.defaultSetOptions), r) : r = this.defaultSetOptions;
    const a = typeof o == "string" ? o : JSON.stringify(o);
    this.cookies = Object.assign(Object.assign({}, this.cookies), { [t]: a }), this.HAS_DOCUMENT_COOKIE && (document.cookie = Vn(t, a, r)), this._emitChange({ name: t, value: o, options: r });
  }
  remove(t, o) {
    const r = o = Object.assign(Object.assign(Object.assign({}, this.defaultSetOptions), o), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 });
    this.cookies = Object.assign({}, this.cookies), delete this.cookies[t], this.HAS_DOCUMENT_COOKIE && (document.cookie = Vn(t, "", r)), this._emitChange({ name: t, value: void 0, options: o });
  }
  addChangeListener(t) {
    this.changeListeners.push(t), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 1 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.addEventListener("change", this.update) : this._startPolling());
  }
  removeChangeListener(t) {
    const o = this.changeListeners.indexOf(t);
    o >= 0 && this.changeListeners.splice(o, 1), this.HAS_DOCUMENT_COOKIE && this.changeListeners.length === 0 && (typeof window == "object" && "cookieStore" in window ? window.cookieStore.removeEventListener("change", this.update) : this._stopPolling());
  }
}
const $o = Zo.createContext(new ea()), { Provider: Ul, Consumer: Pl } = $o;
function ta() {
  return typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
}
function na(e) {
  const t = dt($o);
  if (!t)
    throw new Error("Missing <CookiesProvider>");
  const [o, r] = O(() => t.getAll());
  ta() && Qo(() => {
    function s() {
      const c = t.getAll({
        doNotUpdate: !0
      });
      oa() && r(c);
    }
    return t.addChangeListener(s), () => {
      t.removeChangeListener(s);
    };
  }, [t, o]);
  const a = Q(() => t.set.bind(t), [t]), i = Q(() => t.remove.bind(t), [t]), l = Q(() => t.update.bind(t), [t]);
  return [o, a, i, l];
}
function oa(e, t, o) {
  return !0;
}
const Fn = "APP_DOWNLOAD_POPUP_LOADED", ra = "done", ia = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: o } = Ee({ component: e }), r = o(), { tagGTM: a } = te(), [i, l] = na(), [s, c] = O(!1), d = W(() => {
    i[Fn] ? c(!1) : c(!0);
  }, [i]), u = W(() => {
    l(
      Fn,
      ra,
      {
        domain: ".hanssem.com",
        path: "/",
        expires: Fr(/* @__PURE__ */ new Date(), 1),
        httpOnly: !1
      }
    ), c(!1);
  }, [l]);
  return Mn(() => {
    d();
  }), r && r.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...a(e.componentLayoutCd), children: /* @__PURE__ */ n(
    oo,
    {
      isOpen: s,
      variant: "general",
      height: 352,
      handleClose: () => u(),
      zIndex: 1100,
      ...a(`${e.componentLayoutCd}_bottomsheet`),
      children: /* @__PURE__ */ $(xe, { width: "100%", height: "100%", alignment: "center", px: 16, pb: 16, children: [
        /* @__PURE__ */ n(
          Ot,
          {
            variant: "hanssem_logo",
            width: 80,
            height: 80,
            resize: !0,
            mb: 24
          }
        ),
        /* @__PURE__ */ n(
          Ht,
          {
            variant: "headline4",
            color: "color_chip.primary",
            textAlign: "center",
            mb: 24,
            children: r.map((p) => p.acctContsText).join(`
`).split("  ").join(`
`).split(`
`).map((p, h) => /* @__PURE__ */ $(
              jt,
              {
                children: [
                  h > 0 && /* @__PURE__ */ n("br", {}),
                  p
                ]
              },
              `${e.componentLayoutCd}-text-${h + 1}`
            ))
          }
        ),
        /* @__PURE__ */ n(
          xn,
          {
            width: "100%",
            emphasis: "high",
            size: "lg",
            icon: {
              align: "right",
              variant: "ic_arrow_right"
            },
            mb: 15,
            onClick: () => t(),
            ...a(`${e.componentLayoutCd}_move_app_button`),
            children: "앱 바로 가기"
          }
        ),
        /* @__PURE__ */ n(
          ur,
          {
            variant: "text",
            size: "lg",
            color: "color_chip.gray.700",
            onClick: () => u(),
            ...a(`${e.componentLayoutCd}_stay_web_button`),
            children: "모바일 웹으로 보기"
          }
        )
      ] })
    }
  ) }) : /* @__PURE__ */ n(Y, {});
}, Ue = "no-swiping", aa = 146, sa = 304, Mo = 322.5, Gl = 24, gn = 375, Eo = 322.5, Yn = {
  vertical: 540,
  square: 375,
  horizontal: 238,
  band: 125,
  thin: 53,
  timer: 0,
  autonomous: 0
}, la = 140, ca = 322.5, da = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { items: i, handleMore: l } = At(e), { tagGTM: s } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...s(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: "100%", children: [
    /* @__PURE__ */ n(
      Ce,
      {
        variant: "headline4",
        color: we("accent_color.primary.default"),
        pl: 16,
        children: "Best"
      }
    ),
    /* @__PURE__ */ n(
      it,
      {
        className: Ue,
        baseWidth: 375,
        itemWidth: 319,
        data: i,
        pl: 16,
        pr: 16,
        gap: 12,
        isPreviewed: !0,
        handleMore: () => l(),
        onTouchStart: (c, d) => o && o(d),
        onTouchEnd: (c, d) => r && r(d),
        onTouchCancel: a,
        children: ({ width: c, item: d }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...et(`/goods/${d.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...s(`${e.componentLayoutCd}_item_button`, {
              "good-id": d.id
              // wlp: wiseLogParam,
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: c, children: [
              /* @__PURE__ */ $(
                oe,
                {
                  width: c,
                  height: Math.floor(c * 213 / 319),
                  position: "relative",
                  overflow: "hidden",
                  children: [
                    /* @__PURE__ */ n(
                      _e,
                      {
                        src: d.imageUrl,
                        w: c,
                        h: Math.floor(c * 213 / 319),
                        imgFit: "cover",
                        borderRadius: "2px"
                      }
                    ),
                    d.goodsBadgeTypeCode && d.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "8px", left: "8px", children: /* @__PURE__ */ n(gt, { variant: "default", children: d.goodsBadgeTypeCodeName }) })
                  ]
                }
              ),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "subTitle1",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  textAlign: "left",
                  children: d.goodsName
                }
              )
            ] })
          }
        )
      }
    )
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, ua = Lt;
function Oo({
  columnCount: e = 1,
  columnSpace: t = 0,
  rowSpace: o = 0,
  list: r = [],
  children: a
}) {
  const i = Tn(), [l, s] = O(0), [c, d] = O(0), u = W(
    ({ width: g }) => {
      s(g), d((g - t * (e - 1)) / e);
    },
    [e, t]
  ), [p, h] = O([]);
  return J(() => {
    const g = [];
    let w = 0;
    r.forEach((f, C) => {
      C > 0 && C % e === 0 && w++, g.length < w + 1 && g.push([]), g[w].push(f);
    }), h(g);
  }, [e, r]), /* @__PURE__ */ n(oe, { width: "100%", children: /* @__PURE__ */ n(ua, { disableHeight: !0, onResize: u, children: ({ width: g }) => /* @__PURE__ */ n(le, { alignment: "start", space: o, width: g, children: p.map((w, f) => /* @__PURE__ */ n(
    Ve,
    {
      alignment: "start",
      space: t,
      width: g,
      children: w.map((C, N) => /* @__PURE__ */ n(jt, { children: a({
        item: C,
        containerWidth: l,
        fixedWidth: c,
        index: f * e + N
      }) }, `${i}-${f + 1}-${N + 1}`))
    },
    `${i}-${f + 1}`
  )) }) }) });
}
const pa = ({
  component: e,
  handleLink: t
}) => {
  const { items: o } = At({ ...e, fetchSize: 10 }), { tagGTM: r } = te();
  return o && o.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...r(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: "100%", children: [
    /* @__PURE__ */ n(
      Ve,
      {
        alignment: "end",
        space: "space-between",
        width: "100%",
        pl: 16,
        pr: 16,
        children: /* @__PURE__ */ n(
          Ce,
          {
            variant: "headline4",
            color: we("accent_color.primary.default"),
            children: "Best"
          }
        )
      }
    ),
    /* @__PURE__ */ n(oe, { width: "100%", pl: 16, pr: 16, children: /* @__PURE__ */ n(
      Oo,
      {
        list: o,
        columnCount: 2,
        columnSpace: 8,
        rowSpace: 40,
        children: ({ item: a, fixedWidth: i }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...et(`/goods/${a.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${e.componentLayoutCd}_item_button`, {
              "good-id": a.id
              // wlp: wiseLogParam,
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 16, width: "100%", children: [
              /* @__PURE__ */ $(
                oe,
                {
                  width: i,
                  height: i,
                  position: "relative",
                  children: [
                    /* @__PURE__ */ n(
                      _e,
                      {
                        src: a.imageUrl,
                        alt: a.goodsName,
                        w: i,
                        h: i,
                        imgFit: "cover",
                        borderRadius: "2px"
                      }
                    ),
                    a.goodsBadgeTypeCode && a.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "6px", left: "6px", children: /* @__PURE__ */ n(gt, { variant: "default", children: a.goodsBadgeTypeCodeName }) })
                  ]
                }
              ),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "body2",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  textAlign: "left",
                  children: a.goodsName
                }
              )
            ] })
          }
        )
      }
    ) })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, ha = ({ component: e, handleLink: t }) => {
  const { items: o, handleMore: r } = At(e), { tagGTM: a } = te();
  return o && o.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...a(e.componentLayoutCd), children: /* @__PURE__ */ n(
    Po,
    {
      list: o,
      rowSpace: 40,
      handleNextMore: () => r(),
      children: ({ item: i, measure: l, fixedWidth: s }) => /* @__PURE__ */ n(
        be,
        {
          style: { width: "100%" },
          onClick: () => t({
            ...et(`/goods/${i.id}`, "REMODELING")
            // wiseLogParam,
          }),
          ...a(`${e.componentLayoutCd}_item_button`, {
            "good-id": i.id
            // wlp: wiseLogParam,
          }),
          children: /* @__PURE__ */ $(le, { alignment: "start", width: "100%", pl: 16, pr: 16, children: [
            /* @__PURE__ */ $(
              oe,
              {
                width: "100%",
                height: s * 228 / 375,
                position: "relative",
                children: [
                  /* @__PURE__ */ n(
                    _e,
                    {
                      src: i.imageUrl,
                      imgFit: "cover",
                      borderRadius: "2px",
                      onLoad: l
                    }
                  ),
                  i.goodsBadgeTypeCode && i.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "8px", left: "8px", children: /* @__PURE__ */ n(gt, { variant: "default", children: i.goodsBadgeTypeCodeName }) })
                ]
              }
            ),
            /* @__PURE__ */ $(le, { alignment: "start", width: "100%", pt: 12, children: [
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "subTitle1",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  textAlign: "left",
                  children: i.goodsName
                }
              ),
              i.recommendationTagList.length > 0 && /* @__PURE__ */ n(
                Ce,
                {
                  variant: "body3",
                  color: we("natural_color.gray.600"),
                  mt: "6px",
                  textAlign: "left",
                  children: i.recommendationTagList.map((c, d) => /* @__PURE__ */ n(ga, { children: c.keywordName }, `${i.id}-tag-${d + 1}`))
                }
              )
            ] })
          ] })
        }
      )
    }
  ) }) : /* @__PURE__ */ n(Y, {});
}, ga = ce.span`
  &:not(:first-child) {
    &:before {
      margin: 3px 6px;
      width: 1px;
      height: 12px;
      content: '|';
      color: #e2e2e2;
    }
  }
`, Ut = ({ ...e }) => /* @__PURE__ */ n(po, { p: 0, flexShrink: 0, ...e, children: /* @__PURE__ */ $(Ve, { pt: "3px", pb: "3px", pl: "6px", children: [
  /* @__PURE__ */ n(Ce, { variant: "button_md_r", color: we("natural_color.gray.700"), children: "더보기" }),
  /* @__PURE__ */ n(ho, { variant: "ic_right_16", useFillColor: !0, fillColor: "#666" })
] }) }), En = ({
  autoConfigData: e
}) => {
  const { httpClient: t } = te(), { data: o } = Sn(
    e == null ? void 0 : e.url,
    (a) => t.request({ url: a, method: "GET" })
  );
  return {
    categories: Q(
      () => (o == null ? void 0 : o.code) === 200 ? o == null ? void 0 : o.data : void 0,
      [o]
    )
  };
}, fa = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { categories: i } = En(e), { tagGTM: l } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...l(e.componentLayoutCd), children: /* @__PURE__ */ n(le, { alignment: "start", space: 56, width: "100%", children: i.map(
    ({ category: s }, c) => s.goods && s.goods.length > 0 ? /* @__PURE__ */ $(
      le,
      {
        alignment: "start",
        space: 12,
        width: "100%",
        children: [
          /* @__PURE__ */ $(Ve, { space: "space-between", width: "100%", pl: 16, pr: 16, children: [
            /* @__PURE__ */ n(
              Ce,
              {
                variant: "headline5",
                color: we("accent_color.primary.default"),
                textAlign: "left",
                children: s.categoryName
              }
            ),
            /* @__PURE__ */ n(
              Ut,
              {
                onClick: () => t({
                  ...Nn(s, "REMODELING")
                  // wiseLogParam,
                }),
                ...l(`${e.componentLayoutCd}_more_button`, {
                  "category-id": s.categoryNo
                  // wlp: wiseLogParam,
                })
              }
            )
          ] }),
          /* @__PURE__ */ n(
            it,
            {
              className: Ue,
              baseWidth: 375,
              itemWidth: 142,
              data: s.goods,
              pl: 16,
              pr: 16,
              gap: 10,
              isPreviewed: !0,
              onTouchStart: (d, u) => o && o(u),
              onTouchEnd: (d, u) => r && r(u),
              onTouchCancel: a,
              children: ({ width: d, item: u }) => /* @__PURE__ */ n(
                be,
                {
                  onClick: () => t({
                    ...et(`/goods/${u.id}`, "REMODELING")
                    // wiseLogParam,
                  }),
                  ...l(`${e.componentLayoutCd}_item_button`, {
                    "good-id": u.id
                    // wlp: wiseLogParam,
                  }),
                  children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: d, children: [
                    /* @__PURE__ */ n(
                      oe,
                      {
                        width: d,
                        height: Math.floor(d * 95 / 142),
                        position: "relative",
                        overflow: "hidden",
                        children: /* @__PURE__ */ n(
                          _e,
                          {
                            src: u.imageUrl,
                            w: d,
                            h: Math.floor(d * 95 / 142),
                            imgFit: "cover",
                            borderRadius: "2px"
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ n(
                      Ce,
                      {
                        variant: "body3",
                        color: we("accent_color.primary.default"),
                        isNoWrap: !0,
                        lineClamp: 2,
                        textAlign: "left",
                        children: u.goodsName
                      }
                    )
                  ] })
                }
              )
            }
          )
        ]
      },
      `${e.dispComponentNo}-item-${c + 1}`
    ) : /* @__PURE__ */ n(Y, {})
  ) }) }) : /* @__PURE__ */ n(Y, {});
}, ya = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { categories: i } = En(e), { tagGTM: l } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...l(e.componentLayoutCd), children: /* @__PURE__ */ n(le, { alignment: "start", space: 56, width: "100%", children: i.map(
    ({ category: s }, c) => s.goods && s.goods.length > 0 ? /* @__PURE__ */ $(
      le,
      {
        alignment: "start",
        space: 12,
        width: "100%",
        children: [
          /* @__PURE__ */ $(Ve, { space: "space-between", width: "100%", pl: 16, pr: 16, children: [
            /* @__PURE__ */ n(
              Ce,
              {
                variant: "headline4",
                color: we("accent_color.primary.default"),
                textAlign: "left",
                children: s.categoryName
              }
            ),
            /* @__PURE__ */ n(
              Ut,
              {
                onClick: () => t({
                  ...Nn(s, "REMODELING")
                  // wiseLogParam,
                }),
                ...l(`${e.componentLayoutCd}_more_button`, {
                  "category-id": s.categoryNo
                  // wlp: wiseLogParam,
                })
              }
            )
          ] }),
          /* @__PURE__ */ n(
            it,
            {
              className: Ue,
              baseWidth: 375,
              itemWidth: 142,
              data: s.goods,
              pl: 16,
              pr: 16,
              gap: 10,
              isPreviewed: !0,
              onTouchStart: (d, u) => o && o(u),
              onTouchEnd: (d, u) => r && r(u),
              onTouchCancel: a,
              children: ({ width: d, item: u }) => /* @__PURE__ */ n(
                be,
                {
                  onClick: () => t({
                    ...et(`/goods/${u.id}`, "REMODELING")
                    // wiseLogParam,
                  }),
                  ...l(`${e.componentLayoutCd}_item_button`, {
                    "good-id": u.id
                    // wlp: wiseLogParam,
                  }),
                  children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: d, children: [
                    /* @__PURE__ */ $(
                      oe,
                      {
                        width: d,
                        height: d,
                        position: "relative",
                        overflow: "hidden",
                        children: [
                          /* @__PURE__ */ n(
                            _e,
                            {
                              src: u.imageUrl,
                              w: d,
                              h: d,
                              imgFit: "cover",
                              borderRadius: "2px"
                            }
                          ),
                          u.goodsBadgeTypeCode && u.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "6px", left: "6px", children: /* @__PURE__ */ n(gt, { variant: "default", children: u.goodsBadgeTypeCodeName }) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ n(
                      Ce,
                      {
                        variant: "body3",
                        color: we("accent_color.primary.default"),
                        isNoWrap: !0,
                        lineClamp: 2,
                        textAlign: "left",
                        children: u.goodsName
                      }
                    )
                  ] })
                }
              )
            }
          )
        ]
      },
      `${e.dispComponentNo}-item-${c + 1}`
    ) : /* @__PURE__ */ n(Y, {})
  ) }) }) : /* @__PURE__ */ n(Y, {});
}, ma = ({
  component: e,
  handleLink: t
}) => {
  const { items: o, handleMore: r } = At(e), { tagGTM: a } = te();
  return o && o.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...a(e.componentLayoutCd), children: /* @__PURE__ */ n(oe, { width: "100%", pl: 16, pr: 16, children: /* @__PURE__ */ n(
    Po,
    {
      list: o,
      columnCount: 2,
      columnSpace: 8,
      rowSpace: 40,
      handleNextMore: () => r(),
      children: ({ item: i, measure: l, fixedWidth: s }) => /* @__PURE__ */ n(
        be,
        {
          style: { width: s },
          onClick: () => t({
            ...et(`/goods/${i.id}`, "REMODELING")
            // wiseLogParam,
          }),
          ...a(`${e.componentLayoutCd}_item_button`, {
            "good-id": i.id
            // wlp: wiseLogParam,
          }),
          children: /* @__PURE__ */ $(le, { alignment: "start", space: 16, width: s, children: [
            /* @__PURE__ */ $(oe, { width: s, height: s, position: "relative", children: [
              /* @__PURE__ */ n(
                _e,
                {
                  src: i.imageUrl,
                  imgFit: "cover",
                  w: s,
                  h: s,
                  borderRadius: "2px",
                  onLoad: l
                }
              ),
              i.goodsBadgeTypeCode && i.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "6px", left: "6px", children: /* @__PURE__ */ n(gt, { variant: "default", children: i.goodsBadgeTypeCodeName }) })
            ] }),
            /* @__PURE__ */ n(
              Ce,
              {
                variant: "body2",
                color: we("accent_color.primary.default"),
                isNoWrap: !0,
                lineClamp: 2,
                textAlign: "left",
                children: i.goodsName
              }
            )
          ] })
        }
      )
    }
  ) }) }) : /* @__PURE__ */ n(Y, {});
}, wa = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { items: i, handleMore: l } = At(e), { tagGTM: s } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...s(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: "100%", children: [
    /* @__PURE__ */ n(
      Ce,
      {
        variant: "headline4",
        color: we("accent_color.primary.default"),
        pl: 16,
        children: "New"
      }
    ),
    /* @__PURE__ */ n(
      it,
      {
        className: Ue,
        baseWidth: 375,
        itemWidth: 319,
        data: i,
        pl: 16,
        pr: 16,
        gap: 12,
        isPreviewed: !0,
        handleMore: () => l(),
        onTouchStart: (c, d) => o && o(d),
        onTouchEnd: (c, d) => r && r(d),
        onTouchCancel: a,
        children: ({ width: c, item: d }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...et(`/goods/${d.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...s(`${e.componentLayoutCd}_item_button`, {
              "good-id": d.id
              // wlp: wiseLogParam,
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: c, children: [
              /* @__PURE__ */ $(
                oe,
                {
                  width: c,
                  height: Math.floor(c * 213 / 319),
                  position: "relative",
                  overflow: "hidden",
                  children: [
                    /* @__PURE__ */ n(
                      _e,
                      {
                        src: d.imageUrl,
                        w: c,
                        h: Math.floor(c * 213 / 319),
                        imgFit: "cover",
                        borderRadius: "2px"
                      }
                    ),
                    d.goodsBadgeTypeCode && d.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "8px", left: "8px", children: /* @__PURE__ */ n(gt, { variant: "default", children: d.goodsBadgeTypeCodeName }) })
                  ]
                }
              ),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "subTitle1",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  textAlign: "left",
                  children: d.goodsName
                }
              )
            ] })
          }
        )
      }
    )
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, ba = ({
  component: e,
  handleLink: t
}) => {
  const { items: o } = At({ ...e, fetchSize: 10 }), { tagGTM: r } = te();
  return o && o.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...r(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: "100%", children: [
    /* @__PURE__ */ n(
      Ve,
      {
        alignment: "end",
        space: "space-between",
        width: "100%",
        pl: 16,
        pr: 16,
        children: /* @__PURE__ */ n(
          Ce,
          {
            variant: "headline4",
            color: we("accent_color.primary.default"),
            children: "New"
          }
        )
      }
    ),
    /* @__PURE__ */ n(oe, { width: "100%", pl: 16, pr: 16, children: /* @__PURE__ */ n(
      Oo,
      {
        list: o,
        columnCount: 2,
        columnSpace: 8,
        rowSpace: 40,
        children: ({ item: a, fixedWidth: i }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...et(`/goods/${a.id}`, "REMODELING")
              // wiseLogParam,
            }),
            ...r(`${e.componentLayoutCd}_item_button`, {
              "good-id": a.id
              // wlp: wiseLogParam,
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 16, width: "100%", children: [
              /* @__PURE__ */ $(
                oe,
                {
                  width: i,
                  height: i,
                  position: "relative",
                  children: [
                    /* @__PURE__ */ n(
                      _e,
                      {
                        src: a.imageUrl,
                        alt: a.goodsName,
                        w: i,
                        h: i,
                        imgFit: "cover",
                        borderRadius: "2px"
                      }
                    ),
                    a.goodsBadgeTypeCode && a.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "6px", left: "6px", children: /* @__PURE__ */ n(gt, { variant: "default", children: a.goodsBadgeTypeCodeName }) })
                  ]
                }
              ),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "body2",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  textAlign: "left",
                  children: a.goodsName
                }
              )
            ] })
          }
        )
      }
    ) })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, va = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { categories: i } = En(e), { tagGTM: l } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...l(e.componentLayoutCd), children: /* @__PURE__ */ n(le, { alignment: "start", space: 56, width: "100%", children: i.map(
    ({ category: s }, c) => s.goods && s.goods.length > 0 ? /* @__PURE__ */ $(
      le,
      {
        alignment: "start",
        space: 12,
        width: "100%",
        children: [
          /* @__PURE__ */ $(Ve, { space: "space-between", width: "100%", pl: 16, pr: 16, children: [
            /* @__PURE__ */ n(
              Ce,
              {
                variant: "headline4",
                color: we("accent_color.primary.default"),
                textAlign: "left",
                children: s.categoryName
              }
            ),
            /* @__PURE__ */ n(
              Ut,
              {
                onClick: () => t({
                  ...Nn(s, "REMODELING")
                  // wiseLogParam,
                }),
                ...l(`${e.componentLayoutCd}_more_button`, {
                  "category-id": s.categoryNo
                  // wlp: wiseLogParam,
                })
              }
            )
          ] }),
          /* @__PURE__ */ n(
            it,
            {
              className: Ue,
              baseWidth: 375,
              itemWidth: 319,
              data: s.goods,
              pl: 16,
              pr: 16,
              gap: 12,
              isPreviewed: !0,
              onTouchStart: (d, u) => o && o(u),
              onTouchEnd: (d, u) => r && r(u),
              onTouchCancel: a,
              children: ({ width: d, item: u }) => /* @__PURE__ */ n(
                be,
                {
                  onClick: () => t({
                    ...et(`/goods/${u.id}`, "REMODELING")
                    // wiseLogParam,
                  }),
                  ...l(`${e.componentLayoutCd}_item_button`, {
                    "good-id": u.id
                    // wlp: wiseLogParam,
                  }),
                  children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: d, children: [
                    /* @__PURE__ */ $(
                      oe,
                      {
                        width: d,
                        height: Math.floor(d * 213 / 319),
                        position: "relative",
                        overflow: "hidden",
                        children: [
                          /* @__PURE__ */ n(
                            _e,
                            {
                              src: u.imageUrl,
                              w: d,
                              h: Math.floor(d * 213 / 319),
                              imgFit: "cover",
                              borderRadius: "2px"
                            }
                          ),
                          u.goodsBadgeTypeCode && u.goodsBadgeTypeCode.length > 0 && /* @__PURE__ */ n(oe, { position: "absolute", top: "8px", left: "8px", children: /* @__PURE__ */ n(gt, { variant: "default", children: u.goodsBadgeTypeCodeName }) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ n(
                      Ce,
                      {
                        variant: "subTitle1",
                        color: we("accent_color.primary.default"),
                        isNoWrap: !0,
                        lineClamp: 2,
                        textAlign: "left",
                        children: u.goodsName
                      }
                    )
                  ] })
                }
              )
            }
          )
        ]
      },
      `${e.dispComponentNo}-item-${c + 1}`
    ) : /* @__PURE__ */ n(
      jt,
      {},
      `${e.dispComponentNo}-item-${c + 1}`
    )
  ) }) }) : /* @__PURE__ */ n(Y, {});
}, Ca = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  var w, f;
  const { componentData: i, getComponentDataList: l, wiseLogParam: s } = Ee({
    component: e
  }), c = l(), { hosts: d, tagGTM: u } = te(), [p, h] = O(0), g = Q(
    () => c.length > 0 ? c[0].relProdList.length - 1 : 0,
    [c]
  );
  return c && c.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...u(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", width: "100%", children: [
    /* @__PURE__ */ $(Ve, { space: "space-between", width: "100%", pl: 16, pr: 16, pb: 16, children: [
      /* @__PURE__ */ n(
        Ce,
        {
          variant: "headline4",
          color: we("accent_color.primary.default"),
          textAlign: "left",
          children: (w = e.componentData) == null ? void 0 : w.componentInfo.title
        }
      ),
      ((f = i == null ? void 0 : i.componentInfo) == null ? void 0 : f.useSeeMoreYn) === "Y" && /* @__PURE__ */ n(
        Ut,
        {
          onClick: () => t({
            ...i.componentInfo,
            wiseLogParam: s
          })
        }
      )
    ] }),
    /* @__PURE__ */ n(
      be,
      {
        style: { width: "100%", fontSize: 0 },
        onClick: () => t({
          ...c[0],
          wiseLogParam: s
        }),
        ...u(`${e.componentLayoutCd}_item_button`, {
          wlp: s
        }),
        children: /* @__PURE__ */ n(
          _e,
          {
            src: Te(d.hanssemMallCDN, c[0].bannerImgUrl),
            imgFit: "fill"
          }
        )
      }
    ),
    c[0].relProdList.length > 0 && /* @__PURE__ */ $(le, { alignment: "start", width: "100%", mt: 20, children: [
      /* @__PURE__ */ n(
        it,
        {
          className: Ue,
          baseWidth: 375,
          itemWidth: 142,
          pl: 16,
          pr: 16,
          gap: 8,
          isPreviewed: !0,
          data: c[0].relProdList,
          setSlideIndex: h,
          onTouchStart: (C, N) => o && o(N),
          onTouchEnd: (C, N) => r && r(N),
          onTouchCancel: a,
          children: ({ width: C, item: N }) => /* @__PURE__ */ n(
            be,
            {
              onClick: () => t({
                ...et(N.gdsDetailUrl, "REMODELING"),
                wiseLogParam: s
              }),
              ...u(`${e.componentLayoutCd}_item_button`, {
                "good-id": N.gdsNo,
                wlp: s
              }),
              children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: C, children: [
                /* @__PURE__ */ n(
                  oe,
                  {
                    width: C,
                    height: C * 95 / 142,
                    overflow: "hidden",
                    children: /* @__PURE__ */ n(
                      _e,
                      {
                        src: Te(d.hanssemMallCDN, N.imgPathL),
                        w: C,
                        h: C * 95 / 142,
                        imgFit: "cover",
                        borderRadius: "2px"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ n(
                  Ce,
                  {
                    variant: "body3",
                    color: we("accent_color.primary.default"),
                    width: "100%",
                    isNoWrap: !0,
                    lineClamp: 2,
                    textAlign: "left",
                    children: N.gdsNm
                  }
                )
              ] })
            }
          )
        }
      ),
      /* @__PURE__ */ n(oe, { width: "100%", pt: 24, pl: 16, pr: 16, children: /* @__PURE__ */ n(_a, { now: p, max: g }) })
    ] })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, _a = ce.div`
  ${({ now: e, max: t }) => Be`
    position: relative;
    width: 100%;
    height: 2px;
    background-color: #e2e2e2;
    content: ' ';
    overflow: hidden;
    display: ${t <= 1 ? "none" : "block"};
    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: ${Math.ceil(e / t * 100)}%;
      width: ${Math.ceil(1 / t * 100)}%;
      height: 2px;
      background-color: #121212;
      content: ' ';
      transition: all 0.3s ease;
    }
  `}
`, Ia = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...d(e.componentLayoutCd), children: /* @__PURE__ */ n(
    yt,
    {
      className: Ue,
      baseWidth: 375,
      baseHeight: 240,
      data: s,
      hasPagination: !0,
      onTouchStart: (u, p) => o && o(p),
      onTouchEnd: (u, p) => r && r(p),
      onTouchCancel: a,
      children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
        be,
        {
          onClick: () => t({
            ...h,
            wiseLogParam: l
          }),
          ...d(`${e.componentLayoutCd}_item_button`, {
            wlp: l
          }),
          children: /* @__PURE__ */ n(
            _e,
            {
              src: Te(c.hanssemMallCDN, h.bannerImgUrl),
              w: u,
              h: p,
              imgFit: "fill"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ n(Y, {});
}, La = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: o, wiseLogParam: r } = Ee({
    component: e
  }), a = o(), { hosts: i, tagGTM: l } = te();
  return a && a.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...l(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 20, width: "100%", pl: 16, pr: 16, children: [
    /* @__PURE__ */ $(
      Ce,
      {
        variant: "headline4",
        color: we("accent_color.primary.default"),
        textAlign: "left",
        children: [
          "인테리어, 혼자 고민 마시고",
          /* @__PURE__ */ n("br", {}),
          "한샘에서 상담하세요!"
        ]
      }
    ),
    /* @__PURE__ */ n(le, { alignment: "start", width: "100%", space: 8, children: a.map((s, c) => /* @__PURE__ */ n(
      be,
      {
        onClick: () => t({
          ...s,
          wiseLogParam: r
        }),
        ...l(`${e.componentLayoutCd}_item_button`, {
          wlp: r
        }),
        children: /* @__PURE__ */ n(
          _e,
          {
            src: Te(i.hanssemMallCDN, s.bannerImgUrl),
            imgFit: "fill"
          }
        )
      },
      `RemodelingBannerWhereStart-${e.dispComponentNo}-${c + 1}`
    )) })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, xa = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(
    ge,
    {
      space: "bottom_20",
      ...d(e.componentLayoutCd),
      children: /* @__PURE__ */ n(
        yt,
        {
          className: Ue,
          baseWidth: 375,
          baseHeight: 125,
          data: s,
          hasPagination: !0,
          isAutoPlayed: !0,
          onTouchStart: (u, p) => o && o(p),
          onTouchEnd: (u, p) => r && r(p),
          onTouchCancel: a,
          children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
            be,
            {
              onClick: () => t({
                ...h,
                wiseLogParam: l
              }),
              ...d(`${e.componentLayoutCd}_item_button`, {
                wlp: l
              }),
              children: /* @__PURE__ */ n(
                _e,
                {
                  src: Te(c.hanssemMallCDN, h.bannerImgUrl),
                  w: u,
                  h: p,
                  imgFit: "fill"
                }
              )
            }
          )
        }
      )
    }
  ) : /* @__PURE__ */ n(Y, {});
}, Na = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...d(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, children: [
    /* @__PURE__ */ n(
      Ce,
      {
        variant: "headline4",
        color: we("accent_color.primary.default"),
        pl: 16,
        pr: 16,
        textAlign: "left",
        children: "홈인테리어 스타일"
      }
    ),
    /* @__PURE__ */ n(
      it,
      {
        className: Ue,
        baseWidth: 375,
        itemWidth: 168,
        itemHeight: 224,
        pl: 16,
        pr: 16,
        gap: 8,
        isPreviewed: !0,
        data: s,
        onTouchStart: (u, p) => o && o(p),
        onTouchEnd: (u, p) => r && r(p),
        onTouchCancel: a,
        children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...h,
              wiseLogParam: l
            }),
            ...d(`${e.componentLayoutCd}_item_button`, {
              wlp: l
            }),
            children: /* @__PURE__ */ n(
              _e,
              {
                src: Te(c.hanssemMallCDN, h.bannerImgUrl),
                w: u,
                h: p,
                imgFit: "fill",
                borderRadius: "2px"
              }
            )
          }
        )
      }
    )
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, Sa = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te(), [u, p] = O(0), h = Q(() => s == null ? void 0 : s.length, [s]);
  return s && s.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...d(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", width: "100%", children: [
    /* @__PURE__ */ n(
      yt,
      {
        className: Ue,
        baseWidth: 375,
        baseHeight: 375,
        data: s,
        setSlideIndex: p,
        isAutoPlayed: !0,
        onTouchStart: (g, w) => o && o(w),
        onTouchEnd: (g, w) => r && r(w),
        onTouchCancel: a,
        children: ({ width: g, height: w, item: f }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...f,
              wiseLogParam: l
            }),
            ...d(`${e.componentLayoutCd}_item_button`, {
              wlp: l
            }),
            children: /* @__PURE__ */ n(
              _e,
              {
                src: Te(c.hanssemMallCDN, f.bannerImgUrl),
                w: g,
                h: w,
                imgFit: "fill"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ n(Ta, { now: u, max: h })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, Ta = ce.div`
  ${({ now: e, max: t }) => Be`
    position: relative;
    width: 100%;
    height: 2px;
    background-color: #e2e2e2;
    content: ' ';
    overflow: hidden;
    display: ${t <= 1 ? "none" : "block"};
    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: ${Math.ceil(1 / t * 100) * (e + 1)}%;
      height: 2px;
      background-color: #0064ff;
      content: ' ';
      transition: all 0.3s ease;
    }
  `}
`, ka = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...d(e.componentLayoutCd), children: /* @__PURE__ */ n(
    yt,
    {
      className: Ue,
      baseWidth: 375,
      baseHeight: 300,
      data: s,
      hasPagination: !0,
      isAutoPlayed: !0,
      onTouchStart: (u, p) => o && o(p),
      onTouchEnd: (u, p) => r && r(p),
      onTouchCancel: a,
      children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
        be,
        {
          onClick: () => t({
            ...h,
            wiseLogParam: l
          }),
          ...d(`${e.componentLayoutCd}_item_button`, {
            wlp: l
          }),
          children: /* @__PURE__ */ n(
            _e,
            {
              src: Te(c.hanssemMallCDN, h.bannerImgUrl),
              w: u,
              h: p,
              imgFit: "fill"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ n(Y, {});
}, Da = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(ge, { space: "none", ...d(e.componentLayoutCd), children: /* @__PURE__ */ n(
    yt,
    {
      className: Ue,
      baseWidth: 375,
      baseHeight: 240,
      data: s,
      hasPagination: !0,
      isAutoPlayed: !0,
      onTouchStart: (u, p) => o && o(p),
      onTouchEnd: (u, p) => r && r(p),
      onTouchCancel: a,
      children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
        be,
        {
          onClick: () => t({
            ...h,
            wiseLogParam: l
          }),
          ...d(`${e.componentLayoutCd}_item_button`, {
            wlp: l
          }),
          children: /* @__PURE__ */ n(
            _e,
            {
              src: Te(c.hanssemMallCDN, h.bannerImgUrl),
              w: u,
              h: p,
              imgFit: "fill"
            }
          )
        }
      )
    }
  ) }) : /* @__PURE__ */ n(Y, {});
}, $a = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  var p;
  const { componentData: i, getComponentDataList: l, wiseLogParam: s } = Ee({
    component: e
  }), c = l(), { hosts: d, tagGTM: u } = te();
  return c && c.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...u(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", width: "100%", children: [
    /* @__PURE__ */ n(oe, { width: "100%", children: /* @__PURE__ */ n(
      _e,
      {
        src: Te(d.hanssemMallCDN, c[0].bannerImgUrl),
        imgFit: "fill"
      }
    ) }),
    c.length > 1 && /* @__PURE__ */ n(oe, { width: "100%", mt: 12, children: /* @__PURE__ */ n(
      it,
      {
        className: Ue,
        baseWidth: 375,
        itemWidth: 109,
        pl: 16,
        pr: 16,
        gap: 8,
        isPreviewed: !0,
        data: c.slice(1, c.length),
        onTouchStart: (h, g) => o && o(g),
        onTouchEnd: (h, g) => r && r(g),
        onTouchCancel: a,
        children: ({ width: h, item: g }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...g,
              wiseLogParam: s
            }),
            ...u(`${e.componentLayoutCd}_item_button`, {
              wlp: s
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: h, children: [
              /* @__PURE__ */ n(oe, { width: h, height: h, overflow: "hidden", children: /* @__PURE__ */ n(
                _e,
                {
                  src: Te(
                    d.hanssemMallCDN,
                    g.bannerImgUrl
                  ),
                  w: h,
                  h,
                  imgFit: "fill",
                  borderRadius: "2px"
                }
              ) }),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "subTitle3",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  width: "100%",
                  textAlign: "left",
                  children: g.bannerNm
                }
              )
            ] })
          }
        )
      }
    ) }),
    ((p = i == null ? void 0 : i.componentInfo) == null ? void 0 : p.useSeeMoreYn) === "Y" && /* @__PURE__ */ n(oe, { pt: 20, pl: 16, pr: 16, width: "100%", children: /* @__PURE__ */ n(
      jr,
      {
        emphasis: "low",
        variant: "textIcon",
        width: "100%",
        onClick: () => t({
          ...i.componentInfo,
          wiseLogParam: s
        }),
        ...u(`${e.componentLayoutCd}_more_button`, {
          wlp: s
        }),
        children: "매장 더보기"
      }
    ) })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, Ma = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te();
  return s && s.length > 0 ? /* @__PURE__ */ n(
    ge,
    {
      space: "bottom_20",
      ...d(e.componentLayoutCd),
      children: /* @__PURE__ */ n(
        yt,
        {
          className: Ue,
          baseWidth: 375,
          baseHeight: 250,
          data: s,
          hasPagination: !0,
          isAutoPlayed: !0,
          onTouchStart: (u, p) => o && o(p),
          onTouchEnd: (u, p) => r && r(p),
          onTouchCancel: a,
          children: ({ width: u, height: p, item: h }) => /* @__PURE__ */ n(
            be,
            {
              onClick: () => t({
                ...h,
                wiseLogParam: l
              }),
              ...d(`${e.componentLayoutCd}_item_button`, {
                wlp: l
              }),
              children: /* @__PURE__ */ n(
                _e,
                {
                  src: Te(c.hanssemMallCDN, h.bannerImgUrl),
                  w: u,
                  h: p,
                  imgFit: "fill"
                }
              )
            }
          )
        }
      )
    }
  ) : /* @__PURE__ */ n(Y, {});
}, Ea = ({
  component: e,
  handleLink: t
}) => {
  var c;
  const { componentData: o, getComponentDataList: r, wiseLogParam: a } = Ee({
    component: e
  }), i = r(), { hosts: l, tagGTM: s } = te();
  return i && i.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...s(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 20, width: "100%", pl: 16, pr: 16, children: [
    /* @__PURE__ */ $(Ve, { alignment: "end", space: "space-between", width: "100%", children: [
      /* @__PURE__ */ $(
        Ce,
        {
          variant: "headline4",
          color: we("accent_color.primary.default"),
          textAlign: "left",
          children: [
            "인테리어, 어디부터 시작할지",
            /* @__PURE__ */ n("br", {}),
            "모르겠다면?"
          ]
        }
      ),
      ((c = o == null ? void 0 : o.componentInfo) == null ? void 0 : c.useSeeMoreYn) === "Y" && /* @__PURE__ */ n(
        Ut,
        {
          onClick: () => t({
            ...o.componentInfo,
            wiseLogParam: a
          }),
          ...s(`${e.componentLayoutCd}_more_button`, {
            wlp: a
          })
        }
      )
    ] }),
    /* @__PURE__ */ n(le, { alignment: "start", width: "100%", space: 8, children: i.map((d, u) => /* @__PURE__ */ n(
      be,
      {
        onClick: () => t({
          ...d,
          wiseLogParam: a
        }),
        ...s(`${e.componentLayoutCd}_item_button`, {
          wlp: a
        }),
        children: /* @__PURE__ */ n(
          _e,
          {
            src: Te(l.hanssemMallCDN, d.bannerImgUrl),
            imgFit: "fill"
          }
        )
      },
      `RemodelingBannerWhereStart-${e.dispComponentNo}-${u + 1}`
    )) })
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, Oa = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  var p, h;
  const { componentData: i, getComponentDataList: l, wiseLogParam: s } = Ee({
    component: e
  }), c = l(), { hosts: d, tagGTM: u } = te();
  return c && c.length > 0 ? /* @__PURE__ */ n(ge, { space: "default", ...u(e.componentLayoutCd), children: /* @__PURE__ */ $(le, { alignment: "start", space: 20, width: "100%", children: [
    /* @__PURE__ */ $(
      Ve,
      {
        alignment: "end",
        space: "space-between",
        width: "100%",
        pl: 16,
        pr: 16,
        children: [
          /* @__PURE__ */ n(
            Ce,
            {
              variant: "headline4",
              color: we("accent_color.primary.default"),
              textAlign: "left",
              children: (p = e.componentData) == null ? void 0 : p.componentInfo.title
            }
          ),
          ((h = i == null ? void 0 : i.componentInfo) == null ? void 0 : h.useSeeMoreYn) === "Y" && /* @__PURE__ */ n(
            Ut,
            {
              onClick: () => t({
                ...i.componentInfo,
                wiseLogParam: s
              }),
              ...u(`${e.componentLayoutCd}_more_button`, {
                wlp: s
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ n(
      it,
      {
        className: Ue,
        baseWidth: 375,
        itemWidth: 292,
        pl: 16,
        pr: 16,
        gap: 8,
        isPreviewed: !0,
        data: c,
        onTouchStart: (g, w) => o && o(w),
        onTouchEnd: (g, w) => r && r(w),
        onTouchCancel: a,
        children: ({ width: g, item: w }) => /* @__PURE__ */ n(
          be,
          {
            onClick: () => t({
              ...et(w.gdsDetailUrl, "REMODELING"),
              wiseLogParam: s
            }),
            ...u(`${e.componentLayoutCd}_item_button`, {
              "good-id": w.gdsNo,
              wlp: s
            }),
            children: /* @__PURE__ */ $(le, { alignment: "start", space: 12, width: g, children: [
              /* @__PURE__ */ n(
                oe,
                {
                  width: g,
                  height: Math.floor(g * 195 / 292),
                  overflow: "hidden",
                  children: /* @__PURE__ */ n(
                    _e,
                    {
                      src: Te(d.hanssemMallCDN, w.imgPathL),
                      w: g,
                      h: Math.floor(g * 195 / 292),
                      imgFit: "cover",
                      borderRadius: "2px"
                    }
                  )
                }
              ),
              /* @__PURE__ */ n(
                Ce,
                {
                  variant: "body3",
                  color: we("accent_color.primary.default"),
                  isNoWrap: !0,
                  lineClamp: 2,
                  width: "100%",
                  textAlign: "left",
                  children: w.gdsNm
                }
              )
            ] })
          }
        )
      }
    )
  ] }) }) : /* @__PURE__ */ n(Y, {});
}, Ra = ({ component: e, handleLink: t }) => {
  const { getComponentDataList: o } = Ee({ component: e }), r = o(), { hosts: a, tagGTM: i } = te();
  return r && r.length > 0 ? /* @__PURE__ */ n(
    ge,
    {
      space: "bottom_20",
      ...i(e.componentLayoutCd),
      children: /* @__PURE__ */ n(le, { alignment: "start", width: "100%", children: r.map((l, s) => /* @__PURE__ */ n(
        oe,
        {
          width: "100%",
          pl: 16,
          pr: 16,
          children: /* @__PURE__ */ n(
            _e,
            {
              src: Te(a.hanssemMallCDN, l.bannerImgUrl),
              imgFit: "fill"
            }
          )
        },
        `RemodelingBannerEvent-${e.dispComponentNo}-${s + 1}`
      )) })
    }
  ) : /* @__PURE__ */ n(Y, {});
}, Xt = 60, Ba = 64, Kn = ({
  component: e,
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a
}) => {
  const { getComponentDataList: i, wiseLogParam: l } = Ee({
    component: e
  }), s = i(), { hosts: c, tagGTM: d } = te(), [u, p] = O(0), [h, g] = O(null), w = (R) => {
    g(R);
  }, [f, C] = O(null), N = (R) => {
    C(R);
  }, k = Q(() => ((h == null ? void 0 : h.scrollWidth) || 0) > ((h == null ? void 0 : h.clientWidth) || 0), [h == null ? void 0 : h.clientWidth, h == null ? void 0 : h.scrollWidth]), I = Q(
    () => `${e == null ? void 0 : e.componentLayoutCd}_item_button`,
    [e == null ? void 0 : e.componentLayoutCd]
  ), A = W(() => {
    const R = f == null ? void 0 : f.querySelectorAll(`.${I}`);
    if (en(R)) return 0;
    const X = Array.from(R), U = h == null ? void 0 : h.getBoundingClientRect(), S = (U == null ? void 0 : U.width) || 0, E = (U == null ? void 0 : U.left) || 0, Z = 100 / ((X == null ? void 0 : X.length) || 0);
    return X == null ? void 0 : X.reduce((T, ee) => {
      const x = ee.getBoundingClientRect(), m = x.width, G = x.left - E, z = G <= S, q = (S - G > m ? m : S - G) / m;
      return z ? T + Z * q : T;
    }, 0);
  }, [h, f, I]), M = W(() => {
    k && p(A());
  }, [A, k]);
  return J(() => {
    h && (h.ontouchstart = (R) => {
      R.stopPropagation(), o && o(R);
    }, h.ontouchend = (R) => {
      R.stopPropagation(), r && r(R);
    }, h.ontouchcancel = (R) => {
      R.stopPropagation(), a && a(R);
    }, h.ontouchmove = (R) => {
      R.stopPropagation();
    }, h.onscroll = (R) => {
      R.stopPropagation(), M();
    });
  }, [
    h,
    M,
    a,
    r,
    o
  ]), J(() => {
    M();
  }, [M]), s && s.length > 0 ? /* @__PURE__ */ $(ge, { space: "none", ...d(e.componentLayoutCd), children: [
    /* @__PURE__ */ n(Aa, { ref: w, children: /* @__PURE__ */ n(Ua, { ref: N, children: s.map((R, X) => /* @__PURE__ */ n(
      Pa,
      {
        onClick: () => t({
          ...R,
          wiseLogParam: l
        }),
        ...d(`${e.componentLayoutCd}_item_button`, {
          wlp: l,
          "option-value": R.bannerNm
        }),
        className: `${I}`,
        hasScroll: k,
        children: /* @__PURE__ */ $(
          xe,
          {
            space: 8,
            alignment: "center",
            maxWidth: Ba,
            children: [
              /* @__PURE__ */ n(
                V,
                {
                  width: Xt,
                  height: Xt,
                  overflow: "hidden",
                  borderRadius: "50%",
                  children: /* @__PURE__ */ n(
                    _e,
                    {
                      src: Te(c.hanssemMallCDN, R.bannerImgUrl),
                      w: Xt,
                      h: Xt,
                      imgFit: "fill"
                    }
                  )
                }
              ),
              /* @__PURE__ */ n(
                Ht,
                {
                  variant: "caption1",
                  color: "color_chip.primary",
                  textAlign: "center",
                  children: R.bannerNm
                }
              )
            ]
          }
        )
      },
      `${e.dispComponentNo}-item-${X + 1}`
    )) }) }),
    /* @__PURE__ */ n(je, { space: "center", width: "100%", padding: "8px 0px", children: k && /* @__PURE__ */ n(je, { space: "center", padding: "8px 16px", width: "100%", children: /* @__PURE__ */ n(
      Vt,
      {
        percent: u,
        variant: "line1",
        width: "80px"
      }
    ) }) })
  ] }) : /* @__PURE__ */ n(Y, {});
}, Aa = ce(V)`
  width: 100%;
  padding-top: 8px;
  padding-left: 16px;
  padding-right: 16px;
  overflow-y: hidden;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-track {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    display: none;
  }

  ::-webkit-scrollbar-thumb:hover {
    display: none;
  }
`, Ua = ce.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
`, Pa = ce(be)`
  ${({ hasScroll: e }) => e && Be`
      &:last-child {
        padding-right: 16px;
      }
    `}
`, Ga = ({ handleIsOnData: e }) => {
  const [t, o] = O([]), { hosts: r, httpClient: a } = te();
  return Mn(() => {
    It(r.hanssemApiGateway, a).getPopupList.exec({ deviceType: "MOBILE" }).then((i) => {
      var l, s;
      i.code === 200 && (i != null && i.data) ? (e((((l = i == null ? void 0 : i.data) == null ? void 0 : l.popupList) || []).length > 0), o(((s = i == null ? void 0 : i.data) == null ? void 0 : s.popupList) || [])) : (e(!1), o([]));
    }).catch(() => {
      e(!1), o([]);
    });
  }), {
    data: t
  };
}, Ha = ({
  handleClick: e,
  width: t,
  height: o,
  handleIsOnData: r
}) => {
  const { data: a } = Ga({ handleIsOnData: r }), { tagGTM: i } = te();
  return a.length <= 0 ? /* @__PURE__ */ n(Y, {}) : /* @__PURE__ */ n(ge, { space: "none", ...i("app-main-popup"), children: /* @__PURE__ */ n(V, { position: "relative", children: /* @__PURE__ */ n(
    yt,
    {
      data: a,
      baseWidth: t,
      baseHeight: o,
      hasPagination: !0,
      pageIndicator: "numberStyle",
      children: ({ width: l, height: s, item: c }) => /* @__PURE__ */ n(
        V,
        {
          width: l,
          height: s,
          onClick: () => e(c.appLinkInfoDto),
          children: /* @__PURE__ */ n(Wt, { src: c.imageUrl })
        }
      )
    }
  ) }) });
}, Hl = nn(Ha), za = ({
  title: e,
  subTitle: t,
  moreView: o,
  tooltip: r,
  className: a,
  as: i,
  gtm: l
}) => {
  const { tagGTM: s } = te(), { handleClickUnit: c } = ut();
  if (!e.isUse) return /* @__PURE__ */ n(Y, {});
  const d = Q(() => {
    if (o.isUse)
      return {
        variant: "moreBtn",
        content: o.buttonName,
        handleClick: () => c(o.isNewWindow, o.appLinkInfoDto)
      };
    if (r.isUse)
      return {
        variant: "tooltip",
        content: r.title,
        message: r.desc || "",
        icon: r.iconType || "ic_question"
      };
  }, [
    c,
    o,
    r.desc,
    r.iconType,
    r.isUse,
    r.title
  ]);
  return /* @__PURE__ */ n(ge, { space: "none", children: /* @__PURE__ */ n(
    pr,
    {
      title1: e.data1,
      title2: e.data2 || "",
      rightArea: d,
      subTitle1: t.data1 || "",
      subTitle2: t.data2 || "",
      className: a,
      as: i,
      ...s(l.taggtm, {
        ...l,
        "landing-url": o.appLinkInfoDto.linkUrl
      })
    }
  ) });
}, Wa = ({ landing: e, indicator: t, gtm: o }) => {
  const { tagGTM: r } = te(), { indicatorPercent: a } = ft(), { handleClickUnit: i } = ut();
  return /* @__PURE__ */ $(ge, { space: "none", children: [
    e.isUse && /* @__PURE__ */ n(V, { width: "100%", pt: 20, pr: 16, pl: 16, children: /* @__PURE__ */ n(
      xn,
      {
        width: "100%",
        size: "lg",
        emphasis: "low",
        icon: {
          variant: "ic_arrow_right",
          align: "right"
        },
        onClick: () => i(e.isNewWindow, e.appLinkInfoDto),
        ...r(o.taggtm, {
          ...o,
          "landing-url": e.appLinkInfoDto.linkUrl
        }),
        children: e.buttonName
      }
    ) }),
    t.isUse && a !== void 0 && /* @__PURE__ */ n(
      V,
      {
        pt: 20,
        pr: 16,
        pl: 16,
        display: "flex",
        justifyContent: "center",
        ...r(o.taggtm, o),
        children: /* @__PURE__ */ n(
          Vt,
          {
            variant: "line5",
            percent: a,
            width: "80px"
          }
        )
      }
    )
  ] });
}, wn = ({ item: e }) => {
  const { tagGTM: t } = te(), { handleClickUnit: o } = ut(), { unitType: r, gtm: a } = on(), i = Q(() => {
    var l, s, c;
    return t(a.taggtm, {
      ...a,
      index: e.gtmIndex,
      "plan-id": ((l = e.appLinkInfoDto) == null ? void 0 : l.appLinkTarget) === "PLAN" ? (s = e.appLinkInfoDto) == null ? void 0 : s.appLinkVal : void 0,
      "landing-url": (c = e.appLinkInfoDto) == null ? void 0 : c.linkUrl
    });
  }, [e, a, t]);
  return /* @__PURE__ */ $(Y, { children: [
    r === "capsule" && /* @__PURE__ */ n(
      hr,
      {
        img: e.imageUrl,
        title: e.quicklinkName,
        isNewBadge: e.isHighlight,
        icon: "ic_arrow_right",
        handleClick: () => o(e.isNewWindow, e.appLinkInfoDto),
        ...i
      }
    ),
    r === "square" && /* @__PURE__ */ n(
      gr,
      {
        img: e.imageUrl,
        title: e.quicklinkName,
        isNewBadge: e.isHighlight,
        handleClick: () => o(e.isNewWindow, e.appLinkInfoDto),
        ...i
      }
    ),
    r === "circle" && /* @__PURE__ */ n(
      fr,
      {
        img: e.imageUrl,
        title: e.quicklinkName,
        isNewBadge: e.isHighlight,
        handleClick: () => o(e.isNewWindow, e.appLinkInfoDto),
        ...i
      }
    )
  ] });
}, ja = () => {
  const { setIndicatorPercent: e } = ft(), { unitType: t, quickLinkData: o, gtm: r } = on(), a = Q(() => t === "capsule", [t]);
  return /* @__PURE__ */ n(
    un,
    {
      pl: "14px",
      pr: "14px",
      setIndicatorPercentState: e,
      children: o.map((i, l) => /* @__PURE__ */ n(
        je,
        {
          width: "100%",
          alignment: "stretch",
          space: 6,
          children: o[l].map((s, c) => /* @__PURE__ */ n(
            Va,
            {
              isCapsule: a,
              children: /* @__PURE__ */ n(wn, { item: s })
            },
            `${t}-item-${r["component-id"]}-${c}`
          ))
        },
        `${r["component-id"]}-${t}-horizontal-scroller-${l}`
      ))
    }
  );
}, Va = ce(V)`
  ${({ isCapsule: e }) => !e && Be`
      max-width: 60px;
      min-width: 60px;
      width: 60px;
    `}
`, sn = ({
  componentId: e,
  size: t,
  componentGroupDataId: o
}) => {
  const r = ye(null), a = ye([]), { index: i } = ft(), { hosts: l, httpClient: s } = te(), [c, d] = O(!1), u = ye(t), p = W(
    (A) => (A = A + 1, e != null ? tn.stringify({
      componentId: e,
      page: A,
      size: t,
      componentGroupDataId: o
    }) : null),
    [e, t, o]
  ), h = W(
    (A) => It(
      l.hanssemApiGateway,
      s
    ).getTemplateInfiniteComponentsData.exec(
      tn.parse(
        A
      )
    ),
    [l.hanssemApiGateway, s]
  ), {
    data: g,
    setSize: w,
    size: f,
    isValidating: C
  } = uo(
    p,
    h,
    {
      revalidateIfStale: !1,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1,
      revalidateFirstPage: !1
    }
  ), N = Q(() => {
    if (C || !(g != null && g.length))
      return a.current;
    const A = g != null && g.map ? g == null ? void 0 : g.map((R) => R.data) : void 0, M = A == null ? void 0 : A.map((R) => R == null ? void 0 : R.map((X) => X.content));
    return M && M.length > 0 ? (a.current = (M == null ? void 0 : M.reduce((R = [], X = []) => R == null ? void 0 : R.concat(X[0]), [])) || [], a.current) : [];
  }, [g, C]), k = Q(
    () => {
      var A, M;
      return ((M = yn((A = yn(g)) == null ? void 0 : A.data)) == null ? void 0 : M.totalElements) || 0;
    },
    [g]
  ), I = W(async () => {
    N.length < Number(k) && await w(f + 1);
  }, [N.length, w, f, k]);
  return J(() => {
    r.current && u.current !== f && (u.current = f, window.setTimeout(() => {
      var A;
      (A = r.current) == null || A.clearCache();
    }, 750));
  }, [N, f]), J(() => {
    i ? window.setTimeout(() => {
      d(!0);
    }, 500) : d(!0);
  }, [i, c]), { items: N, handleMore: I, gridRef: r, loading: c, sizeData: f };
}, Fa = () => {
  const {
    horizontalType: e,
    unitType: t,
    quickLinkData: o,
    componentId: r,
    gtm: a,
    isInfinity: i
  } = on(), l = ye(!1), { items: s, handleMore: c, gridRef: d } = i && r ? sn({
    componentId: r,
    size: 20
  }) : {
    items: null,
    gridRef: null,
    handleMore: () => null
  };
  return J(() => {
    l.current = !1;
  }, []), /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(Ya, { children: /* @__PURE__ */ n(xe, { space: 10, width: "100%", children: i ? s && s.length > 0 && /* @__PURE__ */ n(Xn, { pl: "16px", pr: "16px", children: /* @__PURE__ */ n(
    cn,
    {
      list: s,
      ref: d,
      columnCount: 5,
      columnSpace: 6,
      rowSpace: 10,
      handleNextMore: () => c(),
      children: ({ item: u, index: p, fixedWidth: h }) => {
        var g;
        return l.current || ((g = d == null ? void 0 : d.current) == null || g.clearCache(), l.current = !0), /* @__PURE__ */ n(
          V,
          {
            width: `calc(${100 / e + "%"} - ${6 * (e - 1) / e}px)`,
            minWidth: h,
            maxWidth: "95.2px",
            children: /* @__PURE__ */ n(wn, { item: u })
          }
        );
      }
    }
  ) }) : o.map((u, p) => /* @__PURE__ */ n(
    Xn,
    {
      pl: "16px",
      pr: "16px",
      children: o[p].map((h, g) => /* @__PURE__ */ n(
        V,
        {
          width: `calc(${100 / e + "%"} - ${6 * (e - 1) / e}px)`,
          minWidth: "44.8px",
          maxWidth: "95.2px",
          children: /* @__PURE__ */ n(wn, { item: h })
        },
        `${a["component-id"]}-${t}-item-${g}`
      ))
    },
    `${a["component-id"]}-${t}-quick-link-vertical-content-box-${p}`
  )) }) }) });
}, Ya = ce(V)`
  display: flex;
  justify-content: center;
  width: 100%;
`, Xn = ce(V)`
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-width: 248px;
  max-width: 500px;
  gap: 6px;
`, Ka = () => {
  const { tagGTM: e } = te(), { scrollType: t, componentId: o, gtm: r } = on();
  try {
    return /* @__PURE__ */ n(ge, { space: "none", ...e(r.taggtm, r), children: t === "horizontal" ? /* @__PURE__ */ n(ja, {}) : /* @__PURE__ */ n(Fa, {}) });
  } catch (a) {
    const i = a.message;
    throw new Error(`${o}-${i}`);
  }
}, Ro = ({ componentGroupDataId: e }) => {
  const {
    horizontalType: t,
    unitType: o,
    bannerData: r,
    BannerUnit: a,
    componentId: i,
    gtm: l,
    isInfinity: s
  } = rn(), c = ye(!1), { items: d, handleMore: u, gridRef: p } = s && i ? sn({
    componentId: i,
    size: 20,
    componentGroupDataId: e
  }) : {
    items: null,
    gridRef: null,
    handleMore: () => null
  };
  return J(() => {
    c.current = !1;
  }, [e]), /* @__PURE__ */ $(Y, { children: [
    t === 1 && /* @__PURE__ */ n(xe, { space: 10, pl: 16, pr: 16, children: s ? d && d.length > 0 && /* @__PURE__ */ n(
      cn,
      {
        list: d,
        handleNextMore: () => u(),
        ref: p,
        children: ({ item: h }) => {
          var g;
          return c.current || ((g = p == null ? void 0 : p.current) == null || g.clearCache(), c.current = !0), /* @__PURE__ */ n(
            V,
            {
              width: "100%",
              pb: 10,
              children: /* @__PURE__ */ n(a, { item: h })
            },
            `${l["component-id"]}_${o}_banner_item`
          );
        }
      }
    ) : r.map((h, g) => r[g].map((w, f) => /* @__PURE__ */ n(
      Xa,
      {
        children: /* @__PURE__ */ n(a, { item: w })
      },
      `${l["component-id"]}_${o}_banner_item_${g}_${f}`
    ))) }),
    t === 2 && o === "square" && /* @__PURE__ */ n(xe, { width: "100%", space: 10, alignment: "start", pl: 16, pr: 16, children: r.map((h, g) => /* @__PURE__ */ n(
      je,
      {
        space: 10,
        width: "100%",
        children: h.map((w, f) => /* @__PURE__ */ n(
          V,
          {
            width: "calc(50% - 5px)",
            children: /* @__PURE__ */ n(a, { item: w })
          },
          `${l["component-id"]}_${o}_banner_item_${f}`
        ))
      },
      `${l["component-id"]}_${o}_banner_content_${g}`
    )) })
  ] });
}, Xa = ce(V)`
  width: 100%;
  ${({ isVertical: e }) => e && "aspect-ratio: 375 / 542;"}
`, Za = () => {
  const [e, t] = O(!1), o = W(() => {
    t(e !== !0);
  }, [e]);
  return { isBottomSheetOpen: e, handleBottomSheet: o };
}, Qa = () => {
  const { setIndicatorPercent: e } = ft(), { isBottomSheetOpen: t, handleBottomSheet: o } = Za(), { VH_100_PX: r } = yr(), {
    horizontalType: a,
    unitType: i,
    bannerData: l,
    BannerUnit: s,
    isLeftRightSpace: c,
    gtm: d
  } = rn(), u = ye(null);
  J(() => {
    u.current && u.current.resetScroll();
  }, [l]);
  const [p, h] = O("6px");
  return /* @__PURE__ */ $(Y, { children: [
    a === 1 && (i === "vertical" ? /* @__PURE__ */ n(
      pl,
      {
        baseWidth: gn,
        baseHeight: Yn[i],
        data: l[0],
        isPageIndicator: !0,
        isAutoPlayed: !0,
        children: ({ item: g, index: w }) => /* @__PURE__ */ n(V, { children: /* @__PURE__ */ n(s, { item: g }) }, `${d["component-id"]}_main_banner_item_${w}`)
      }
    ) : /* @__PURE__ */ $(Y, { children: [
      /* @__PURE__ */ n(
        oo,
        {
          isOpen: t,
          variant: "title",
          height: r - 83,
          handleClose: o,
          zIndex: 1100,
          children: /* @__PURE__ */ n(V, { overflowY: "auto", width: "100%", height: "100%", pb: "16px", children: /* @__PURE__ */ n(Ro, {}) })
        }
      ),
      /* @__PURE__ */ n(
        V,
        {
          padding: c === !0 && i === "band" || i === "thin" ? "0 16px" : "0px",
          children: /* @__PURE__ */ n(
            ms,
            {
              baseWidth: i === "thin" ? gn - 32 : gn,
              baseHeight: Yn[i],
              data: l[0],
              hasPagination: i !== "thin",
              pageIndicator: "numberPlus",
              numberIndicatorClick: o,
              isAutoPlayed: !0,
              setIndicatorPercentState: e,
              children: ({ item: g, index: w }) => /* @__PURE__ */ n(
                V,
                {
                  children: /* @__PURE__ */ n(s, { item: g })
                },
                `${d["component-id"]}_${i}_banner_item_${w}`
              )
            }
          )
        }
      )
    ] })),
    a === 1.5 && /* @__PURE__ */ n(
      ln,
      {
        baseWidth: 375,
        itemWidth: Eo,
        data: l[0],
        pl: 10,
        pr: 16,
        gap: 10,
        setIndicatorPercentState: e,
        isPreviewed: !0,
        isMoveFirstIndex: !0,
        useFixedGap: !0,
        isMaxHeight: !0,
        setSlideIndex: (g) => h(g === 0 ? "6px" : "0px"),
        children: ({ width: g, item: w, index: f }) => /* @__PURE__ */ n(
          xe,
          {
            width: g,
            space: 10,
            ml: p,
            children: l.map((C, N) => C[f] ? /* @__PURE__ */ n(
              s,
              {
                item: C[f]
              },
              `${d["component-id"]}_${i}_banner_item_${f}_${N}`
            ) : /* @__PURE__ */ n(Y, {}))
          },
          `${d["component-id"]}_${i}_banner_slide_list_content_${f}`
        )
      }
    ),
    a === 2.5 && /* @__PURE__ */ n(
      un,
      {
        pl: "16px",
        pr: "16px",
        setIndicatorPercentState: e,
        resetScrollRef: u,
        children: l.map((g, w) => /* @__PURE__ */ n(
          je,
          {
            space: 10,
            width: "100%",
            alignment: "stretch",
            children: l[w].map((f, C) => /* @__PURE__ */ n(
              V,
              {
                width: 168,
                children: /* @__PURE__ */ n(s, { item: f })
              },
              `${d["component-id"]}_${i}_banner_item_${C}_${w}`
            ))
          },
          `${d["component-id"]}_${i}_banner_horizontal_scroller_content_${w}`
        ))
      }
    )
  ] });
}, Zn = ({
  imageUrl: e,
  goodsData: t,
  currentOpenedTooltipId: o,
  setCurrentOpenedTooltipId: r
}) => /* @__PURE__ */ n(V, { width: "100%", children: /* @__PURE__ */ n(
  Ln,
  {
    img: e,
    data: t,
    zIndex: 1,
    variant: "case3",
    currentOpenedTooltipId: o,
    setCurrentOpenedTooltipId: r
  }
) }), Ja = () => {
  const { setIndicatorPercent: e } = ft(), { handleClickUnit: t } = ut(), { scrollType: o, groupData: r, componentId: a } = rn(), i = W((C) => C === "Z", []), l = W(
    (C, N) => i(C) ? "견적 상담" : N ? Dn(N) : N === 0 ? "0" : "",
    [i]
  ), s = Ze.useRef(null), c = Ze.useRef(null), d = Ze.useRef(!1), [u, p] = O(void 0), [h, g] = O(
    null
  ), w = Q(() => [...r].map((C) => {
    const N = [...C.data.content].sort((k, I) => k.positionX !== I.positionX ? k.positionX - I.positionX : k.positionY - I.positionY);
    return {
      ...C,
      data: {
        ...C.data,
        content: N
      }
    };
  }), [r]), f = Q(() => {
    var N, k, I;
    const C = (I = (k = (N = w == null ? void 0 : w[0]) == null ? void 0 : N.data) == null ? void 0 : k.content) == null ? void 0 : I[0];
    return nr(C == null ? void 0 : C.gdsNo);
  }, [w]);
  return J(() => {
    const C = new URLSearchParams(
      typeof window < "u" ? window.location.search : ""
    ), N = parseInt(C.get(`${a}si`) || "0");
    g(Number.isNaN(N) ? 0 : N);
  }, [a]), J(() => {
    if (typeof window > "u") return;
    const C = new URLSearchParams(window.location.search), N = C.get(`${a}ti`) || void 0, k = u ?? (d.current ? void 0 : N);
    p(k);
    const I = w.findIndex(
      (M) => M.data.content.some((R) => R.gdsNo.toString() === k)
    );
    k ? (C.set(`${a}ti`, k), C.set(`${a}si`, I.toString())) : (C.delete(`${a}ti`), C.delete(`${a}si`));
    const A = `${window.location.pathname}?${C.toString()}`;
    window.history.replaceState(
      {
        tooltipId: k,
        slideIndex: I
      },
      "",
      A
    );
  }, [u, a, w, d]), J(() => {
    d.current = !0;
  }, []), J(() => {
    if (new URLSearchParams(
      typeof window < "u" ? window.location.search : ""
    ).get(`${a}ti`)) return;
    const k = (A) => {
      A.forEach((M) => {
        M.isIntersecting && (p(f), c.current = setTimeout(() => {
          p(void 0);
        }, 3e3), I.unobserve(M.target));
      });
    }, I = new IntersectionObserver(k, {
      threshold: 0.5
    });
    return s.current && I.observe(s.current), () => {
      c.current && clearTimeout(c.current);
    };
  }, []), /* @__PURE__ */ $(qa, { ref: s, children: [
    o === "vertical" && /* @__PURE__ */ n(xe, { space: 10, children: w.map((C, N) => {
      const k = C.data.content.map((I) => ({
        id: I.gdsNo.toString(),
        coordinate: {
          x: I.positionX ?? 0,
          y: I.positionY ?? 0
        },
        title: I.gdsNm,
        discountRate: I.dcRate !== 0 ? I.dcRate : void 0,
        price: l(I == null ? void 0 : I.prcViewTypCd, I == null ? void 0 : I.dcPrc),
        pricePerUnit: i(I.prcViewTypCd) ? "" : I.prcViewTypNm,
        handleClick: () => t(
          C.isNewWindow,
          I.appLinkInfoDto,
          I
        )
      }));
      return /* @__PURE__ */ n(
        Zn,
        {
          imageUrl: C.imageUrl,
          goodsData: k,
          currentOpenedTooltipId: u,
          setCurrentOpenedTooltipId: p
        },
        `${a}_group_banner_item_${N}`
      );
    }) }),
    o === "horizontal" && h !== null && /* @__PURE__ */ n(xe, { alignment: "start", space: 10, children: /* @__PURE__ */ n(
      it,
      {
        baseWidth: 375,
        itemWidth: Eo,
        data: w,
        pl: 16,
        pr: 16,
        gap: 10,
        isPreviewed: !0,
        useFixedGap: !0,
        setIndicatorPercentState: e,
        initialSlide: h,
        children: ({ item: C, index: N }) => {
          const k = C.data.content.map((I) => ({
            id: I.gdsNo.toString(),
            coordinate: {
              x: I.positionX ?? 0,
              y: I.positionY ?? 0
            },
            title: I.gdsNm,
            discountRate: I.dcRate !== 0 ? I.dcRate : void 0,
            price: l(I == null ? void 0 : I.prcViewTypCd, I == null ? void 0 : I.dcPrc),
            pricePerUnit: i(I.prcViewTypCd) ? "" : I.prcViewTypNm,
            handleClick: () => t(
              C.isNewWindow,
              I.appLinkInfoDto,
              I
            )
          }));
          return /* @__PURE__ */ n(V, { children: /* @__PURE__ */ n(
            Zn,
            {
              imageUrl: C.imageUrl,
              goodsData: k,
              currentOpenedTooltipId: u,
              setCurrentOpenedTooltipId: p
            },
            `${a}_group_banner_item_${N}`
          ) }, `${a}_group_banner_item_${N}`);
        }
      }
    ) })
  ] });
}, qa = ce(V)`
  width: 100%;
`, es = () => {
  const [e, t] = O(0), [o, r] = O(!1), {
    scrollType: a,
    displayType: i,
    bannerItem: l,
    componentId: s,
    gtm: c,
    isInfinity: d,
    chipUnitType: u,
    isChipLink: p,
    isChip: h,
    selectedChip: g,
    setSelectedChip: w
  } = rn(), f = () => a === "vertical" ? /* @__PURE__ */ n(
    Ro,
    {
      componentGroupDataId: h && e || void 0
    }
  ) : /* @__PURE__ */ n(Qa, {});
  try {
    return /* @__PURE__ */ $(Y, { children: [
      i === "group" && /* @__PURE__ */ n(Ja, {}),
      i === "gallery" && /* @__PURE__ */ n(f, {}),
      h && /* @__PURE__ */ n(
        On,
        {
          type: u,
          handleSetChipIndex: w,
          chipList: l.data.content,
          mt: "4px",
          mb: "10px",
          gtm: c,
          selectedChipIndex: g,
          handleComponentId: t,
          isChipLink: p,
          isInfinity: d,
          setIsChipRender: r,
          isChipRender: o,
          children: /* @__PURE__ */ n(V, { pt: "8px", children: /* @__PURE__ */ n(f, {}) })
        }
      )
    ] });
  } catch (C) {
    const N = C.message;
    throw new Error(`${s}-${N}`);
  }
}, ts = ({
  verticalLineNumber: e,
  horizontalColumnLength: t,
  scrollDirection: o,
  unitData: r
}) => {
  const a = W(() => {
    const s = Array.from(
      { length: e },
      () => []
    );
    return r.forEach(
      (c, d) => s[d % e].push(c)
    ), s;
  }, [e, r]), i = W(() => _n(r, Math.ceil(t)), [r, t]);
  return { convertedUnitData: Q(() => (o === "vertical" ? i() : a()).slice(0, e), [
    i,
    a,
    o,
    e
  ]) };
}, ns = ({
  setIndicatorPercentState: e,
  itemLength: t
}) => (J(() => {
  if (!e) return;
  const r = Math.ceil(1 / t * 100);
  e(r);
}, [t, e]), { handleScroll: W(
  (r) => {
    if (!e) return;
    const a = Math.ceil(
      (r.snapIndex + 1) / r.snapGrid.length * 100
    );
    e(a);
  },
  [e]
) }), os = Lt, ln = ({
  id: e,
  baseWidth: t,
  gap: o,
  itemWidth: r,
  itemHeight: a = 0,
  isAutoResize: i = !0,
  isCentered: l = !1,
  isPreviewed: s = !1,
  pl: c = 0,
  pr: d = 0,
  data: u = [],
  slideIndex: p = -1,
  setSlideIndex: h,
  handleMore: g,
  onTouchStart: w,
  onTouchEnd: f,
  onTouchCancel: C,
  className: N,
  children: k,
  setIndicatorPercentState: I,
  isMoveFirstIndex: A = !1,
  useFixedGap: M,
  isMaxHeight: R = !1,
  customSwiperRef: X
}) => {
  const { handleScroll: U } = ns({
    setIndicatorPercentState: I,
    itemLength: u.length
  }), S = e || Tn(), [E, Z] = O(0), B = X || ye(null), [T, ee] = O(0), x = Q(
    () => i ? Math.floor(E * o / t) : o,
    [t, E, o, i]
  ), m = Q(
    () => i ? Math.floor(E * r / t) : r,
    [t, E, i, r]
  ), v = Q(
    () => i ? Math.floor(m * a / r) : a,
    [i, a, r, m]
  ), G = Q(() => {
    const b = i ? (E + x) / (m + x) : (t + o) / (r + o);
    return s ? b : Math.floor(b);
  }, [
    i,
    E,
    x,
    m,
    t,
    o,
    r,
    s
  ]), [z, _] = O(), [q, y] = O(!1);
  return J(() => (z && "activeIndex" in z && y(!0), () => {
    y(!1);
  }), [z]), J(() => {
    z && q && p >= 0 && z.slideTo(p + 1, 0);
  }, [u, g, q, p, z]), J(() => {
    A && z && z.slideTo(0, 0);
  }, [u]), J(() => {
    const b = () => {
      if (B.current && B.current.swiper) {
        const j = B.current.swiper.slides;
        let de = 0;
        j.forEach((se) => {
          const ie = se.clientHeight;
          ie > de && (de = ie);
        }), ee(de);
      }
    };
    return R && B.current && B.current.swiper && (B.current.swiper.on("init", b), B.current.swiper.on("imagesReady", b), B.current.swiper.on("resize", b)), () => {
      B.current && B.current.swiper && (B.current.swiper.off("init", b), B.current.swiper.off("imagesReady", b), B.current.swiper.off("resize", b));
    };
  }, []), /* @__PURE__ */ n(oe, { width: "100%", className: N, children: /* @__PURE__ */ n(
    os,
    {
      disableHeight: !0,
      onResize: ({ width: b }) => Z(b),
      children: (b) => /* @__PURE__ */ n(
        oe,
        {
          width: E,
          ...v > 0 ? { height: v } : {},
          children: /* @__PURE__ */ n(
            Ft,
            {
              spaceBetween: M ? o : x,
              ref: B,
              slidesPerView: G,
              slidesOffsetBefore: c,
              slidesOffsetAfter: d,
              centeredSlides: l,
              onSwiper: _,
              onSlideChange: ({ activeIndex: j, isEnd: de }) => {
                h && h(j), de && g && g();
              },
              edgeSwipeDetection: "prevent",
              onTouchStart: w,
              onTouchEnd: f,
              onTouchCancel: C,
              onActiveIndexChange: (j) => I && U(j),
              style: { height: T || "auto" },
              children: u.map((j, de) => /* @__PURE__ */ n(Yt, { children: k({
                width: m,
                height: v,
                index: de,
                item: j,
                isActive: de === p
              }) }, `${S}-slide-list-${de + 1}`))
            }
          )
        }
      )
    }
  ) });
}, rs = ({
  horizontalColumnLength: e,
  contentData: t,
  contentsRenderer: o,
  gtm: r
}) => {
  const [a, i] = O("6px"), { setIndicatorPercent: l } = ft(), s = ye(null);
  return J(() => {
    s.current && s.current.swiper && s.current.swiper.slideTo(0, 0);
  }, [t]), /* @__PURE__ */ $(Y, { children: [
    e === 1.5 && /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(xe, { space: 10, alignment: "start", children: /* @__PURE__ */ n(
      ln,
      {
        baseWidth: 375,
        itemWidth: ca,
        data: t[0],
        pl: 10,
        pr: 16,
        gap: 10,
        isPreviewed: !0,
        useFixedGap: !0,
        isMaxHeight: !0,
        setSlideIndex: (c) => i(c === 0 ? "6px" : "0px"),
        customSwiperRef: s,
        setIndicatorPercentState: l,
        children: ({ width: c, item: d, index: u }) => /* @__PURE__ */ n(
          xe,
          {
            width: c,
            space: 10,
            ml: a,
            children: t.map((p, h) => {
              let g = u + 1;
              return t.length > 1 && (g = h + 1, u !== 0 && (g = (u + h) * t.length, h === 0 && (g += 1))), /* @__PURE__ */ n(jt, { children: o(p[u], g) }, h);
            })
          },
          `${r["component-id"]}-horizontal_container-${u}`
        )
      }
    ) }) }),
    e === 2.5 && /* @__PURE__ */ n(
      un,
      {
        pl: "16px",
        pr: "16px",
        setIndicatorPercentState: l,
        children: t.map((c, d) => /* @__PURE__ */ n(
          je,
          {
            space: 10,
            width: "100%",
            alignment: "stretch",
            children: t[d].map((u, p) => {
              const h = d + 1 + t.length * p;
              return /* @__PURE__ */ n(
                V,
                {
                  width: la,
                  children: o(u, h)
                },
                `${r["component-id"]}-2.5-product-item-${d}-${p}`
              );
            })
          },
          `${r["component-id"]}-2.5-horizontal_scroller-${d}`
        ))
      }
    )
  ] });
}, is = ({
  contentData: e,
  isInfinity: t,
  componentId: o,
  componentGroupDataId: r,
  gtm: a,
  unitType: i,
  contentsRenderer: l,
  horizontalColumnLength: s
}) => {
  const c = ye(!1), { items: d, handleMore: u, gridRef: p, loading: h } = t && o ? sn({
    componentId: o,
    size: 20,
    componentGroupDataId: r
  }) : {
    items: null,
    handleMore: () => null,
    gridRef: null,
    loading: !1
  };
  return J(() => {
    c.current = !1;
  }, [r]), /* @__PURE__ */ n(xe, { space: i === "normal" ? 24 : 10, children: t ? h && /* @__PURE__ */ n(
    cn,
    {
      list: d,
      columnCount: 1,
      rowSpace: i === "normal" ? 24 : 10,
      handleNextMore: () => u(),
      ref: p,
      children: ({ item: g, index: w }) => {
        var f;
        return c.current || ((f = p == null ? void 0 : p.current) == null || f.clearCache(), c.current = !0), /* @__PURE__ */ n(V, { width: "100%", pl: 16, pr: 16, children: l(g, w + 1) });
      }
    }
  ) : e.map((g, w) => /* @__PURE__ */ n(
    je,
    {
      space: 10,
      width: "100%",
      alignment: "stretch",
      pl: 16,
      pr: 16,
      children: e[w].map((f, C) => {
        const N = (C || 0) + 1 + w * s;
        return /* @__PURE__ */ n(
          V,
          {
            width: s === 1 ? "100%" : "calc(50% - 5px)",
            children: l(f, N)
          },
          `${a["component-id"]}-vertical-content-item-${C}`
        );
      })
    },
    `${a["component-id"]}-vertical-content-content-${w}`
  )) });
}, On = ({
  type: e,
  handleClickChip: t,
  handleSetChipIndex: o,
  handleComponentId: r,
  setIsChipRender: a,
  chipList: i,
  mt: l,
  mb: s,
  gtm: c,
  children: d,
  selectedChipIndex: u,
  isInfinity: p,
  isChipLink: h,
  isChipRender: g
}) => {
  var x;
  const { tagGTM: w } = te(), { handleClickUnit: f } = ut(), [C, N] = O(!1), [k, I] = O(
    i[0]
  ), [A, M] = O(!1), R = W(
    () => N(!C),
    [C]
  ), X = ye(null), U = ye(null), S = ye(0), E = ye(null), Z = ye(null), B = W(
    (m, v) => {
      if (X.current && m) {
        const G = X.current.clientWidth, z = m.clientWidth, q = m.offsetLeft - G / 2 + z / 2;
        X.current.scrollTo({
          left: q,
          behavior: v ? "smooth" : "auto"
        });
      }
    },
    []
  ), T = Q(
    () => e === "filter" ? mr : wr,
    [e]
  ), ee = W(
    (m, v, G) => {
      I(m), E.current = G.currentTarget, t && t(), o && o(v), r && r(m.componentGroupDataId), p && window.scrollTo({
        top: S.current,
        behavior: "auto"
      }), C && N(!1), C || B(G.currentTarget, !0);
    },
    [
      t,
      r,
      o,
      C,
      p,
      B
    ]
  );
  return J(() => {
    !C && E.current && B(E.current);
  }, [C]), J(() => {
    i && i.length && (r && r(i[0].componentGroupDataId), window.setTimeout(() => {
      var m;
      S.current = ((m = U.current) == null ? void 0 : m.offsetTop) || 0;
    }, 300), !g && a(!0));
  }, [i, r, g, a]), J(() => {
    var z, _;
    const m = ((z = X.current) == null ? void 0 : z.scrollWidth) || 0, v = ((_ = Z.current) == null ? void 0 : _.clientWidth) || 0;
    m > v && M(!0);
    const G = () => {
      N(!1);
    };
    return window.addEventListener("touchmove", G), () => {
      M(!1), window.removeEventListener("touchmove", G);
    };
  }, []), /* @__PURE__ */ $(Y, { children: [
    /* @__PURE__ */ $(
      V,
      {
        width: "100%",
        position: p ? "sticky" : "relative",
        top: 0,
        left: 0,
        pt: l,
        pb: s,
        ref: U,
        zIndex: 999,
        backgroundColor: "color_chip.white",
        ...w(c.taggtm),
        children: [
          A && /* @__PURE__ */ $(Y, { children: [
            /* @__PURE__ */ $(
              je,
              {
                backgroundColor: "color_chip.white",
                zIndex: 1e3,
                position: "absolute",
                top: e === "filter" ? "2px" : "8px",
                right: 0,
                children: [
                  /* @__PURE__ */ n(as, {}),
                  /* @__PURE__ */ n(
                    br,
                    {
                      size: "md",
                      variant: C ? "ic_arrow_up" : "ic_arrow_down",
                      onClick: R
                    }
                  )
                ]
              }
            ),
            !C && /* @__PURE__ */ n(ss, { height: "100%", zIndex: 10 })
          ] }),
          /* @__PURE__ */ n(V, { ref: (m) => Z.current = m, children: /* @__PURE__ */ n(
            ls,
            {
              isChipListExpanded: C,
              isChipDown: A,
              ref: X,
              children: i.map((m, v) => /* @__PURE__ */ n(
                T,
                {
                  onClick: (G) => ee(m, v, G),
                  isChecked: u === v,
                  img: m.chipImageUrl,
                  flex: "0 0 auto",
                  ...w(c.taggtm, c),
                  variant: m.groupTitle1 === "전체" ? "all" : "default",
                  children: m.groupTitle1
                },
                `${c["component-id"]}-expanded-chip-content-${v}`
              ))
            }
          ) })
        ]
      }
    ),
    (k == null ? void 0 : k.imageUrl) && /* @__PURE__ */ n(V, { pb: "10px", pl: "16px", pr: "16px", width: "100%", children: /* @__PURE__ */ n(In, { img: k.imageUrl }) }),
    d,
    h && k.groupTitle1 !== "전체" && ((x = k == null ? void 0 : k.appLinkInfoDto) == null ? void 0 : x.linkUrl) && /* @__PURE__ */ n(V, { width: "100%", pt: 24, pr: 16, pl: 16, children: /* @__PURE__ */ n(
      xn,
      {
        width: "100%",
        size: "lg",
        emphasis: "low",
        icon: {
          variant: "ic_arrow_right",
          align: "right"
        },
        ...w(c.taggtm, c),
        onClick: () => f(
          k == null ? void 0 : k.isNewWindow,
          k.appLinkInfoDto
        ),
        children: k.chipLinkButtonTitle
      }
    ) })
  ] });
}, as = ce(V)`
  ${({ theme: e }) => Be`
    width: 1px;
    height: 20px;
    margin: 8px 0;
    background-color: ${e.colors.natural_color.gray[200]};
  `};
`, ss = ce(V)`
  display: flex;
  width: 100px;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    270deg,
    #ffffff 47.18%,
    rgba(255, 255, 255, 0.0677083) 94.89%,
    rgba(255, 255, 255, 0) 101.79%
  );
  pointer-events: none;
`, ls = ce(V)`
  display: flex;
  position: relative;
  gap: 8px;
  padding-left: 16px;

  ${({ isChipListExpanded: e, isChipDown: t }) => e ? Be`
          width: calc(100% - 34px);
          flex-wrap: wrap;
        ` : Be`
          width: 100%;
          padding-right: ${t ? "48px" : "0"};

          overflow-y: hidden;
          overflow-x: auto;

          ::-webkit-scrollbar {
            display: none;
          }

          ::-webkit-scrollbar-track {
            display: none;
          }

          ::-webkit-scrollbar-thumb {
            display: none;
          }

          ::-webkit-scrollbar-thumb:hover {
            display: none;
          }
        `}
`, cs = ({
  displayData: e,
  horizontalColumnLength: t,
  verticalLineNumber: o,
  unitDirection: r,
  scrollDirection: a,
  dataType: i,
  unitElement: l,
  isChip: s,
  scrapContentList: c,
  setScrapContentList: d,
  onHandleAction: u,
  isLogin: p,
  toggleScrap: h,
  unitType: g,
  ratio: w,
  gtm: f,
  componentId: C,
  chipType: N,
  isChipLink: k,
  isInfinity: I,
  contentsDataType: A
}) => {
  const [M, R] = O(0), [X, U] = O(0), [S, E] = O([]), [Z, B] = O(!1), [T, ee] = O(!1), { tagGTM: x } = te(), { handleClickUnit: m } = ut(), { convertedUnitData: v } = ts({
    verticalLineNumber: o,
    horizontalColumnLength: t,
    unitData: S,
    scrollDirection: a
  });
  J(() => {
    ee(!s), i === "default" && E(e), i === "group" && s && E(
      e[M].data.content
    );
  }, [i, e, s, M]), J(() => {
    s && Z && ee(Z);
  }, [s, Z, X]);
  const G = Q(() => {
    switch (g) {
      case "normal":
        return w === "square" ? Ir : Lr;
      case "horizontal":
        return w === "circle" ? Cr : _r;
      default:
        return vr;
    }
  }, [w, g]), z = W(
    (b, j) => (c == null ? void 0 : c.find(
      (se) => se.targetNo === b && (se == null ? void 0 : se.scrapGbnCd) === j
    )) !== void 0,
    [c]
  ), _ = W(
    async (b, j) => {
      if (!p) {
        u({
          type: "confirm",
          action: "login",
          message: `로그인 후 이용 가능합니다. 
 로그인 하시겠습니까?`
        });
        return;
      }
      const de = z(b, j);
      if (await h({
        scrapGbnCd: j,
        targetNo: b,
        targetSubNo: 0,
        isUse: !de
      }) === 200)
        if (de) {
          const ie = c.filter(
            (ke) => ke.targetNo !== b || ke.scrapGbnCd !== j
          );
          d(ie);
        } else
          u({
            type: "toast",
            action: "scrap",
            message: "스크랩이 완료되었습니다."
          }), d([
            ...c,
            { targetNo: b, targetSubNo: 0, scrapGbnCd: j }
          ]);
    },
    [
      p,
      z,
      u,
      c,
      d,
      h
    ]
  ), q = W(
    (b, j) => {
      var se;
      const de = {
        flag: b == null ? void 0 : b.tagInfo.map((ie) => ({
          variant: ie.style === "LINE" ? "line" : "solid",
          textColor: ie.textColor,
          color: ie.styleColor,
          content: ie.name
        })),
        handleClick: () => m(b.isNewWindow, b.appLinkInfoDto),
        img: b == null ? void 0 : b.imageInfo.images[0].imageUrl,
        imgFlags: b == null ? void 0 : b.imageInfo.tagInfo.map((ie) => ({
          variant: ie.variant,
          textColor: ie.textColor,
          color: ie.color,
          content: ie.content
        })),
        info1: b == null ? void 0 : b.squareMeter,
        info2: b == null ? void 0 : b.cityCountryDistrict,
        info3: b == null ? void 0 : b.planDisplayPeriod,
        profile: b != null && b.sourceName ? {
          img: b == null ? void 0 : b.sourceImageUrl,
          name: b == null ? void 0 : b.sourceName
        } : void 0,
        reviewScore: l.isReviewRating ? Bt(b == null ? void 0 : b.reviewRating).toFixed(1) : void 0,
        subTitle: b == null ? void 0 : b.contentsSubTitle,
        title: b == null ? void 0 : b.contentsTitle,
        imgs: b == null ? void 0 : b.imageInfo.images.map((ie) => ie.imageUrl),
        isShowBookmark: b != null && b.scrapGbnCode ? b == null ? void 0 : b.isScrap : !1,
        // 스크랩 어떻게 해야 할 지 체크 필요
        isCheckedBookmark: z(
          b == null ? void 0 : b.contentsNo,
          b == null ? void 0 : b.scrapGbnCode
        ),
        handleClickBookmark: () => _(b == null ? void 0 : b.contentsNo, b == null ? void 0 : b.scrapGbnCode)
      };
      return /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(
        G,
        {
          ...de,
          ...x(f.taggtm, {
            ...f,
            index: j,
            "content-id": A === "HOMEIDEA" ? b == null ? void 0 : b.contentsNo : void 0,
            "plan-id": A === "PLAN" ? b == null ? void 0 : b.contentsNo : void 0,
            "landing-url": (se = b == null ? void 0 : b.appLinkInfoDto) == null ? void 0 : se.linkUrl
          }),
          opacity: b ? 1 : 0
        },
        `${f["page-id-value"]}-${f["component-id"]}-${f["template-id"]}-${b == null ? void 0 : b.contentsNo}`
      ) });
    },
    [
      G,
      A,
      f,
      _,
      m,
      z,
      x,
      l.isReviewRating
    ]
  ), y = () => a === "horizontal" ? /* @__PURE__ */ n(
    rs,
    {
      contentData: v,
      gtm: f,
      horizontalColumnLength: t,
      contentsRenderer: q
    }
  ) : T && /* @__PURE__ */ n(
    is,
    {
      contentData: v,
      componentId: C,
      componentGroupDataId: s && X || void 0,
      isInfinity: I,
      unitType: g,
      gtm: f,
      contentsRenderer: q,
      horizontalColumnLength: t
    }
  );
  try {
    return /* @__PURE__ */ $(Y, { children: [
      s && N && /* @__PURE__ */ n(
        On,
        {
          type: N,
          handleSetChipIndex: R,
          handleComponentId: U,
          selectedChipIndex: M,
          chipList: e,
          mt: "4px",
          mb: "10px",
          gtm: f,
          isChipLink: k,
          isInfinity: I,
          setIsChipRender: B,
          isChipRender: Z,
          children: y()
        }
      ),
      !s && y()
    ] });
  } catch (b) {
    const j = b.message;
    throw new Error(`${C}-${j}`);
  }
}, qt = () => {
  const e = ye(null), {
    horizontalType: t,
    dataType: o,
    unitType: r,
    bannerType: a,
    goodsData: i,
    ProductUnit: l,
    gtm: s
  } = an();
  J(() => {
    e.current && e.current.resetScroll();
  }, [i]);
  const [c, d] = O("6px"), { setIndicatorPercent: u } = ft(), p = Q(() => o === "group" ? "scroll" : t === 1.5 ? "swipe" : "scroll", [t, o]);
  return /* @__PURE__ */ $(Y, { children: [
    p === "swipe" && /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(xe, { space: 10, alignment: "start", children: /* @__PURE__ */ n(
      ln,
      {
        baseWidth: 375,
        itemWidth: Mo,
        data: i[0],
        pl: 10,
        pr: 16,
        gap: 12,
        isPreviewed: !0,
        isMoveFirstIndex: !0,
        useFixedGap: !0,
        isMaxHeight: !0,
        setSlideIndex: (h) => d(h === 0 ? "6px" : "0px"),
        setIndicatorPercentState: u,
        children: ({ width: h, item: g, index: w }) => /* @__PURE__ */ n(
          xe,
          {
            width: h,
            space: 10,
            ml: c,
            children: i.map((f, C) => /* @__PURE__ */ n(l, { item: f[w] }, C))
          },
          `${s["component-id"]}-horizontal_container-${w}`
        )
      }
    ) }) }),
    p === "scroll" && /* @__PURE__ */ n(
      un,
      {
        pl: o === "group" && a === "BANNER" ? "12px" : "16px",
        pr: o === "group" && a === "BANNER" ? "12px" : "16px",
        verticalSpace: r === "normal" ? 24 : 10,
        resetScrollRef: e,
        setIndicatorPercentState: u,
        children: i.map((h, g) => /* @__PURE__ */ n(
          je,
          {
            space: 10,
            width: "100%",
            alignment: "stretch",
            children: i[g].map((w, f) => /* @__PURE__ */ n(
              V,
              {
                width: t === 1.5 ? sa : aa,
                children: /* @__PURE__ */ n(l, { item: w })
              },
              f
            ))
          },
          `${s["component-id"]}-2.5-horizontal_scroller-${g}`
        ))
      }
    )
  ] });
}, Bo = ({
  componentGroupDataId: e
}) => {
  const t = ye(!1), {
    horizontalType: o,
    scrollType: r,
    displayType: a,
    bannerType: i,
    goodsData: l,
    ProductUnit: s,
    gtm: c,
    componentId: d,
    isInfinity: u
  } = an(), p = a === "group", { items: h, handleMore: g, loading: w, gridRef: f } = u && d ? sn({
    componentId: d,
    size: 20,
    componentGroupDataId: e
  }) : {
    items: null,
    gridRef: null,
    handleMore: () => null,
    loading: !1
  };
  return J(() => {
    t.current = !1;
  }, [e]), /* @__PURE__ */ n(
    V,
    {
      pl: p ? 0 : 16,
      pr: p ? 0 : 16,
      ml: p && i !== "TIMER" ? 0 : 16,
      mr: p && i !== "TIMER" ? 0 : 16,
      children: u ? h && h.length > 0 && w && /* @__PURE__ */ n(
        cn,
        {
          list: h,
          ref: f,
          columnCount: o,
          columnSpace: 10,
          rowSpace: r === "vertical" ? 24 : 10,
          handleNextMore: () => g(),
          children: ({ item: C, index: N, fixedWidth: k, rowCount: I, columnIndex: A }) => {
            var R;
            t.current || ((R = f == null ? void 0 : f.current) == null || R.clearCache(), t.current = !0);
            const M = (A || 0) + N * o;
            return /* @__PURE__ */ n(V, { width: k, children: /* @__PURE__ */ n(s, { item: C, index: M }) });
          }
        }
      ) : /* @__PURE__ */ n(
        xr,
        {
          colSize: o,
          colGap: 10,
          rowGap: r === "vertical" ? 24 : 10,
          children: l.map((C, N) => l[N].map((k, I) => /* @__PURE__ */ n(
            V,
            {
              width: "100%",
              children: /* @__PURE__ */ n(s, { item: k })
            },
            `${c["component-id"]}-vertical-product-item-${I}`
          )))
        }
      )
    }
  );
}, ds = () => {
  const { setIndicatorPercent: e } = ft(), {
    horizontalType: t,
    unitType: o,
    bannerType: r,
    groupScroll: a,
    bannerData: i,
    ProductUnit: l,
    GroupBannerUnit: s,
    gtm: c
  } = an(), d = Q(() => o === "normal" ? je : xe, [o]), u = W(
    (S, E) => /* @__PURE__ */ $(
      xe,
      {
        width: "100%",
        space: 10,
        children: [
          /* @__PURE__ */ n(s, { item: S, index: E }),
          t === 2.5 || t === 1.5 ? /* @__PURE__ */ n(
            V,
            {
              width: "100%",
              backgroundColor: "color_chip.white",
              position: "relative",
              children: /* @__PURE__ */ n(qt, {})
            }
          ) : /* @__PURE__ */ n(
            d,
            {
              width: "100%",
              space: 10,
              alignment: "start",
              backgroundColor: "color_chip.white",
              position: "relative",
              children: S.data.content.map((Z, B) => /* @__PURE__ */ n(l, { item: Z, index: B }, B))
            }
          )
        ]
      },
      `${c["component-id"]}-band-banner-group-product-content-${E}`
    ),
    [c, s, t, d, l]
  ), [p, h] = O(0), [g, w] = O(0), [
    f,
    C
  ] = O(0), N = W((S) => {
    S !== null && (h(S.getBoundingClientRect().height), w(
      S.getBoundingClientRect().height / 2 - 45
    ));
  }, []), k = W(
    (S) => {
      if (S !== null) {
        let E = f;
        E < S.getBoundingClientRect().height && (E = S.getBoundingClientRect().height, C(E));
      }
    },
    [f]
  ), I = Q(() => g >= f ? p : p + f - g, [
    p,
    f,
    g
  ]), A = W(
    (S, E) => /* @__PURE__ */ $(
      V,
      {
        width: "100%",
        height: `${I}px`,
        children: [
          /* @__PURE__ */ n(us, { ref: N, children: /* @__PURE__ */ n(s, { item: S, index: E }) }),
          /* @__PURE__ */ n(
            ps,
            {
              pl: "32px",
              ref: k,
              mt: `-${g}px`,
              children: t === 2.5 || t === 1.5 ? /* @__PURE__ */ n(
                V,
                {
                  width: "100%",
                  pt: "12px",
                  backgroundColor: "color_chip.white",
                  position: "relative",
                  zIndex: 3,
                  children: /* @__PURE__ */ n(qt, {})
                }
              ) : /* @__PURE__ */ n(
                d,
                {
                  width: "100%",
                  space: 10,
                  alignment: "start",
                  pt: "12px",
                  pl: "12px",
                  backgroundColor: "color_chip.white",
                  position: "relative",
                  zIndex: 3,
                  children: S.data.content.map((Z, B) => /* @__PURE__ */ n(l, { item: Z, index: B }, B))
                }
              )
            }
          )
        ]
      },
      `${c["component-id"]}-square-banner-group-product-container-${E}`
    ),
    [
      c,
      I,
      N,
      s,
      k,
      g,
      t,
      d,
      l
    ]
  ), M = W(
    (S, E) => /* @__PURE__ */ $(
      xe,
      {
        width: "100%",
        space: 16,
        children: [
          S.timerEndDatetime && /* @__PURE__ */ n(s, { item: S, index: E }),
          t === 2.5 || t === 1.5 ? /* @__PURE__ */ n(qt, {}) : /* @__PURE__ */ n(Bo, {})
        ]
      },
      `${c["component-id"]}-timer-banner-group-product-content-${E}`
    ),
    [c, s, t]
  ), R = Q(() => {
    switch (r) {
      case "BAND_BANNER":
        return u;
      case "BANNER":
        return A;
      default:
        return M;
    }
  }, [u, A, M, r]), [X, U] = O("6px");
  return /* @__PURE__ */ n(Y, { children: a === "horizontal" && r !== "TIMER" ? /* @__PURE__ */ n(
    ln,
    {
      baseWidth: 375,
      itemWidth: Mo,
      data: i,
      pl: 10,
      pr: 16,
      gap: 10,
      isPreviewed: !0,
      isMoveFirstIndex: !0,
      useFixedGap: !0,
      isMaxHeight: !0,
      setSlideIndex: (S) => U(S === 0 ? "6px" : "0px"),
      setIndicatorPercentState: e,
      children: ({ width: S, item: E, index: Z }) => /* @__PURE__ */ n(V, { width: S, ml: X, children: R(E, Z) })
    }
  ) : /* @__PURE__ */ n(xe, { space: 24, width: "100%", children: i.map((S, E) => R(S, E)) }) });
}, us = ce(V)``, ps = ce(V)``, hs = () => {
  const [e, t] = O(0), [o, r] = O(!1), {
    scrollType: a,
    displayType: i,
    componentId: l,
    gtm: s,
    isInfinity: c,
    chipUnitType: d,
    isChipLink: u,
    isChip: p,
    selectedChip: h,
    setSelectedChip: g,
    bannerData: w
  } = an(), f = () => a === "horizontal" ? /* @__PURE__ */ n(qt, {}) : /* @__PURE__ */ n(
    Bo,
    {
      componentGroupDataId: p && e || void 0
    }
  );
  try {
    return /* @__PURE__ */ $(Y, { children: [
      i === "group" && /* @__PURE__ */ n(ds, {}),
      i === "gallery" && /* @__PURE__ */ n(f, {}),
      p && /* @__PURE__ */ n(
        On,
        {
          type: d,
          handleSetChipIndex: g,
          chipList: w,
          mt: "4px",
          mb: "10px",
          gtm: s,
          selectedChipIndex: h,
          handleComponentId: t,
          isChipLink: u,
          isChipRender: o,
          setIsChipRender: r,
          isInfinity: c,
          children: /* @__PURE__ */ n(f, {})
        }
      )
    ] });
  } catch (C) {
    const N = C.message;
    throw new Error(`${l}-${N}`);
  }
}, Ao = ({
  apiType: e = "display-info",
  handleLink: t,
  onTouchStart: o,
  onTouchEnd: r,
  onTouchCancel: a,
  dispTemplateNo: i,
  templateApiCd: l,
  ctgNo: s,
  custNo: c,
  pcId: d,
  snbCd: u,
  sort: p,
  channelCd: h,
  abTestGroup: g
}) => {
  const { template: w } = Ci({
    apiType: e,
    dispTemplateNo: i,
    templateApiCd: l,
    ctgNo: s,
    custNo: c,
    pcId: d,
    snbCd: u,
    sort: p,
    channelCd: h,
    abTestGroup: g
  });
  return /* @__PURE__ */ n(le, { alignment: "start", width: "100%", children: w == null ? void 0 : w.dispComponentList.map(
    (f, C) => /* @__PURE__ */ $(
      oe,
      {
        width: "100%",
        children: [
          f.componentLayoutCd === "interior_banner_card" && /* @__PURE__ */ n(
            Bi,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "interior_banner_list" && /* @__PURE__ */ n(
            Ai,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "interior_banner_unlimited_responsibility" && /* @__PURE__ */ n(
            Pi,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "M_MENU_TITLE_BANNER" && /* @__PURE__ */ n(
            Wi,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "APP_DOWNLOAD" && /* @__PURE__ */ n(
            ia,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_best_goods_list" && /* @__PURE__ */ n(
            da,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_new_goods_list" && /* @__PURE__ */ n(
            wa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_lineup_goods_list" && /* @__PURE__ */ n(
            fa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_part_midcate_goods_list" && /* @__PURE__ */ n(
            va,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_goods_list" && /* @__PURE__ */ n(
            ha,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_best_tag_material_goods_list" && /* @__PURE__ */ n(
            pa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_new_tag_material_goods_list" && /* @__PURE__ */ n(
            ba,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_material_cate_goods_list" && /* @__PURE__ */ n(
            ya,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_auto_material_goods_list" && /* @__PURE__ */ n(
            ma,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner+goods_list" && /* @__PURE__ */ n(
            Ca,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_big" && /* @__PURE__ */ n(
            Ia,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_consult" && /* @__PURE__ */ n(
            La,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_event" && /* @__PURE__ */ n(
            xa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_homestyle" && /* @__PURE__ */ n(
            Na,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_rolling" && /* @__PURE__ */ n(
            Sa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_rolling_event" && /* @__PURE__ */ n(
            ka,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_rolling_start" && /* @__PURE__ */ n(
            Da,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_store_info_list" && /* @__PURE__ */ n(
            $a,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_trend" && /* @__PURE__ */ n(
            Ma,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_banner_where_start" && /* @__PURE__ */ n(
            Ea,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_goods_week_new_arrival" && /* @__PURE__ */ n(
            Oa,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "remodeling_img_line_desc" && /* @__PURE__ */ n(
            Ra,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "M_MENU_TITLE_BANNER_ROLLING" && /* @__PURE__ */ n(
            Kn,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          ),
          f.componentLayoutCd === "APP_MAIN_POPUP" && /* @__PURE__ */ n(
            Kn,
            {
              component: f,
              handleLink: t,
              onTouchStart: o,
              onTouchEnd: r,
              onTouchCancel: a
            }
          )
        ]
      },
      `${w.templateApiCd}-${w.dispTemplateNo}-${f.dispComponentNo}-${C + 1}`
    )
  ) });
}, zl = ({
  module: e,
  viewType: t,
  typeValue: o,
  ...r
}) => {
  const { gnbList: a } = vi({ viewType: t, typeValue: o }), i = Q(
    () => to(a, { module: e }),
    [a, e]
  );
  return i ? /* @__PURE__ */ n(Ao, { dispTemplateNo: i.dispTemplateNo, ...r }) : /* @__PURE__ */ n(Y, {});
}, Wl = ({
  module: e,
  typeValue: t,
  ...o
}) => {
  const { templateInfo: r } = _i({ typeValue: t }), a = Q(
    () => to(r, { key: e }),
    [e, r]
  ), i = Q(() => {
    const l = { ...o };
    return a && (or(Bt(a.value)) ? l.templateApiCd = a.value : l.dispTemplateNo = a.value), l;
  }, [a, o]);
  return a ? /* @__PURE__ */ n(Ao, { ...i }) : /* @__PURE__ */ n(Y, {});
}, gs = ({
  setIndicatorPercentState: e,
  itemLength: t
}) => (J(() => {
  if (!e) return;
  const r = Math.ceil(1 / t * 100);
  e(r);
}, [t, e]), { handleScroll: W(
  (r) => {
    if (!e) return;
    const a = Math.ceil(
      (r.snapIndex + 1) / r.snapGrid.length * 100
    );
    e(a);
  },
  [e]
) }), fs = Lt, it = ({
  id: e,
  baseWidth: t,
  gap: o,
  itemWidth: r,
  itemHeight: a = 0,
  isAutoResize: i = !0,
  isCentered: l = !1,
  isPreviewed: s = !1,
  pl: c = 0,
  pr: d = 0,
  data: u = [],
  slideIndex: p = -1,
  setSlideIndex: h,
  handleMore: g,
  onTouchStart: w,
  onTouchEnd: f,
  onTouchCancel: C,
  className: N,
  children: k,
  setIndicatorPercentState: I,
  isMoveFirstIndex: A = !1,
  useFixedGap: M,
  isMaxHeight: R = !1,
  initialSlide: X = 0
}) => {
  const { handleScroll: U } = gs({
    setIndicatorPercentState: I,
    itemLength: u.length
  }), [S, E] = O(0), Z = ye(null), [B, T] = O(0), ee = Q(
    () => i ? Math.floor(S * o / t) : o,
    [t, S, o, i]
  ), x = Q(
    () => i ? Math.floor(S * r / t) : r,
    [t, S, i, r]
  ), m = Q(
    () => i ? Math.floor(x * a / r) : a,
    [i, a, r, x]
  ), v = Q(() => {
    const y = i ? (S + ee) / (x + ee) : (t + o) / (r + o);
    return s ? y : Math.floor(y);
  }, [
    i,
    S,
    ee,
    x,
    t,
    o,
    r,
    s
  ]), [G, z] = O(), [_, q] = O(!1);
  return J(() => (G && "activeIndex" in G && q(!0), () => {
    q(!1);
  }), [G]), J(() => {
    G && _ && p >= 0 && G.slideTo(p + 1, 0);
  }, [u, g, _, p, G]), J(() => {
    A && G && G.slideTo(0, 0);
  }, [u]), J(() => {
    const y = () => {
      if (Z.current && Z.current.swiper) {
        const b = Z.current.swiper.slides;
        let j = 0;
        b.forEach((de) => {
          const se = de.clientHeight;
          se > j && (j = se);
        }), T(j);
      }
    };
    return R && Z.current && Z.current.swiper && (Z.current.swiper.on("init", y), Z.current.swiper.on("imagesReady", y), Z.current.swiper.on("resize", y)), () => {
      Z.current && Z.current.swiper && (Z.current.swiper.off("init", y), Z.current.swiper.off("imagesReady", y), Z.current.swiper.off("resize", y));
    };
  }, []), /* @__PURE__ */ n(oe, { width: "100%", className: N, children: /* @__PURE__ */ n(
    fs,
    {
      disableHeight: !0,
      onResize: ({ width: y }) => E(y),
      children: (y) => /* @__PURE__ */ n(
        oe,
        {
          width: S,
          ...m > 0 ? { height: m } : {},
          children: /* @__PURE__ */ n(
            Ft,
            {
              initialSlide: X,
              spaceBetween: M ? o : ee,
              ref: Z,
              slidesPerView: v,
              slidesOffsetBefore: c,
              slidesOffsetAfter: d,
              centeredSlides: l,
              onSwiper: z,
              onSlideChange: ({ activeIndex: b, isEnd: j }) => {
                h && h(b), j && g && g();
              },
              edgeSwipeDetection: "prevent",
              onTouchStart: w,
              onTouchEnd: f,
              onTouchCancel: C,
              onActiveIndexChange: (b) => I && U(b),
              style: { height: B || "auto" },
              ...m < 1 ? { autoHeight: !0 } : {},
              children: u.map((b, j) => /* @__PURE__ */ n(Yt, { children: k({
                width: x,
                height: m,
                index: j,
                item: b,
                isActive: j === p
              }) }, `slide-list-${j + 1}`))
            }
          )
        }
      )
    }
  ) });
}, Uo = ({
  setIndicatorPercentState: e,
  itemLength: t
}) => (J(() => {
  if (!e) return;
  const r = Math.ceil(1 / t * 100);
  e(r);
}, [t, e]), { handleScroll: W(
  (r) => {
    if (!e) return;
    const a = Math.ceil((r.realIndex + 1) / t * 100);
    e(a);
  },
  [t, e]
) }), ys = Lt, yt = ({
  id: e,
  baseWidth: t,
  baseHeight: o,
  data: r = [],
  slideIndex: a = -1,
  setSlideIndex: i,
  hasPagination: l = !1,
  canZoom: s = !1,
  isCentered: c = !1,
  isAutoPlayed: d = !1,
  autoMs: u = 5e3,
  onTouchStart: p,
  onTouchEnd: h,
  onTouchCancel: g,
  className: w,
  children: f,
  pageIndicator: C = "number",
  numberIndicatorClick: N,
  setIndicatorPercentState: k
}) => {
  const { handleScroll: I } = Uo({
    setIndicatorPercentState: k,
    itemLength: r.length
  }), A = e || Tn(), [M, R] = O(0), X = Q(
    () => Math.ceil(o * M / t),
    [o, t, M]
  ), [U, S] = O(a + 1), [E, Z] = O(), [B, T] = O(!1);
  J(() => (E && "activeIndex" in E && T(!0), () => {
    T(!1);
  }), [E]), J(() => {
    E && B && (d && E.autoplay.start(), a >= 0 && E.slideTo(a + 1, 0));
  }, [r, B, a, E, d]);
  const ee = (x) => {
    if (x === "number")
      return /* @__PURE__ */ n(V, { position: "absolute", bottom: 12, right: 12, zIndex: 1, children: /* @__PURE__ */ n(
        Rt,
        {
          variant: "number",
          current: U === 0 ? 1 : U,
          total: r.length
        }
      ) });
    if (x === "numberPlus")
      return /* @__PURE__ */ n(V, { position: "absolute", bottom: 12, right: 12, zIndex: 1, children: /* @__PURE__ */ n(
        Rt,
        {
          variant: "number_icon",
          current: U === 0 ? 1 : U,
          total: r.length,
          onClick: N
        }
      ) });
    if (x === "line")
      return /* @__PURE__ */ n(V, { position: "relative", zIndex: 1, children: /* @__PURE__ */ n(
        Vt,
        {
          variant: "line1",
          percent: U / r.length * 100
        }
      ) });
    if (x === "numberStyle")
      return /* @__PURE__ */ n(
        V,
        {
          position: "absolute",
          bottom: "16px",
          left: "50%",
          zIndex: 1,
          style: {
            transform: "translateX(-50%)"
          },
          children: /* @__PURE__ */ n(
            Rt,
            {
              variant: "number",
              current: U === 0 ? 1 : U,
              total: r.length
            }
          )
        }
      );
  };
  return /* @__PURE__ */ $(V, { width: "100%", position: "relative", className: w, children: [
    /* @__PURE__ */ n(
      ys,
      {
        disableHeight: !0,
        onResize: ({ width: x }) => R(x),
        children: (x) => /* @__PURE__ */ n(V, { width: M, children: /* @__PURE__ */ n(
          Ft,
          {
            modules: [kn],
            spaceBetween: 0,
            slidesPerView: 1,
            zoom: s,
            centeredSlides: c,
            onSwiper: Z,
            onSlideChange: ({ activeIndex: m }) => {
              const v = m % r.length < 1 ? r.length : m % r.length;
              i && i(v - 1), S(v);
            },
            loop: r.length > 1,
            autoplay: {
              delay: u,
              disableOnInteraction: !1
            },
            edgeSwipeDetection: "prevent",
            onTouchStart: p,
            onTouchEnd: h,
            onTouchCancel: g,
            onActiveIndexChange: (m) => k && I(m),
            children: r.map((m, v) => /* @__PURE__ */ n(Yt, { children: f({
              width: M,
              height: X,
              index: v,
              item: m
            }) }, `${A}-slide-box-${v + 1}`))
          }
        ) })
      }
    ),
    l && r.length > 1 && ee(C)
  ] });
}, ms = ({
  id: e,
  baseWidth: t,
  baseHeight: o,
  data: r = [],
  slideIndex: a = -1,
  hasPagination: i = !1,
  canZoom: l = !1,
  isCentered: s = !1,
  isAutoPlayed: c = !1,
  autoMs: d = 5e3,
  onTouchStart: u,
  onTouchEnd: p,
  onTouchCancel: h,
  className: g,
  children: w,
  pageIndicator: f = "number",
  numberIndicatorClick: C,
  setIndicatorPercentState: N
}) => {
  const { handleScroll: k } = Uo({
    setIndicatorPercentState: N,
    itemLength: r.length
  }), [I, A] = O(a + 1), [M, R] = O(), [X, U] = O(!1);
  J(() => (M && "activeIndex" in M && U(!0), () => {
    U(!1);
  }), [M]), J(() => {
    M && X && c && M.autoplay.start();
  }, [r, X, a, M, c]);
  const S = (E) => {
    if (E === "number")
      return /* @__PURE__ */ n(V, { position: "absolute", bottom: 12, right: 12, zIndex: 1, children: /* @__PURE__ */ n(
        Rt,
        {
          variant: "number",
          current: I === 0 ? 1 : I,
          total: r.length
        }
      ) });
    if (E === "numberPlus")
      return /* @__PURE__ */ n(V, { position: "absolute", bottom: 12, right: 12, zIndex: 1, children: /* @__PURE__ */ n(
        Rt,
        {
          variant: "number_icon",
          current: I === 0 ? 1 : I,
          total: r.length,
          onClick: C
        }
      ) });
    if (E === "line")
      return /* @__PURE__ */ n(V, { position: "relative", zIndex: 1, children: /* @__PURE__ */ n(
        Vt,
        {
          variant: "line1",
          percent: I / r.length * 100
        }
      ) });
    if (E === "numberStyle")
      return /* @__PURE__ */ n(
        V,
        {
          position: "absolute",
          bottom: "16px",
          left: "50%",
          zIndex: 1,
          style: {
            transform: "translateX(-50%)"
          },
          children: /* @__PURE__ */ n(
            Rt,
            {
              variant: "number",
              current: I === 0 ? 1 : I,
              total: r.length
            }
          )
        }
      );
  };
  return /* @__PURE__ */ $(V, { width: "100%", position: "relative", className: g, children: [
    /* @__PURE__ */ n(ws, { aspectRatio: t / o, children: /* @__PURE__ */ n(
      Ft,
      {
        initialSlide: 0,
        modules: [kn],
        spaceBetween: 0,
        slidesPerView: 1,
        zoom: l,
        centeredSlides: s,
        onSwiper: R,
        onSlideChange: ({ activeIndex: E }) => {
          const Z = r.length;
          A(E % Z + 1);
        },
        loop: r.length > 1,
        autoplay: c ? {
          delay: d,
          disableOnInteraction: !1
        } : void 0,
        loopedSlides: r.length,
        edgeSwipeDetection: "prevent",
        onTouchStart: u,
        onTouchEnd: p,
        onTouchCancel: h,
        onActiveIndexChange: (E) => N && k(E),
        children: r.map((E, Z) => /* @__PURE__ */ n(Yt, { children: w({
          width: t,
          height: o,
          index: Z,
          item: E
        }) }, `${e}-slide-box-${Z + 1}`))
      }
    ) }),
    i && r.length > 1 && S(f)
  ] });
}, ws = ce(V)`
  aspect-ratio: ${({ aspectRatio: e }) => e};
  overflow: hidden;
`, bs = Lt, vs = bo, Cs = wo, Qn = fo, _s = yo, Is = mo;
function Ls({
  isElement: e = !1,
  elementContainerRef: t,
  columnCount: o = 1,
  columnSpace: r = 0,
  rowSpace: a = 0,
  list: i = [],
  handleNextMore: l = () => {
  },
  children: s,
  onScroll: c
}, d) {
  const u = Q(() => o <= 1, [o]), p = Q(
    () => new go({
      fixedWidth: !0,
      defaultWidth: 1,
      defaultHeight: 1
    }),
    []
  ), [h, g] = O(0), w = W(
    ({ index: ee }) => ee < h - 1,
    [h]
  ), [f, C] = O(!1), N = W(async () => {
    f || (C(!0), l(), C(!1));
  }, [l, f]), [k, I] = O(0), [A, M] = O(0), R = W(
    ({ width: ee }) => {
      var x;
      I(ee), M((ee - r * (o - 1)) / o), (x = S.current) == null || x.recomputeGridSize();
    },
    [o, r]
  ), X = W(
    (ee) => {
      const { key: x, index: m, parent: v, style: G } = ee;
      return /* @__PURE__ */ n(
        Qn,
        {
          parent: v,
          columnIndex: 0,
          rowIndex: m,
          cache: p,
          children: ({ measure: z, registerChild: _ }) => /* @__PURE__ */ n(
            "div",
            {
              ref: _,
              style: {
                ...G,
                paddingBottom: m === h - 1 ? 0 : a
              },
              children: /* @__PURE__ */ n(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: m < i.length && /* @__PURE__ */ n(Y, { children: s({
                    ...ee,
                    measure: z,
                    item: i[m],
                    containerWidth: k,
                    fixedWidth: A,
                    rowCount: h
                  }) })
                }
              )
            }
          )
        },
        x
      );
    },
    [p, s, k, A, i, h, a]
  ), U = W(
    (ee) => {
      const { key: x, rowIndex: m, parent: v, columnIndex: G, style: z } = ee, _ = m * o + G;
      return /* @__PURE__ */ n(
        Qn,
        {
          parent: v,
          columnIndex: G,
          rowIndex: m,
          cache: p,
          children: ({ measure: q, registerChild: y }) => /* @__PURE__ */ n(
            "div",
            {
              ref: y,
              style: {
                ...z,
                paddingRight: r,
                paddingBottom: m === h - 1 ? 0 : a
              },
              children: /* @__PURE__ */ n(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: _ < i.length && /* @__PURE__ */ n(Y, { children: s({
                    ...ee,
                    measure: q,
                    item: i[_],
                    containerWidth: k,
                    fixedWidth: A,
                    index: m,
                    rowCount: h
                  }) })
                }
              )
            }
          )
        },
        x
      );
    },
    [
      p,
      s,
      o,
      r,
      k,
      A,
      i,
      h,
      a
    ]
  ), S = ye(void 0), [E, Z] = O();
  J(() => {
    i.length > 0 && g(u ? i.length : Math.ceil(i.length / o));
  }, [o, u, i.length]);
  const B = Q(
    () => /* @__PURE__ */ n(
      _s,
      {
        isRowLoaded: w,
        loadMoreRows: N,
        rowCount: h,
        threshold: 1,
        children: ({ onRowsRendered: ee, registerChild: x }) => /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(Is, { scrollElement: E, onScroll: c, children: ({ height: m, isScrolling: v, onChildScroll: G, scrollTop: z }) => /* @__PURE__ */ n(bs, { height: m, disableHeight: !0, onResize: R, children: ({ width: _ }) => u ? /* @__PURE__ */ n(
          Cs,
          {
            autoHeight: !0,
            width: _,
            height: m,
            isScrolling: v,
            onScroll: (q) => G(q),
            scrollTop: z,
            rowHeight: p.rowHeight,
            rowCount: h,
            rowRenderer: X,
            deferredMeasurementCache: p,
            style: {
              outline: "none",
              overflowX: "hidden"
            },
            ref: (q) => {
              x(q);
            },
            onRowsRendered: ee
          }
        ) : /* @__PURE__ */ n(
          vs,
          {
            autoHeight: !0,
            width: _,
            height: m,
            isScrolling: v,
            onScroll: (q) => G(q),
            scrollTop: z,
            ref: (q) => {
              S.current = q, x(q);
            },
            columnWidth: A + r,
            rowHeight: p.rowHeight,
            columnCount: o,
            rowCount: h,
            cellRenderer: U,
            deferredMeasurementCache: p,
            onSectionRendered: ({
              rowStartIndex: q,
              rowStopIndex: y
            }) => {
              ee({
                startIndex: q,
                stopIndex: y
              });
            },
            style: {
              outline: "none",
              overflowX: "hidden"
            }
          }
        ) }) }) })
      }
    ),
    [
      p,
      U,
      o,
      r,
      E,
      A,
      u,
      w,
      N,
      R,
      c,
      h,
      X
    ]
  ), T = W(() => {
    p.clearAll();
  }, [p]);
  return qn(d, () => ({
    clearCache: T
  })), e ? /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ n(
        "div",
        {
          ref: (ee) => {
            Z(ee), t == null || t(ee);
          },
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "auto"
          },
          children: B
        }
      )
    }
  ) : /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: "100%",
        height: "100%"
      },
      children: B
    }
  );
}
const Po = Cn(Ls), xs = Lt, Ns = bo, Ss = wo, Jn = fo, Ts = yo, ks = mo;
function Ds({
  isElement: e = !1,
  elementContainerRef: t,
  columnCount: o = 1,
  columnSpace: r = 0,
  rowSpace: a = 0,
  list: i = [],
  handleNextMore: l = () => {
  },
  children: s,
  onScroll: c,
  cacheClearEffectDeps: d = []
}) {
  const u = ye(void 0), [p, h] = O(), [g, w] = O(0), [f, C] = O(!0), [N, k] = O(0), [I, A] = O(0), [M, R] = O({ index: 0 }), X = Q(() => o <= 1, [o]), U = Q(
    () => new go({
      fixedWidth: !0,
      defaultHeight: 100
    }),
    []
  ), S = W(
    ({ index: m }) => m < g - 1,
    [g]
  ), E = W(async () => {
    f || (C(!0), l());
  }, [l, f]);
  J(() => {
    S(M) && f && C(!1);
  }, [M, f, S]);
  const Z = W(
    ({ width: m }) => {
      var v;
      k(m), A((m - r * (o - 1)) / o), U.clearAll(), (v = u.current) == null || v.recomputeGridSize();
    },
    [U, o, r]
  ), B = W(
    (m) => {
      const { key: v, index: G, parent: z, style: _ } = m;
      return /* @__PURE__ */ n(
        Jn,
        {
          parent: z,
          columnIndex: 0,
          rowIndex: G,
          cache: U,
          children: ({ measure: q, registerChild: y }) => /* @__PURE__ */ n(
            "div",
            {
              ref: y,
              style: {
                ..._,
                paddingBottom: G === g - 1 ? 0 : a
              },
              children: /* @__PURE__ */ n(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: G < i.length && /* @__PURE__ */ n(Y, { children: s({
                    ...m,
                    measure: q,
                    item: i[G],
                    containerWidth: N,
                    fixedWidth: I,
                    rowCount: g
                  }) })
                }
              )
            }
          )
        },
        v
      );
    },
    [U, s, N, I, i, g, a]
  ), T = W(
    (m) => {
      const { key: v, rowIndex: G, parent: z, columnIndex: _, style: q } = m, y = G * o + _;
      return /* @__PURE__ */ n(
        Jn,
        {
          parent: z,
          columnIndex: _,
          rowIndex: G,
          cache: U,
          children: ({ measure: b, registerChild: j }) => /* @__PURE__ */ n(
            "div",
            {
              ref: j,
              style: {
                ...q,
                paddingRight: r,
                paddingBottom: G === g - 1 ? 0 : a
              },
              children: /* @__PURE__ */ n(
                "div",
                {
                  style: {
                    width: "100%",
                    height: "100%"
                  },
                  children: y < i.length && /* @__PURE__ */ n(Y, { children: s({
                    ...m,
                    measure: b,
                    item: i[y],
                    containerWidth: N,
                    fixedWidth: I,
                    index: G,
                    rowCount: g
                  }) })
                }
              )
            }
          )
        },
        v
      );
    },
    [
      U,
      s,
      o,
      r,
      N,
      I,
      i,
      g,
      a
    ]
  ), ee = W(() => {
    (d == null ? void 0 : d.length) > 0 && setTimeout(() => {
      U.clearAll();
    }, 0);
  }, [U, d == null ? void 0 : d.length]);
  J(() => {
    i.length > 0 && w(X ? i.length : Math.ceil(i.length / o));
  }, [o, X, i.length]), J(() => {
    ee();
  }, [...d]);
  const x = Q(
    () => /* @__PURE__ */ n(Y, { children: en(i) ? /* @__PURE__ */ n(Y, {}) : /* @__PURE__ */ n(
      Ts,
      {
        isRowLoaded: (m) => (R(m), S(m)),
        loadMoreRows: E,
        rowCount: g,
        threshold: 1,
        children: ({ onRowsRendered: m, registerChild: v }) => /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(
          ks,
          {
            scrollElement: p,
            onScroll: c,
            children: ({ height: G, isScrolling: z, onChildScroll: _, scrollTop: q }) => /* @__PURE__ */ n(
              xs,
              {
                height: G,
                disableHeight: !0,
                onResize: Z,
                children: ({ width: y }) => X ? /* @__PURE__ */ n(
                  Ss,
                  {
                    autoHeight: !0,
                    width: y,
                    height: G,
                    onScroll: (b) => _(b),
                    scrollTop: q,
                    rowHeight: U.rowHeight,
                    rowCount: g,
                    rowRenderer: B,
                    style: {
                      outline: "none",
                      overflowX: "hidden"
                    },
                    ref: (b) => {
                      v(b);
                    },
                    onRowsRendered: m
                  }
                ) : /* @__PURE__ */ n(
                  Ns,
                  {
                    autoHeight: !0,
                    width: y,
                    height: G,
                    isScrolling: z,
                    onScroll: (b) => _(b),
                    scrollTop: q,
                    ref: (b) => {
                      u.current = b, v(b);
                    },
                    columnWidth: I + r,
                    columnCount: o,
                    rowHeight: U.rowHeight,
                    rowCount: g,
                    cellRenderer: T,
                    onSectionRendered: ({
                      rowStartIndex: b,
                      rowStopIndex: j
                    }) => {
                      m({
                        startIndex: b,
                        stopIndex: j
                      });
                    },
                    style: {
                      outline: "none",
                      overflowX: "hidden"
                    }
                  }
                )
              }
            )
          }
        ) })
      }
    ) }),
    [
      U.rowHeight,
      T,
      o,
      r,
      p,
      I,
      Z,
      X,
      S,
      i,
      E,
      c,
      g,
      B
    ]
  );
  return e ? /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ n(
        "div",
        {
          ref: (m) => {
            h(m), t == null || t(m);
          },
          style: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflowX: "hidden",
            overflowY: "auto"
          },
          children: x
        }
      )
    }
  ) : /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: "100%",
        height: "100%"
      },
      children: x
    }
  );
}
const cn = Cn(Ds), $s = Ze.createContext({}), Go = !0;
function Ms({ baseColor: e, highlightColor: t, width: o, height: r, borderRadius: a, circle: i, direction: l, duration: s, enableAnimation: c = Go, customHighlightBackground: d }) {
  const u = {};
  return l === "rtl" && (u["--animation-direction"] = "reverse"), typeof s == "number" && (u["--animation-duration"] = `${s}s`), c || (u["--pseudo-element-display"] = "none"), (typeof o == "string" || typeof o == "number") && (u.width = o), (typeof r == "string" || typeof r == "number") && (u.height = r), (typeof a == "string" || typeof a == "number") && (u.borderRadius = a), i && (u.borderRadius = "50%"), typeof e < "u" && (u["--base-color"] = e), typeof t < "u" && (u["--highlight-color"] = t), typeof d == "string" && (u["--custom-highlight-background"] = d), u;
}
function Es({ count: e = 1, wrapper: t, className: o, containerClassName: r, containerTestId: a, circle: i = !1, style: l, ...s }) {
  var c, d, u;
  const p = Ze.useContext($s), h = { ...s };
  for (const [I, A] of Object.entries(s))
    typeof A > "u" && delete h[I];
  const g = {
    ...p,
    ...h,
    circle: i
  }, w = {
    ...l,
    ...Ms(g)
  };
  let f = "react-loading-skeleton";
  o && (f += ` ${o}`);
  const C = (c = g.inline) !== null && c !== void 0 ? c : !1, N = [], k = Math.ceil(e);
  for (let I = 0; I < k; I++) {
    let A = w;
    if (k > e && I === k - 1) {
      const R = (d = A.width) !== null && d !== void 0 ? d : "100%", X = e % 1, U = typeof R == "number" ? R * X : `calc(${R} * ${X})`;
      A = { ...A, width: U };
    }
    const M = Ze.createElement("span", { className: f, style: A, key: I }, "‌");
    C ? N.push(M) : N.push(Ze.createElement(
      Ze.Fragment,
      { key: I },
      M,
      Ze.createElement("br", null)
    ));
  }
  return Ze.createElement("span", { className: r, "data-testid": a, "aria-live": "polite", "aria-busy": (u = g.enableAnimation) !== null && u !== void 0 ? u : Go }, t ? N.map((I, A) => Ze.createElement(t, { key: A }, I)) : N);
}
function Os({
  isSkeleton: e,
  children: t,
  containerStyle: o,
  containerW100P: r,
  containerH100P: a,
  containerWH100P: i,
  className: l,
  style: s,
  borderRadius: c = 0,
  ...d
}) {
  const u = Q(() => i ? {
    width: "100%",
    height: "100%"
  } : r ? {
    width: "100%"
  } : a ? {
    height: "100%"
  } : {}, [a, r, i]);
  return e ? /* @__PURE__ */ n(
    Rs,
    {
      style: {
        ...u,
        ...o,
        borderRadius: c
      },
      className: l,
      children: /* @__PURE__ */ n(
        Es,
        {
          style: {
            display: "flex",
            alignItems: "center",
            ...s,
            borderRadius: c
          },
          ...d
        }
      )
    }
  ) : /* @__PURE__ */ n(Y, { children: t });
}
const Rs = ce.div`
  display: inline-block;
`;
function Bs(e) {
  return (t) => {
    e.forEach((o) => {
      typeof o == "function" ? o(t) : o != null && (o.current = t);
    });
  };
}
const As = ({ imgFit: e, w: t, h: o, q: r, src: a, imageScale: i = 1, ...l }, s) => {
  const c = ye(null), d = Bs([s, c]), [u, p] = O(!1), [h, g] = O(!1), w = W(
    (C) => {
      var N;
      p(!0), g(!1), (N = l == null ? void 0 : l.onLoad) == null || N.call(l, C);
    },
    [l]
  ), f = W(
    (C) => {
      var N;
      p(!1), g(!0), (N = l == null ? void 0 : l.onError) == null || N.call(l, C);
    },
    [l]
  );
  return /* @__PURE__ */ n(
    "div",
    {
      style: {
        width: t || "100%",
        height: o || "100%",
        boxSizing: "border-box"
      },
      children: /* @__PURE__ */ $(
        "div",
        {
          style: {
            width: t || "100%",
            height: o || "100%",
            position: "relative"
          },
          children: [
            /* @__PURE__ */ n(
              Os,
              {
                isSkeleton: !u,
                duration: h ? 0 : void 0,
                style: {
                  width: t || "100%",
                  height: o || "100%"
                },
                containerStyle: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: t || "100%",
                  height: o || "100%"
                }
              }
            ),
            !h && /* @__PURE__ */ n(
              Ps,
              {
                ...l,
                ref: d,
                src: Pr({
                  url: a || "",
                  w: t && t * i,
                  h: o && o * i,
                  q: r
                }),
                imgFit: e,
                onLoad: w,
                onError: f
              }
            ),
            h && /* @__PURE__ */ n(
              "div",
              {
                style: {
                  width: t || "100%",
                  height: o || "100%",
                  backgroundColor: "#efefef"
                }
              }
            )
          ]
        }
      )
    }
  );
}, Wt = nn(Cn(As)), Us = ce.img`
  ${({ imgFit: e }) => Be`
    width: 100%;
    height: 100%;
    object-fit: ${e};
  `}
`, Ps = nn(Us), dn = 99, Ho = dn + 10, zo = 71, Rn = 60, Gs = 48, jl = ({
  isShow: e,
  children: t,
  noFixed: o,
  ...r
}) => /* @__PURE__ */ n(zs, { isShow: e, ...r, children: /* @__PURE__ */ n(Hs, { isShow: e, noFixed: o, children: t }) }), Hs = ce.div`
  ${({ isShow: e, theme: t, noFixed: o }) => Be`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: ${e ? `${zo}px` : "0px"};
    opacity: ${e ? 1 : 0};
    ${!o && Be`
      z-index: ${Ho};
    `}

    transition: all 0.3s;
    background: ${t.colors.natural_color.white};
    border-top: solid 1px ${t.colors.natural_color.gray[200]};
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`, zs = ce(oe)`
  ${({ isShow: e }) => Be`
    padding-bottom: ${e ? `${zo}px` : "0px"};
  `}
`, Ws = () => {
  const [e, t] = O(!1), [o, r] = O(!1), a = ye(0), i = W((d) => {
    a.current = d.clientX, t(!0);
  }, []), l = W(
    () => (
      // NOTE: need some delay so item under cursor won't be clicked
      window.requestAnimationFrame(() => {
        r(!1), t(!1);
      })
    ),
    []
  ), s = W(
    (d, u) => {
      const p = a.current - d.clientX, h = Math.abs(p) > 5;
      e && h && r(!0), o && h && (a.current = d.clientX, u(p));
    },
    [e, o]
  ), c = W(
    ({ scrollContainer: d }) => (u) => s(u, (p) => {
      d.current && (d.current.scrollLeft += p);
    }),
    [s]
  );
  return {
    dragStart: i,
    dragStop: l,
    isDragging: o,
    handleDrag: c
  };
}, js = () => ({
  handleWheel: W(
    (t, o) => {
      o.deltaY < 0 ? t.scrollNext() : o.deltaY > 0 && t.scrollPrev();
    },
    []
  )
});
var bn = { exports: {} };
(function(e, t) {
  (function(o, r) {
    r(t, Ze);
  })(xi, function(o, r) {
    function a(L) {
      return L && typeof L == "object" && "default" in L ? L : { default: L };
    }
    var i = a(r);
    (function(L, D) {
      D === void 0 && (D = {});
      var H = D.insertAt;
      if (typeof document < "u") {
        var F = document.head || document.getElementsByTagName("head")[0], P = document.createElement("style");
        P.type = "text/css", H === "top" && F.firstChild ? F.insertBefore(P, F.firstChild) : F.appendChild(P), P.styleSheet ? P.styleSheet.cssText = L : P.appendChild(document.createTextNode(L));
      }
    })(`.react-horizontal-scrolling-menu--scroll-container {
  display: flex;
  height: max-content;
  overflow-y: hidden;
  position: relative;
  width: 100%;
}

.react-horizontal-scrolling-menu--scroll-container.rtl {
  direction: rtl;
}

.react-horizontal-scrolling-menu--inner-wrapper {
  display: flex;
  overflow-y: hidden;
}

.react-horizontal-scrolling-menu--wrapper {
  display: flex;
  flex-direction: column;
}

.react-horizontal-scrolling-menu--header,
.react-horizontal-scrolling-menu--footer {
  width: 100%;
}

.react-horizontal-scrolling-menu--arrow-left,
.react-horizontal-scrolling-menu--arrow-right {
  display: flex;
}
`);
    const l = "react-horizontal-scrolling-menu", s = "-separator", c = `${l}-${s}`, d = `${l}--item`, u = `${l}--scroll-container`, p = `${l}--wrapper`, h = `${l}--inner-wrapper`, g = `${l}--header`, w = `${l}--arrow-left`, f = `${l}--arrow-right`, C = `${l}--footer`, N = "itemId", k = "data-key", I = "data-index";
    var A = Object.freeze({ __proto__: null, rootClassName: l, separatorString: s, separatorClassName: c, itemClassName: d, scrollContainerClassName: u, wrapperClassName: p, innerWrapperClassName: h, headerClassName: g, arrowLeftClassName: w, arrowRightClassName: f, footerClassName: C, id: N, dataKeyAttribute: k, dataIndexAttribute: I });
    function M({ className: L = "", children: D, onScroll: H = () => {
    }, scrollRef: F }) {
      const P = i.default.useMemo(() => `${u} ${L}`, [L]);
      return i.default.createElement("div", { className: P, onScroll: H, ref: F }, D);
    }
    var R = i.default.memo(function({ className: L, id: D, index: H, refs: F }) {
      const P = i.default.useRef(null);
      return F[H] = P, i.default.createElement("div", Object.assign({ className: L }, { [k]: D, [I]: H }, { ref: P }));
    }), X = i.default.memo(function({ children: L, className: D, id: H, index: F, refs: P }) {
      const K = i.default.useRef(null);
      return P[String(F)] = K, i.default.createElement("div", Object.assign({ className: D }, { [k]: H, [I]: F }, { ref: K }), L);
    });
    function U(L) {
      return typeof L == "object" && L != null && L.nodeType === 1;
    }
    function S(L, D) {
      return (!D || L !== "hidden") && L !== "visible" && L !== "clip";
    }
    function E(L, D) {
      if (L.clientHeight < L.scrollHeight || L.clientWidth < L.scrollWidth) {
        var H = getComputedStyle(L, null);
        return S(H.overflowY, D) || S(H.overflowX, D) || function(F) {
          var P = function(K) {
            if (!K.ownerDocument || !K.ownerDocument.defaultView) return null;
            try {
              return K.ownerDocument.defaultView.frameElement;
            } catch {
              return null;
            }
          }(F);
          return !!P && (P.clientHeight < F.scrollHeight || P.clientWidth < F.scrollWidth);
        }(L);
      }
      return !1;
    }
    function Z(L, D, H, F, P, K, ne, re) {
      return K < L && ne > D || K > L && ne < D ? 0 : K <= L && re <= H || ne >= D && re >= H ? K - L - F : ne > D && re < H || K < L && re > H ? ne - D + P : 0;
    }
    var B, T = function(L, D) {
      var H = window, F = D.scrollMode, P = D.block, K = D.inline, ne = D.boundary, re = D.skipOverflowHiddenElements, pe = typeof ne == "function" ? ne : function(lt) {
        return lt !== ne;
      };
      if (!U(L)) throw new TypeError("Invalid target");
      for (var me, ae, Ie = document.scrollingElement || document.documentElement, $e = [], Ne = L; U(Ne) && pe(Ne); ) {
        if ((Ne = (ae = (me = Ne).parentElement) == null ? me.getRootNode().host || null : ae) === Ie) {
          $e.push(Ne);
          break;
        }
        Ne != null && Ne === document.body && E(Ne) && !E(document.documentElement) || Ne != null && E(Ne, re) && $e.push(Ne);
      }
      for (var Fe = H.visualViewport ? H.visualViewport.width : innerWidth, Ye = H.visualViewport ? H.visualViewport.height : innerHeight, Ke = window.scrollX || pageXOffset, Xe = window.scrollY || pageYOffset, Qe = L.getBoundingClientRect(), pt = Qe.height, mt = Qe.width, at = Qe.top, xt = Qe.right, Pt = Qe.bottom, Nt = Qe.left, Ge = P === "start" || P === "nearest" ? at : P === "end" ? Pt : at + pt / 2, He = K === "center" ? Nt + mt / 2 : K === "end" ? xt : Nt, nt = [], St = 0; St < $e.length; St++) {
        var Se = $e[St], ze = Se.getBoundingClientRect(), wt = ze.height, Je = ze.width, ht = ze.top, Tt = ze.right, bt = ze.bottom, De = ze.left;
        if (F === "if-needed" && at >= 0 && Nt >= 0 && Pt <= Ye && xt <= Fe && at >= ht && Pt <= bt && Nt >= De && xt <= Tt) return nt;
        var kt = getComputedStyle(Se), Dt = parseInt(kt.borderLeftWidth, 10), $t = parseInt(kt.borderTopWidth, 10), Mt = parseInt(kt.borderRightWidth, 10), Et = parseInt(kt.borderBottomWidth, 10), he = 0, Le = 0, Me = "offsetWidth" in Se ? Se.offsetWidth - Se.clientWidth - Dt - Mt : 0, ve = "offsetHeight" in Se ? Se.offsetHeight - Se.clientHeight - $t - Et : 0, st = "offsetWidth" in Se ? Se.offsetWidth === 0 ? 0 : Je / Se.offsetWidth : 0, vt = "offsetHeight" in Se ? Se.offsetHeight === 0 ? 0 : wt / Se.offsetHeight : 0;
        if (Ie === Se) he = P === "start" ? Ge : P === "end" ? Ge - Ye : P === "nearest" ? Z(Xe, Xe + Ye, Ye, $t, Et, Xe + Ge, Xe + Ge + pt, pt) : Ge - Ye / 2, Le = K === "start" ? He : K === "center" ? He - Fe / 2 : K === "end" ? He - Fe : Z(Ke, Ke + Fe, Fe, Dt, Mt, Ke + He, Ke + He + mt, mt), he = Math.max(0, he + Xe), Le = Math.max(0, Le + Ke);
        else {
          he = P === "start" ? Ge - ht - $t : P === "end" ? Ge - bt + Et + ve : P === "nearest" ? Z(ht, bt, wt, $t, Et + ve, Ge, Ge + pt, pt) : Ge - (ht + wt / 2) + ve / 2, Le = K === "start" ? He - De - Dt : K === "center" ? He - (De + Je / 2) + Me / 2 : K === "end" ? He - Tt + Mt + Me : Z(De, Tt, Je, Dt, Mt + Me, He, He + mt, mt);
          var We = Se.scrollLeft, ot = Se.scrollTop;
          Ge += ot - (he = Math.max(0, Math.min(ot + he / vt, Se.scrollHeight - wt / vt + ve))), He += We - (Le = Math.max(0, Math.min(We + Le / st, Se.scrollWidth - Je / st + Me)));
        }
        nt.push({ el: Se, top: he, left: Le });
      }
      return nt;
    };
    function ee(L) {
      return L === Object(L) && Object.keys(L).length !== 0;
    }
    function x(L, D) {
      var H = L.isConnected || L.ownerDocument.documentElement.contains(L);
      if (ee(D) && typeof D.behavior == "function") return D.behavior(H ? T(L, D) : []);
      if (H) {
        var F = function(P) {
          return P === !1 ? { block: "end", inline: "nearest" } : ee(P) ? P : { block: "start", inline: "nearest" };
        }(D);
        return function(P, K) {
          K === void 0 && (K = "auto");
          var ne = "scrollBehavior" in document.body.style;
          P.forEach(function(re) {
            var pe = re.el, me = re.top, ae = re.left;
            pe.scroll && ne ? pe.scroll({ top: me, left: ae, behavior: K }) : (pe.scrollTop = me, pe.scrollLeft = ae);
          });
        }(T(L, F), F.behavior);
      }
    }
    var m = function() {
      return B || (B = "performance" in window ? performance.now.bind(performance) : Date.now), B();
    };
    function v(L) {
      var D = m(), H = Math.min((D - L.startTime) / L.duration, 1), F = L.ease(H), P = L.startX + (L.x - L.startX) * F, K = L.startY + (L.y - L.startY) * F;
      L.method(P, K), P !== L.x || K !== L.y ? requestAnimationFrame(function() {
        return v(L);
      }) : L.cb();
    }
    function G(L, D, H, F, P, K) {
      var ne, re, pe, me;
      F === void 0 && (F = 600), P === void 0 && (P = function(ae) {
        return 1 + --ae * ae * ae * ae * ae;
      }), ne = L, re = L.scrollLeft, pe = L.scrollTop, me = function(ae, Ie) {
        L.scrollLeft = Math.ceil(ae), L.scrollTop = Math.ceil(Ie);
      }, v({ scrollable: ne, method: me, startTime: m(), startX: re, startY: pe, x: D, y: H, duration: F, ease: P, cb: K });
    }
    var z = function(L) {
      return L && !L.behavior || L.behavior === "smooth";
    }, _ = function(L, D) {
      var H = D || {};
      return z(H) ? x(L, { block: H.block, inline: H.inline, scrollMode: H.scrollMode, boundary: H.boundary, behavior: function(F) {
        return Promise.all(F.reduce(function(P, K) {
          var ne = K.el, re = K.left, pe = K.top, me = ne.scrollLeft, ae = ne.scrollTop;
          return me === re && ae === pe ? P : [].concat(P, [new Promise(function(Ie) {
            return G(ne, re, pe, H.duration, H.ease, function() {
              return Ie({ el: ne, left: [me, re], top: [ae, pe] });
            });
          })]);
        }, []));
      } }) : Promise.resolve(x(L, D));
    };
    const q = (L) => Object.values(L).map((D) => D.current).filter(Boolean);
    function y(L, D, H, F, P, K) {
      var ne;
      const re = ((ne = L == null ? void 0 : L.entry) === null || ne === void 0 ? void 0 : ne.target) || L, pe = D || "smooth";
      if (re) return K ? re == null ? void 0 : re.scrollIntoView({ behavior: pe, inline: H || "end", block: F || "nearest" }) : _(re, Object.assign({ behavior: pe, inline: H || "end", block: F || "nearest", duration: 500 }, P));
    }
    const b = (L) => document.querySelector(`[${k}='${L}']`), j = (L) => document.querySelector(`[${I}='${L}']`);
    function de(L) {
      return i.default.isValidElement(L) && L || typeof L == "function" && i.default.createElement(L, null) || null;
    }
    const se = (L) => L.filter((D) => !new RegExp(`.*${s}$`).test(D)), ie = (L) => {
      var D;
      return String(((D = L == null ? void 0 : L.props) === null || D === void 0 ? void 0 : D[N]) || String((L == null ? void 0 : L.key) || "").replace(/^\.\$/, ""));
    };
    function ke({ children: L, itemClassName: D = "", refs: H, separatorClassName: F = "" }) {
      const P = i.default.Children.toArray(L).filter(Boolean), K = P.length, ne = i.default.useMemo(() => `${d} ${D}`, [D]), re = i.default.useMemo(() => `${c} ${F}`, [F]);
      return i.default.createElement(i.default.Fragment, null, P.map((pe, me) => {
        const ae = ie(pe), Ie = ae + s, $e = me + 1 === K;
        return [i.default.createElement(X, { className: ne, id: ae, key: "menuItem__" + ae, refs: H, index: me }, pe), !$e && i.default.createElement(R, { className: re, id: Ie, refs: H, key: Ie, index: me + 0.1 })];
      }));
    }
    const tt = typeof window < "u" ? i.default.useLayoutEffect : i.default.useEffect;
    function jo({ items: L, itemsChanged: D, refs: H, options: F }) {
      const P = i.default.useRef(), [K, ne] = i.default.useState([]), re = i.default.useRef(+setTimeout(() => {
      }, 0)), pe = i.default.useCallback((me) => {
        L.set(function(ae, Ie) {
          return [...ae].map(($e) => {
            var Ne, Fe, Ye, Ke;
            const Xe = $e.target, Qe = String((Fe = (Ne = Xe == null ? void 0 : Xe.dataset) === null || Ne === void 0 ? void 0 : Ne.key) !== null && Fe !== void 0 ? Fe : "");
            return [Qe, { index: String((Ke = (Ye = Xe == null ? void 0 : Xe.dataset) === null || Ye === void 0 ? void 0 : Ye.index) !== null && Ke !== void 0 ? Ke : ""), key: Qe, entry: $e, visible: $e.intersectionRatio >= Ie.ratio }];
          });
        }(me, F)), clearTimeout(re.current), re.current = +setTimeout(() => requestAnimationFrame(() => {
          ne((ae) => {
            const Ie = L.getVisible().map(($e) => $e[1].key);
            return JSON.stringify(ae) !== JSON.stringify(Ie) ? Ie : ae;
          });
        }), F.throttle);
      }, [L, F]);
      return tt(() => {
        const me = q(H), ae = P.current || new IntersectionObserver(pe, F);
        return P.current = ae, me.forEach((Ie) => ae.observe(Ie)), () => {
          clearTimeout(re.current), ae.disconnect(), P.current = void 0;
        };
      }, [pe, D, F, H]), { visibleElementsWithSeparators: K };
    }
    const Vo = (L) => i.default.Children.toArray(L).map(ie).filter(Boolean);
    class Fo extends Map {
      toArr() {
        return this.sort([...this]);
      }
      toItems() {
        return this.toArr().map(([D]) => D);
      }
      toItemsWithoutSeparators() {
        return se(this.toItems());
      }
      toItemsKeys() {
        return this.toItems();
      }
      sort(D) {
        return D.sort(([, H], [, F]) => +H.index - +F.index);
      }
      set(D, H) {
        return Array.isArray(D) ? this.sort(D).forEach(([F, P]) => {
          super.set(String(F), P);
        }) : super.set(String(D), H), this;
      }
      first() {
        var D;
        return (D = this.toArr()[0]) === null || D === void 0 ? void 0 : D[1];
      }
      last() {
        var D, H;
        return (H = (D = this.toArr().slice(-1)) === null || D === void 0 ? void 0 : D[0]) === null || H === void 0 ? void 0 : H[1];
      }
      filter(D) {
        return this.toArr().filter(D);
      }
      find(D) {
        return this.toArr().find(D);
      }
      findIndex(D) {
        return this.toArr().findIndex(D);
      }
      getCurrentPos(D, H) {
        const F = this.toArr().filter((K) => {
          var ne;
          return H ? !(!((ne = K == null ? void 0 : K[0]) === null || ne === void 0) && ne.includes(s)) : K;
        }), P = F.findIndex(([K, ne]) => K === D || ne === D);
        return [F, P];
      }
      prev(D, H) {
        var F;
        const [P, K] = this.getCurrentPos(D, !!H);
        return K !== -1 ? (F = P[K - 1]) === null || F === void 0 ? void 0 : F[1] : void 0;
      }
      next(D, H) {
        var F;
        const [P, K] = this.getCurrentPos(D, !!H);
        return K !== -1 ? (F = P[K + 1]) === null || F === void 0 ? void 0 : F[1] : void 0;
      }
      getVisible() {
        return this.filter((D) => D[1].visible);
      }
      getVisibleElements() {
        return this.filter((D) => !D[0].includes(s) && D[1].visible);
      }
    }
    const Bn = { ratio: 0.9, rootMargin: "5px", threshold: [0.05, 0.5, 0.75, 0.95], throttle: 100 }, An = i.default.createContext({}), Un = (L) => L.reduce((D, H) => D.concat(H).concat(`${H}${s}`), []).slice(0, -1);
    o.ScrollMenu = function({ LeftArrow: L, RightArrow: D, children: H, Header: F, Footer: P, transitionDuration: K = 500, transitionEase: ne, transitionBehavior: re, onInit: pe = () => {
    }, onUpdate: me = () => {
    }, onMouseDown: ae, onMouseUp: Ie, onMouseMove: $e, onScroll: Ne = () => {
    }, onWheel: Fe = () => {
    }, options: Ye = Bn, scrollContainerClassName: Ke = "", itemClassName: Xe = "", separatorClassName: Qe = "", wrapperClassName: pt = "", apiRef: mt = { current: {} }, RTL: at, noPolyfill: xt }) {
      const Pt = de(L), Nt = de(D), Ge = de(F), He = de(P), nt = i.default.useRef(null), [St] = i.default.useState({}), Se = i.default.useMemo(() => Object.assign(Object.assign(Object.assign({}, Bn), Ye), { root: nt.current }), [Ye, nt.current]), ze = i.default.useRef(new Fo()).current, wt = function(he, Le) {
        const [Me, ve] = i.default.useState(""), st = i.default.useMemo(() => Vo(he), [he]);
        return i.default.useEffect(() => {
          const vt = st.filter(Boolean).join("");
          Le.toItemsWithoutSeparators().filter((We) => !st.includes(We)).forEach((We) => {
            var ot, lt;
            const pn = ((ot = Le.last()) === null || ot === void 0 ? void 0 : ot.key) === We && ((lt = Le.prev(We)) === null || lt === void 0 ? void 0 : lt.key) || "";
            Le.delete(pn), Le.delete(`${We}${s}`), Le.delete(We);
          }), ve(vt);
        }, [st, Le]), Me;
      }(H, ze), { visibleElementsWithSeparators: Je } = jo({ items: ze, itemsChanged: wt, options: Se, refs: St }), ht = !!Je.length, Tt = i.default.useMemo(() => function(he, Le = [], Me, ve, st, vt) {
        var We, ot;
        const lt = se(Le), pn = !!(!((We = he.first()) === null || We === void 0) && We.visible), Yo = !!(!((ot = he.last()) === null || ot === void 0) && ot.visible), Pn = (ue) => {
          var fe;
          return (fe = he.find((Oe) => Oe[1].key === String(ue))) === null || fe === void 0 ? void 0 : fe[1];
        }, Gn = () => {
          var ue, fe;
          return he.prev((fe = (ue = he.getVisible()) === null || ue === void 0 ? void 0 : ue[0]) === null || fe === void 0 ? void 0 : fe[1]);
        }, Hn = () => {
          var ue, fe, Oe, Ae;
          return he.next((Ae = (Oe = (fe = (ue = he.getVisible()) === null || ue === void 0 ? void 0 : ue.slice) === null || fe === void 0 ? void 0 : fe.call(ue, -1)) === null || Oe === void 0 ? void 0 : Oe[0]) === null || Ae === void 0 ? void 0 : Ae[1]);
        };
        return { getItemById: Pn, getItemElementById: b, getItemByIndex: (ue) => {
          var fe;
          return (fe = he.find((Oe) => String(Oe[1].index) === String(ue))) === null || fe === void 0 ? void 0 : fe[1];
        }, getItemElementByIndex: j, getNextItem: Hn, getNextElement: () => {
          var ue, fe, Oe, Ae;
          return he.next((Ae = (Oe = (fe = (ue = he.getVisibleElements()) === null || ue === void 0 ? void 0 : ue.slice) === null || fe === void 0 ? void 0 : fe.call(ue, -1)) === null || Oe === void 0 ? void 0 : Oe[0]) === null || Ae === void 0 ? void 0 : Ae[1], !0);
        }, getPrevItem: Gn, getPrevElement: () => {
          var ue, fe;
          return he.prev((fe = (ue = he.getVisibleElements()) === null || ue === void 0 ? void 0 : ue[0]) === null || fe === void 0 ? void 0 : fe[1], !0);
        }, isFirstItemVisible: pn, isItemVisible: (ue) => lt.includes(String(ue)), isLastItem: (ue) => he.last() === Pn(ue), isLastItemVisible: Yo, scrollNext: (ue, fe, Oe, { duration: Ae, ease: qe, boundary: Ct = Me == null ? void 0 : Me.current } = {}) => {
          const _t = ue ?? (ve == null ? void 0 : ve.behavior);
          return y(Hn(), _t, fe || "start", Oe || "nearest", { boundary: Ct, duration: Ae ?? (ve == null ? void 0 : ve.duration), ease: qe ?? (ve == null ? void 0 : ve.ease) }, st || vt);
        }, scrollPrev: (ue, fe, Oe, { duration: Ae, ease: qe, boundary: Ct = Me == null ? void 0 : Me.current } = {}) => {
          const _t = ue ?? (ve == null ? void 0 : ve.behavior);
          return y(Gn(), _t, fe || "end", Oe || "nearest", { boundary: Ct, duration: Ae ?? (ve == null ? void 0 : ve.duration), ease: qe ?? (ve == null ? void 0 : ve.ease) }, st || vt);
        }, scrollToItem: (ue, fe, Oe, Ae, qe) => {
          var Ct, _t;
          return y(ue, fe ?? (ve == null ? void 0 : ve.behavior), Oe, Ae, Object.assign(Object.assign({ boundary: Me == null ? void 0 : Me.current }, qe), { duration: (Ct = qe == null ? void 0 : qe.duration) !== null && Ct !== void 0 ? Ct : ve == null ? void 0 : ve.duration, ease: (_t = qe == null ? void 0 : qe.ease) !== null && _t !== void 0 ? _t : ve == null ? void 0 : ve.ease }));
        }, visibleElements: lt, visibleElementsWithSeparators: Le, visibleItems: Le, visibleItemsWithoutSeparators: lt };
      }(ze, Je, nt, { duration: K, ease: ne, behavior: re }, at, xt), [ze, Je, wt, at, xt]), bt = i.default.useCallback(() => Object.assign(Object.assign({}, Tt), { initComplete: ht, items: ze, visibleElementsWithSeparators: Je, scrollContainer: nt }), [Tt, ht, ze, Je, nt]), [De, kt] = i.default.useState(bt);
      (function({ cb: he = () => {
      }, condition: Le, hash: Me }) {
        i.default.useEffect(() => {
          Le && he();
        }, [Me, Le]);
      })({ cb: () => me(De), condition: function({ cb: he, condition: Le }) {
        const [Me, ve] = i.default.useState(!1);
        return i.default.useEffect(() => {
          Le && !Me && (ve(!0), he());
        }, [Le, Me]), Me;
      }({ cb: () => pe(De), condition: ht }), hash: JSON.stringify(Je.concat(String(De == null ? void 0 : De.isFirstItemVisible)).concat(String(De == null ? void 0 : De.isLastItemVisible))) }), i.default.useEffect(() => kt(bt()), [bt]), mt.current = De;
      const Dt = i.default.useCallback((he) => Ne(De, he), [Ne, De]), $t = i.default.useCallback((he) => Fe(De, he), [Fe, De]), Mt = i.default.useMemo(() => `${p} ${pt}`, [pt]), Et = i.default.useMemo(() => `${Ke}${at ? " rtl" : ""}`, [at, Ke]);
      return i.default.createElement("div", { className: Mt, onWheel: $t, onMouseDown: ae == null ? void 0 : ae(De), onMouseUp: Ie == null ? void 0 : Ie(De), onMouseMove: $e == null ? void 0 : $e(De) }, i.default.createElement(An.Provider, { value: De }, i.default.createElement("div", { className: g }, Ge), i.default.createElement("div", { className: h }, i.default.createElement("div", { className: w }, Pt), i.default.createElement(M, { className: Et, onScroll: Dt, scrollRef: nt }, i.default.createElement(ke, { refs: St, itemClassName: Xe, separatorClassName: Qe }, H)), i.default.createElement("div", { className: f }, Nt)), i.default.createElement("div", { className: C }, He)));
    }, o.VisibilityContext = An, o.constants = A, o.getItemsPos = (L) => {
      var D;
      const H = ((P) => P.filter((K, ne, re) => {
        const pe = ne === 0, me = ne === re.length - 1, ae = new RegExp(s).test(K);
        return !((pe || me) && ae);
      }))(L), F = H[Math.floor(H.length / 2)];
      return { first: H == null ? void 0 : H[0], center: F, last: (D = H.slice(-1)) === null || D === void 0 ? void 0 : D[0] };
    }, o.slidingWindow = function(L, D) {
      const H = se(L), F = se(D);
      return { prev: () => Un(function(P, K) {
        const ne = P.findIndex(($e) => $e === (K == null ? void 0 : K[0])), re = K.length, pe = ne - re, me = pe < 0, ae = me ? 0 : pe, Ie = P.slice(ae, me ? re : ne);
        return Ie.length === re ? Ie : P.slice(ne, re);
      }(H, F)), next: () => Un(function(P, K) {
        const ne = P.findIndex(($e) => {
          var Ne;
          return $e === ((Ne = K.slice(-1)) === null || Ne === void 0 ? void 0 : Ne[0]);
        }), re = K.length, pe = ne + re + 1, me = pe > P.length - 1, ae = me ? P.length - 1 : pe, Ie = P.slice(me ? ae - re + 1 : ne + 1, ae);
        return Ie.length === re ? Ie : P.slice(P.length - re, P.length + re);
      }(H, F)) };
    }, Object.defineProperty(o, "__esModule", { value: !0 });
  });
})(bn, bn.exports);
var Vs = bn.exports;
const Fs = ({
  children: e,
  offWheel: t = !1,
  space: o = 8,
  apiRef: r,
  ...a
}) => {
  const { handleWheel: i } = js(), { dragStart: l, dragStop: s, handleDrag: c, isDragging: d } = Ws();
  return /* @__PURE__ */ n(Ys, { onMouseLeave: s, ...a, space: o, children: /* @__PURE__ */ n(
    Vs.ScrollMenu,
    {
      onWheel: t ? void 0 : i,
      onMouseDown: () => l,
      onMouseUp: () => s,
      onMouseMove: c,
      apiRef: r,
      children: e({ isDragging: d })
    }
  ) });
}, Ys = ce.div`
  .react-horizontal-scrolling-menu--scroll-container::-webkit-scrollbar {
    display: none;
  }

  .react-horizontal-scrolling-menu--scroll-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overscroll-behavior: none;
  }
  ${({ space: e = 8 }) => Be`
    .react-horizontal-scrolling-menu--item {
      padding-right: ${Zr(e)};
    }
    .react-horizontal-scrolling-menu--item:last-child {
      padding-right: 0;
    }
  `}
`, Vl = ({
  images: e,
  startIndex: t = 0,
  handleClose: o,
  backgroundColor: r = "rgba(18, 18, 18, 0.7)"
}) => {
  const { tagGTM: a } = te(), [i, l] = O(-1), s = ye(), [c, d] = O(!1), u = W(
    (p) => {
      l(p), s && s.current && s.current.scrollToItem(s.current.getItemByIndex(p));
    },
    [s]
  );
  return J(() => {
    e.length > 0 && t >= 0 && (Wn(() => u(t), 500)(), Wn(() => d(!0), 750)());
  }, [u, e.length, t]), /* @__PURE__ */ $(
    oe,
    {
      width: "100%",
      height: "100%",
      backgroundColor: r,
      ...a("gallery"),
      children: [
        /* @__PURE__ */ n(Ve, { alignment: "center", width: "100%", height: "100%", children: i >= 0 && /* @__PURE__ */ n(
          yt,
          {
            data: e,
            baseWidth: 375,
            baseHeight: 540,
            canZoom: !0,
            isCentered: !0,
            slideIndex: i,
            setSlideIndex: (p) => {
              c && u(p);
            },
            children: ({ width: p, height: h, item: g }) => /* @__PURE__ */ n(Ve, { alignment: "center", width: p, height: h, children: g.thumbnailUrl && /* @__PURE__ */ n(oe, { width: p, height: h, maxHeight: "50vh", children: /* @__PURE__ */ n(Ks, { src: g.url, alt: g.url }) }) })
          }
        ) }),
        /* @__PURE__ */ n(
          po,
          {
            position: "fixed",
            top: 40,
            right: 16,
            zIndex: 1,
            p: 0,
            onClick: o,
            ...a("gallery_close_button"),
            children: /* @__PURE__ */ n(ho, { variant: "ic_close_bold_32", useFillColor: !0, color: "#FFF" })
          }
        ),
        e.length > 1 && /* @__PURE__ */ n(oe, { position: "fixed", left: 0, right: 0, bottom: 52, zIndex: 1, children: /* @__PURE__ */ n(oe, { width: "100%", children: /* @__PURE__ */ n(Fs, { space: 8, apiRef: s, children: ({ isDragging: p }) => e.map((h, g) => /* @__PURE__ */ n(
          oe,
          {
            pl: g === 0 ? "24px" : "0px",
            pr: g < e.length - 1 ? "0px" : "24px",
            children: /* @__PURE__ */ n(
              oe,
              {
                width: 60,
                height: 60,
                borderWidth: i === g ? 2 : 0,
                borderStyle: "solid",
                borderColor: we("accent_color.secondary.blue"),
                onClick: () => {
                  p || u(g);
                },
                children: h.thumbnailUrl && /* @__PURE__ */ n(
                  Xs,
                  {
                    src: h.thumbnailUrl,
                    alt: h.thumbnailUrl
                  }
                )
              }
            )
          },
          `image-${g + 1}`
        )) }) }) })
      ]
    }
  );
}, Ks = ce.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`, Xs = ce.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`, Fl = ({ bottom: e = 20 }) => {
  const { tagGTM: t } = te(), o = ye(null), [r, a] = O(!1), [i, l] = O(0), s = W(() => {
    o != null && o.current && o.current.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []), c = rr(() => {
    var g;
    const h = ((g = o == null ? void 0 : o.current) == null ? void 0 : g.scrollY) ?? 0;
    l(h);
  }, 300), d = W(() => {
    const h = (window == null ? void 0 : window.innerHeight) / 3;
    a(i > h);
  }, [i]), u = () => {
    o.current = window, o.current.addEventListener("scroll", c);
  }, p = () => {
    (o == null ? void 0 : o.current) !== null && o.current.removeEventListener("scroll", c);
  };
  return J(() => (u(), () => {
    p();
  }), []), J(() => {
    d();
  }, [d]), /* @__PURE__ */ n(
    Zs,
    {
      className: "scroll-top-wrapper",
      isShow: r,
      position: "fixed",
      right: 16,
      bottom: e,
      zIndex: Ho,
      width: 40,
      height: 40,
      ...t("scroll_top_button"),
      children: /* @__PURE__ */ n(
        Vr,
        {
          className: "scroll-top-button",
          variant: "top",
          onClick: s
        }
      )
    }
  );
}, Zs = ce(oe)`
  transform: scale(${({ isShow: e }) => e ? 1 : 0});
  transition: transform 0.2s;
`;
var Wo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function o() {
      for (var i = "", l = 0; l < arguments.length; l++) {
        var s = arguments[l];
        s && (i = a(i, r(s)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return o.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var l = "";
      for (var s in i)
        t.call(i, s) && i[s] && (l = a(l, s));
      return l;
    }
    function a(i, l) {
      return l ? i ? i + " " + l : i + l : i;
    }
    e.exports ? (o.default = o, e.exports = o) : window.classNames = o;
  })();
})(Wo);
var Qs = Wo.exports;
const Zt = /* @__PURE__ */ ko(Qs), Js = ({ color: e = "#121212" }) => /* @__PURE__ */ $(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ n("path", { d: "M13 7V10", stroke: e, strokeLinecap: "round" }),
      /* @__PURE__ */ n("path", { d: "M19 7V10", stroke: e, strokeLinecap: "round" }),
      /* @__PURE__ */ n(
        "path",
        {
          d: "M9 17V18.1677C9 22.4968 12.1309 26 16 26C19.8691 26 23 22.4968 23 18.1677V17",
          stroke: e,
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ n("path", { d: "M6.89258 14.7009H25.0926", stroke: e, strokeLinecap: "round" }),
      /* @__PURE__ */ n(
        "path",
        {
          d: "M23.7963 14.7006C23.7963 14.2042 23.7635 13.7244 23.6979 13.2611C23.1073 8.90968 19.8758 5.60059 15.9881 5.60059C12.1004 5.60059 8.88525 8.92622 8.29471 13.2777C8.2291 13.741 8.19629 14.2208 8.19629 14.7006",
          stroke: e
        }
      )
    ]
  }
), qs = ({ color: e = "#121212" }) => /* @__PURE__ */ $(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ n(
        "rect",
        {
          x: "8",
          y: "7",
          width: "15.5",
          height: "18",
          stroke: e,
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ n("path", { d: "M11 11H17", stroke: e, strokeLinecap: "round" }),
      /* @__PURE__ */ n("path", { d: "M11 14H14.9", stroke: e, strokeLinecap: "round" })
    ]
  }
), el = ({ color: e = "#121212" }) => /* @__PURE__ */ n(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ n(
      "path",
      {
        d: "M8 25V8H24V25L16 20.5L8 25Z",
        stroke: e,
        strokeLinejoin: "round"
      }
    )
  }
), tl = ({ color: e = "#121212" }) => /* @__PURE__ */ $(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ n(
        "path",
        {
          d: "M16 14C17.66 14 19 12.66 19 11C19 9.34 17.66 8 16 8C14.34 8 13 9.34 13 11C13 12.66 14.34 14 16 14Z",
          stroke: e
        }
      ),
      /* @__PURE__ */ n(
        "path",
        {
          d: "M24 24V18.5C24 18.2239 23.7761 18 23.5 18H8.5C8.22386 18 8 18.2239 8 18.5V24",
          stroke: e,
          strokeLinecap: "round"
        }
      )
    ]
  }
), nl = ({
  fillColor: e = "#0064ff",
  strokeColor: t = "#fff"
}) => /* @__PURE__ */ $(
  "svg",
  {
    width: "27",
    height: "12",
    viewBox: "0 0 27 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ n("rect", { width: "27", height: "12", rx: "6", fill: e }),
      /* @__PURE__ */ n(
        "path",
        {
          d: "M9.26547 3.34375H8.42172V7.48438H8.36703L5.49984 3.34375H4.70297V9H5.56234V4.86719H5.60922L8.47641 9H9.26547V3.34375ZM15.1758 6.17188C15.1758 4.36328 14.0898 3.26562 12.6289 3.26562C11.1562 3.26562 10.0742 4.36328 10.0742 6.17188C10.0742 7.97656 11.1562 9.07812 12.6289 9.07812C14.0898 9.07812 15.1758 7.98047 15.1758 6.17188ZM10.9258 6.17188C10.9297 4.79688 11.6523 4.05078 12.6289 4.05469C13.5977 4.05078 14.3203 4.79688 14.3242 6.17188C14.3203 7.54688 13.5977 8.29297 12.6289 8.28906C11.6523 8.29297 10.9297 7.54688 10.9258 6.17188ZM17.0236 9H17.8908L19.0783 4.77344H19.1252L20.3127 9H21.1798L22.7502 3.34375H21.8439L20.7423 7.71875H20.6955L19.547 3.34375H18.6564L17.508 7.71875H17.4611L16.3595 3.34375H15.4533L17.0236 9Z",
          fill: t
        }
      )
    ]
  }
), Yl = ({ offInteraction: e, viewType: t, host: o }) => {
  const { tagGTM: r } = te(), { direction: a, y: i } = Oi(), [l, s] = O(!1), c = () => {
    s(!1), typeof document < "u" && (document.getElementsByTagName("body")[0].style.overflow = "");
  }, [d, u] = O(!1), p = Q(
    () => !e && a === "DOWN" && i != null && i > Gs,
    [a, e, i]
  );
  return /* @__PURE__ */ $(Y, { children: [
    /* @__PURE__ */ n(
      ol,
      {
        className: Zt({
          close: p
        }),
        ...r("bnb"),
        children: /* @__PURE__ */ n(vn, { children: /* @__PURE__ */ $(rl, { children: [
          /* @__PURE__ */ $(
            Gt,
            {
              href: `${o.mall}/main.html`,
              ...r("bnb_menu_button", {
                "menu-value": "MAIN"
              }),
              children: [
                /* @__PURE__ */ n(
                  Ot,
                  {
                    variant: t === Gr ? "ic_home_solid_32" : "ic_home_32"
                  }
                ),
                /* @__PURE__ */ n("span", { children: "홈" })
              ]
            }
          ),
          /* @__PURE__ */ $(
            Gt,
            {
              href: `${o.mall}/mall.html`,
              ...r("bnb_menu_button", {
                "menu-value": "MALL"
              }),
              children: [
                /* @__PURE__ */ n(
                  Ot,
                  {
                    variant: t === Hr ? "ic_mall_solid_32" : "ic_mall_32"
                  }
                ),
                /* @__PURE__ */ n("span", { children: "스토어" })
              ]
            }
          ),
          /* @__PURE__ */ $(
            Gt,
            {
              href: `${o.remodeling}/main`,
              ...r("bnb_menu_button", {
                "menu-value": "REMODELING"
              }),
              children: [
                /* @__PURE__ */ n(
                  Ot,
                  {
                    variant: t === zr ? "ic_remodeling_solid_32" : "ic_remodeling_32"
                  }
                ),
                /* @__PURE__ */ n("span", { children: "인테리어" })
              ]
            }
          ),
          /* @__PURE__ */ $(
            Gt,
            {
              href: `${o.mall}/homeidea.html`,
              ...r("bnb_menu_button", {
                "menu-value": "HOMEIDEA"
              }),
              children: [
                /* @__PURE__ */ n(
                  Ot,
                  {
                    variant: t === Wr ? "ic_homeidea_solid_32" : "ic_homeidea_32"
                  }
                ),
                /* @__PURE__ */ n("span", { children: "홈아이디어" })
              ]
            }
          ),
          /* @__PURE__ */ $(
            Gt,
            {
              href: `${o.mall}/mmypage/myPageMain.do`,
              ...r("bnb_menu_button", {
                "menu-value": "MY"
              }),
              children: [
                /* @__PURE__ */ n(Ot, { variant: "ic_my_32" }),
                /* @__PURE__ */ n("span", { children: "마이" })
              ]
            }
          )
        ] }) })
      }
    ),
    /* @__PURE__ */ n(il, { className: Zt({ open: l }), onClick: c }),
    /* @__PURE__ */ $(al, { className: Zt({ open: l }), children: [
      /* @__PURE__ */ $(
        Qt,
        {
          className: Zt({ now: d }),
          href: `${o.remodeling}/my/consult`,
          children: [
            /* @__PURE__ */ $("i", { children: [
              /* @__PURE__ */ n(Js, { color: d ? "#0064ff" : "#121212" }),
              d && /* @__PURE__ */ n("label", { children: /* @__PURE__ */ n(nl, {}) })
            ] }),
            /* @__PURE__ */ n("span", { children: "리모델링 매니저" })
          ]
        }
      ),
      /* @__PURE__ */ $(Qt, { href: `${o.mall}/mmyorder/goOrder.do?_PAGE_GB=A`, children: [
        /* @__PURE__ */ n("i", { children: /* @__PURE__ */ n(qs, {}) }),
        /* @__PURE__ */ n("span", { children: "주문내역" })
      ] }),
      /* @__PURE__ */ $(Qt, { href: `${o.mall}/mmypage/wishList.do`, children: [
        /* @__PURE__ */ n("i", { children: /* @__PURE__ */ n(el, {}) }),
        /* @__PURE__ */ n("span", { children: "스크랩" })
      ] }),
      /* @__PURE__ */ $(Qt, { href: `${o.mall}/mmypage/myPageMain.do`, children: [
        /* @__PURE__ */ n("i", { children: /* @__PURE__ */ n(tl, {}) }),
        /* @__PURE__ */ n("span", { children: "MY 한샘" })
      ] })
    ] })
  ] });
}, vn = ce.nav`
  ${({ theme: e }) => Be`
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${Rn}px;
    box-sizing: border-box;
    z-index: ${dn};
    background: ${e.colors.natural_color.white};
    padding: 0 8px;
    border-top: solid 1px ${e.colors.natural_color.gray[200]};
  `}
`, ol = ce.div`
  width: 100%;

  ${vn} {
    transition: transform 0.3s ease;
    will-change: transform;
  }

  &.close {
    ${vn} {
      transform: translateY(100%);
    }
  }
`, rl = ce.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: start;
`, Gt = ce.a`
  ${({ theme: e }) => Be`
    width: 64px;
    padding-top: 4px;
    font-size: 10px;
    display: inline-block;
    text-align: center;
    vertical-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    ${e.typography.caption3}
    color: ${e.colors.natural_color.primary};

    i {
      height: 32px;
    }

    span {
      line-height: 100%;
    }
  `}
`, il = ce.div`
  opacity: 0;
  position: fixed;
  top: 0;
  bottom: ${Rn}px;
  left: 0;
  right: 0;
  transition: all 0.3s;
  z-index: ${dn - 2};
  background-color: rgba(0, 0, 0, 0.6);
  transform: scaleZ(0);
  &.open {
    opacity: 1;
    transform: scaleZ(1);
  }
`, al = ce.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  transition: all 0.3s;
  z-index: ${dn - 1};
  transform: translateY(100%);
  display: flex;
  flex-direction: row;
  align-items: top;
  justify-content: space-between;
  width: 100%;
  height: 128px;
  border-radius: 16px 16px 0px 0px;
  background-color: ${(e) => we("natural_color.white", e.theme.colors)};
  padding: 24px 32px 0;
  &.open {
    transform: translateY(-${Rn}px);
  }
`, Qt = ce.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-size: 11px;

  &.now {
    i {
      background-color: #ecf4ff;
    }
  }

  i {
    position: relative;
    display: block;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #f7f7f7;

    & > * {
      margin-top: 50%;
      margin-left: 50%;
      transform: translate(-50%, -50%);
    }

    label {
      position: absolute;
      top: 8px;
      right: 0;
      transform: translateX(5px);
      margin: 0;
      display: block;
    }
  }

  span {
    line-height: 120%;
    white-space: nowrap;
  }
`, sl = ({
  setIndicatorPercentState: e
}) => {
  const t = W(
    (a) => {
      if (!e) return;
      const i = a.target, l = Math.ceil(
        (i.clientWidth + i.scrollLeft) / i.scrollWidth * 100
      );
      e(l);
    },
    [e]
  ), o = ye();
  J(() => {
    if (!e || o.current === void 0) return;
    const a = Math.ceil(
      o.current.clientWidth / o.current.scrollWidth * 100
    );
    e(a);
  }, [e, o.current]);
  const r = W(() => {
    var a;
    o.current && ((a = o.current) == null || a.scrollTo({ left: 0 }));
  }, []);
  return { containerRef: o, handleScroll: t, resetScroll: r };
}, un = ({
  pl: e,
  pr: t,
  verticalSpace: o = 10,
  children: r,
  setIndicatorPercentState: a,
  resetScrollRef: i,
  ...l
}) => {
  const { resetScroll: s, containerRef: c, handleScroll: d } = sl({
    setIndicatorPercentState: a
  });
  return qn(i, () => ({
    resetScroll: () => s()
  })), /* @__PURE__ */ n(
    ll,
    {
      ref: c,
      onScroll: a && d,
      ...l,
      children: /* @__PURE__ */ n(V, { width: "max-content", pl: e, pr: t, children: /* @__PURE__ */ n(xe, { alignment: "start", space: o, children: r }) })
    }
  );
}, ll = ce(V)`
  width: 100%;

  ${({ pl: e, pr: t }) => Be`
    padding-left: ${e === void 0 ? "0px" : e};
    padding-right: ${e === void 0 ? "0px" : t};
  `};

  overflow-y: hidden;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-track {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    display: none;
  }

  ::-webkit-scrollbar-thumb:hover {
    display: none;
  }
`, cl = ct(null), fn = {
  didCatch: !1,
  error: null
};
class dl extends Jo {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = fn;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var o, r, a = arguments.length, i = new Array(a), l = 0; l < a; l++)
        i[l] = arguments[l];
      (o = (r = this.props).onReset) === null || o === void 0 || o.call(r, {
        args: i,
        reason: "imperative-api"
      }), this.setState(fn);
    }
  }
  componentDidCatch(t, o) {
    var r, a;
    (r = (a = this.props).onError) === null || r === void 0 || r.call(a, t, o);
  }
  componentDidUpdate(t, o) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: a
    } = this.props;
    if (r && o.error !== null && ul(t.resetKeys, a)) {
      var i, l;
      (i = (l = this.props).onReset) === null || i === void 0 || i.call(l, {
        next: a,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(fn);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: o,
      FallbackComponent: r,
      fallback: a
    } = this.props, {
      didCatch: i,
      error: l
    } = this.state;
    let s = t;
    if (i) {
      const c = {
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof o == "function")
        s = o(c);
      else if (r)
        s = zn(r, c);
      else if (a !== void 0)
        s = a;
      else
        throw l;
    }
    return zn(cl.Provider, {
      value: {
        didCatch: i,
        error: l,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function ul() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((o, r) => !Object.is(o, t[r]));
}
const Kl = ({
  pageIdentificationValue: e,
  onHandleClick: t,
  categoryNo: o,
  isLogin: r,
  data: a,
  onHandleAction: i,
  onTouchCancel: l,
  onTouchEnd: s,
  onTouchStart: c,
  style: d,
  componentIdList: u,
  templateId: p,
  componentDataDate: h,
  rdId: g,
  isPreview: w = !1,
  isDataRetry: f = !1,
  ...C
}) => {
  var U;
  const { hosts: N, httpClient: k } = te(), [I, A] = O([]), { data: M } = Sn(
    `displayComponents_${g || e}_${o || ""}`,
    () => It(
      N.hanssemApiGateway,
      k
    ).getTemplateComponents.exec({
      pageIdentificationValue: e,
      categoryNo: o,
      componentIdList: u,
      templateId: p,
      componentDataDate: h,
      isPreview: w,
      rdId: g
    }),
    {
      fallbackData: a,
      revalidateIfStale: f,
      revalidateOnFocus: !1,
      revalidateOnReconnect: !1
    }
  ), R = W(async () => {
    if (r) {
      const S = await It(
        N.hanssemApiGateway,
        k
      ).getScraps.exec();
      (S == null ? void 0 : S.code) === 200 && A(S == null ? void 0 : S.data);
    }
  }, [N, k, r]);
  console.log(M), J(() => {
    R();
  }, [R]);
  const X = W(
    async (S) => (await It(
      N.hanssemApiGateway,
      k
    ).requestScraps.exec(S)).code,
    [N.hanssemApiGateway, k]
  );
  return !(M != null && M.data) || !((U = M == null ? void 0 : M.data) != null && U.length) ? /* @__PURE__ */ n(Y, {}) : /* @__PURE__ */ n(si, { isLogin: r, children: /* @__PURE__ */ n(
    Xr,
    {
      onHandleClick: t,
      onHandleAction: i,
      children: /* @__PURE__ */ n(
        ci,
        {
          scrapItemList: I,
          setScrapItemList: A,
          toggleScrap: X,
          children: /* @__PURE__ */ n(xe, { space: 50, width: "100%", style: { ...d }, children: (M == null ? void 0 : M.data) && (M == null ? void 0 : M.data.map(
            (S, E) => {
              var ee, x;
              const { header: Z, body: B, footer: T } = S.attribute;
              try {
                return /* @__PURE__ */ n(
                  dl,
                  {
                    onError: (m) => Jr(m, S == null ? void 0 : S.componentId),
                    FallbackComponent: () => /* @__PURE__ */ n(Y, {}),
                    children: /* @__PURE__ */ n(V, { width: "100%", children: /* @__PURE__ */ $(Kr, { index: E, children: [
                      /* @__PURE__ */ n(za, { ...Z }),
                      ((x = (ee = S == null ? void 0 : S.data) == null ? void 0 : ee.content) == null ? void 0 : x.length) > 0 ? (() => {
                        switch (S.componentType) {
                          case "QUICKLINK":
                            return /* @__PURE__ */ n(
                              qr,
                              {
                                quickLinkItem: S,
                                children: /* @__PURE__ */ n(Ka, {})
                              }
                            );
                          case "BANNER":
                            return /* @__PURE__ */ n(
                              ei,
                              {
                                bannerItem: S,
                                index: E,
                                children: /* @__PURE__ */ n(es, {})
                              }
                            );
                          case "GOODS":
                            return /* @__PURE__ */ n(
                              di,
                              {
                                productItem: S,
                                index: E,
                                children: /* @__PURE__ */ n(hs, {})
                              }
                            );
                          case "CONTENTS":
                            return /* @__PURE__ */ n(
                              cs,
                              {
                                displayData: S.data.content,
                                contentsDataType: B.contentsData.contentsDataType,
                                displayType: B.display,
                                horizontalColumnLength: B.horizontalType,
                                verticalLineNumber: B.verticalType,
                                unitDirection: B.unit === "normal" ? "vertical" : "horizontal",
                                scrollDirection: B.scroll,
                                dataType: S.dataType,
                                unitElement: B.unitElement,
                                isChip: B.display === "chip" && S.dataType === "group",
                                scrapContentList: I,
                                setScrapContentList: A,
                                onHandleAction: i,
                                isLogin: r,
                                toggleScrap: X,
                                unitType: B.unit,
                                ratio: B.thumbnail,
                                gtm: B.gtm,
                                componentId: S.componentId,
                                chipType: B.chipUnit.chipUnitType,
                                isChipLink: B.chipUnit.isChipLink,
                                isInfinity: B.isInfinity
                              }
                            );
                        }
                      })() : null,
                      /* @__PURE__ */ n(Wa, { ...T })
                    ] }) })
                  },
                  `${S.componentName}-${S.componentId}`
                );
              } catch (m) {
                const v = m.message;
                throw new Error(
                  `${v} new display service error ${S == null ? void 0 : S.componentId}`
                );
              }
            }
          )) })
        }
      )
    }
  ) });
}, pl = ({
  id: e,
  baseWidth: t,
  baseHeight: o,
  data: r = [],
  slideIndex: a = -1,
  canZoom: i = !1,
  isCentered: l = !1,
  isAutoPlayed: s = !1,
  speed: c = 1e3,
  autoMs: d = 5e3,
  onTouchStart: u,
  onTouchEnd: p,
  onTouchCancel: h,
  className: g,
  children: w,
  isPageIndicator: f
}) => {
  const [C, N] = O(a + 1), [k, I] = O(), [A, M] = O(!1);
  J(() => (k && "activeIndex" in k && M(!0), () => {
    M(!1);
  }), [k]), J(() => {
    k && A && s && k.autoplay.start();
  }, [r, A, a, k, s]);
  const R = W(
    (X) => {
      if (X)
        return /* @__PURE__ */ n(V, { position: "relative", zIndex: 1, children: /* @__PURE__ */ n(
          Vt,
          {
            variant: "line1",
            percent: C / r.length * 100
          }
        ) });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [C]
  );
  return /* @__PURE__ */ $(V, { width: "100%", height: "100%", position: "relative", className: g, children: [
    /* @__PURE__ */ n(hl, { aspectRatio: t / o, children: /* @__PURE__ */ n(
      Ft,
      {
        initialSlide: 0,
        effect: "creative",
        creativeEffect: {
          prev: {
            translate: ["-50%", 0, -1]
          },
          next: {
            translate: ["100%", 0, 0]
          }
        },
        grabCursor: !0,
        modules: [kn, Yr],
        spaceBetween: 0,
        slidesPerView: 1,
        zoom: i,
        onSwiper: I,
        centeredSlides: l,
        speed: c,
        onSlideChange: (X) => {
          const { activeIndex: U } = X, S = r.length;
          N(U % S + 1);
        },
        preventInteractionOnTransition: !0,
        loop: r.length > 1,
        loopedSlides: r.length,
        autoplay: s ? {
          delay: d,
          disableOnInteraction: !1
        } : void 0,
        edgeSwipeDetection: "prevent",
        onTouchStart: u,
        onTouchEnd: p,
        onTouchCancel: h,
        children: r.map((X, U) => /* @__PURE__ */ n(Yt, { children: w({
          width: t,
          height: o,
          index: U,
          item: X
        }) }, `${e}-slide-box-${U + 1}`))
      }
    ) }),
    f && r.length > 1 && R(f)
  ] });
}, hl = ce(V)`
  aspect-ratio: ${({ aspectRatio: e }) => e};
  overflow: hidden;
`;
export {
  zo as APP_BAR_BOTTOM_HEIGHT,
  Ho as APP_BAR_BOTTOM_Z_INDEX,
  jl as AppBarBottom,
  si as AuthProvider,
  Eo as BANNER_VERTICAL_1_5_BASE_WIDTH,
  gn as BANNER_VERTICAL_1_BASE_WIDTH,
  Mo as BASE_WIDTH_1_5,
  Yl as BNB,
  Rn as BNB_HEIGHT,
  dn as BNB_Z_INDEX,
  es as Banner,
  ei as BannerDataProvider,
  la as CONTENTS_HORIZONTAL_FIXED_WIDTH,
  ca as CONTENTS_VERTICAL_1_5_BASE_WIDTH,
  On as Chip,
  pi as ClientGatewayRefineTemplateComponents,
  ui as ClientGatewayTemplateComponents,
  hi as ClientGatewayTemplateInfiniteComponents,
  gi as ClientGetScraps,
  fi as ClientRequestScraps,
  cs as Content,
  Xr as DisplayActionProvider,
  Dl as DisplayComponentProvider,
  Wa as Footer,
  Vl as Gallery,
  zl as GnbTemplate,
  Po as GridInfiniteScroller,
  Oo as GridList,
  Gs as HEADER_HEIGHT,
  za as Header,
  Kr as HorizontalPercentProvider,
  Fs as HorizontalScroll,
  un as HorizontalScroller,
  Os as IfSkeleton,
  Wl as InformedTemplate,
  Bi as InteriorBannerCard,
  Ai as InteriorBannerList,
  Pi as InteriorBannerUnlimitedResponsibility,
  Wt as LoadImage,
  Fn as MOBILE_APP_DOWNLOAD_COOKIE_NAME,
  ra as MOBILE_APP_DOWNLOAD_COOKIE_VALUE,
  pl as MainBannerSlideBox,
  Wi as MainMenuTitleBanner,
  Kn as MainMenuTitleBannerRolling,
  Hl as MainPopupContent,
  ia as MobileAppDownload,
  Ut as MoreButton,
  Ue as NO_SWIPE_AREA,
  Kl as NewDisplayService,
  ln as NewDisplaySlideList,
  cn as NewGridInfiniteScroller,
  ms as NewSlideBox,
  aa as PRODUCT_HORIZONTAL_FIXED_WIDTH,
  sa as PRODUCT_HORIZONTAL_GROUP_FIXED_WIDTH,
  Gl as PRODUCT_HORIZONTAL_SCROLLER_SPACE,
  hs as Product,
  di as ProductDataProvider,
  Ka as QuickLink,
  qr as QuickLinkDataProvider,
  da as RemodelingAutoBestGoodsList,
  pa as RemodelingAutoBestTagMaterialGoodsList,
  ha as RemodelingAutoGoodsList,
  fa as RemodelingAutoLineupGoodsList,
  ya as RemodelingAutoMaterialCateGoodsList,
  ma as RemodelingAutoMaterialGoodsList,
  wa as RemodelingAutoNewGoodsList,
  ba as RemodelingAutoNewTagMaterialGoodsList,
  va as RemodelingAutoPartMidcateGoodsList,
  Ia as RemodelingBannerBig,
  La as RemodelingBannerConsult,
  xa as RemodelingBannerEvent,
  Ca as RemodelingBannerGoodsList,
  Na as RemodelingBannerHomestyle,
  Sa as RemodelingBannerRolling,
  ka as RemodelingBannerRollingEvent,
  Da as RemodelingBannerRollingStart,
  $a as RemodelingBannerStoreInfoList,
  Ma as RemodelingBannerTrend,
  Ea as RemodelingBannerWhereStart,
  Oa as RemodelingGoodsWeekNewArrival,
  Ra as RemodelingImgLineDesc,
  ci as ScrapProvider,
  Fl as ScrollTopButton,
  yi as ServerGatewayTemplateComponents,
  mi as ServerGatewayTemplateInfiniteComponents,
  wi as ServerGetScraps,
  bi as ServerRequestScraps,
  yt as SlideBox,
  it as SlideList,
  Ao as Template,
  Dn as addCommas,
  Yn as bannerUnitHeight,
  To as componentGateway,
  Zr as convertNumberPx,
  Qr as createProxyRemovingUndefined,
  $n as displayGateway,
  It as displayServiceGateway,
  El as displayServiceServerGateway,
  $l as filterStyleProps,
  Jr as handleLogError,
  rt as removeUndefinedValues,
  Ml as scrapGateway,
  Pe as tagNameReverse,
  zt as unitMashup,
  ai as useAuth,
  rn as useBannerData,
  Ol as useClipboard,
  Ee as useComponent,
  Rl as useDataLayer,
  ut as useDisplayAction,
  te as useDisplayComponent,
  Bl as useDisplayService,
  Al as useDisplayServiceInfinite,
  Ws as useDrag,
  Mn as useEffectOnce,
  vi as useGnb,
  ft as useHorizontalPercent,
  an as useProductData,
  on as useQuickLinkData,
  At as useRemodelingGoodsDisplay,
  li as useScrap,
  Ci as useTemplate,
  _i as useTemplateInfo,
  js as useWheel,
  Oi as useWindowScrollDirection
};
